// German — source language for the My Within web app.
const de = {
  "lang.switch": "Sprache",

  // Nav / shell
  "nav.marketplace": "Marktplatz",
  "nav.coaches": "Coaches",
  "nav.login": "Anmelden",
  "nav.signup": "Kostenlos starten",
  "nav.dashboard": "Dashboard",
  "nav.circles": "Kreise",
  "nav.collab_packages": "Collab-Pakete",
  "cp.cta_book": "Session buchen",
  "cp.cta_signup": "Konto erstellen zum Buchen",
  "nav.credits": "Guthaben",
  "nav.membership": "Mitgliedschaft",
  "nav.account": "Konto",
  "nav.support": "Support",
  "nav.billing": "Abrechnung",
  "home.meta_title": "Coaching & innere Reflexion",
  "home.meta_desc": "Finde deinen Coach, buche Sessions und arbeite mit KI-gestützter Selbstreflexion an deinem inneren Wachstum.",
  "home.hero_eyebrow": "Dein Raum für inneres Wachstum",
  "home.hero_title": "Finde Ruhe, Klarheit und den richtigen Coach für deinen Weg.",
  "home.hero_sub": "My Within verbindet echte, verifizierte Coaches mit sanfter, KI-gestützter Selbstreflexion — in einer Umgebung, die sich unaufgeregt und sicher anfühlt.",
  "home.hero_cta_marketplace": "Angebote entdecken",
  "home.hero_cta_signup": "Kostenlos starten",
  "home.hero_free_hint": "100 % kostenlos registrieren · keine Kreditkarte nötig",
  "home.step1_title": "Finde deinen Coach",
  "home.step1_text": "Durchsuche verifizierte Coaches und Angebote — nach Thema, Region und Sprache.",
  "home.step2_title": "Arbeite gemeinsam",
  "home.step2_text": "Buche Sessions, tausche dich aus und wachse mit echter, menschlicher Begleitung.",
  "home.step3_title": "Reflektiere mit KI",
  "home.step3_text": "WEVA & EVA begleiten deine innere Arbeit zwischen den Sessions — jederzeit.",
  "home.offerings_title": "Ausgewählte Angebote",
  "home.offerings_sub": "Frisch aus dem Marktplatz unserer Coaches.",
  "home.see_all": "Alle ansehen",
  "home.coaches_title": "Lerne unsere Coaches kennen",
  "home.coaches_sub": "Verifiziert, erfahren und bereit, dich zu begleiten.",
  "home.all_coaches": "Alle Coaches",
  "home.cta_title": "Beginne heute mit deiner inneren Arbeit.",
  "home.cta_sub": "Erstelle in weniger als einer Minute ein Konto — kostenlos und ohne Risiko.",
  "home.cta_btn": "Jetzt kostenlos starten",
  "announce.coach_call": "Als Coach starten – kostenloses Erstgespräch buchen",
  "announce.free_signup": "Oder kostenlos registrieren – in unter einer Minute",
  "announce.founder": "Founder-Angebot – einmalig sichern",
  "foot.tagline": "Ein ruhiger Ort für innere Arbeit — begleitet von echten Coaches und KI-gestützter Reflexion.",
  "foot.discover": "Entdecken",
  "foot.create_account": "Konto erstellen",
  "foot.legal": "Rechtliches",
  "foot.privacy": "Datenschutz",
  "foot.terms": "AGB",
  "foot.built_in_austria": "Mit Sorgfalt gebaut in Österreich",
  "oc.recommended": "Empfohlen",
  "oc.minutes": "{n} Min",
  "oc.parts": "{n} Teile",
  "nav.account_fallback": "Konto",
  "nav.signout": "Abmelden",

  // Common
  "common.or": "ODER",
  "common.loading": "Lädt…",
  "common.active": "Aktiv",
  "common.save": "Speichern",
  "common.cancel": "Abbrechen",

  // Auth shared
  "auth.email": "E-Mail",
  "auth.password": "Passwort",
  "auth.email_placeholder": "du@beispiel.com",
  "auth.quote": "„Der Weg nach innen ist der einzige, der wirklich nach vorne führt.“",
  "auth.quote_attr": "My Within · dein ruhiger Raum",
  "auth.back_home": "← Zurück zur Startseite",
  "auth.google": "Weiter mit Google",
  "auth.apple": "Weiter mit Apple",
  "auth.apple_toast": "Apple-Anmeldung wird mit dem Web-Launch auf my-within.app aktiviert.",

  // Login
  "login.meta_title": "Anmelden",
  "login.meta_desc": "Melde dich bei deinem My Within Konto an.",
  "login.title": "Willkommen zurück",
  "login.subtitle": "Melde dich an, um deine innere Arbeit fortzusetzen.",
  "login.footer_q": "Noch kein Konto?",
  "login.footer_link": "Jetzt registrieren",
  "login.forgot": "Vergessen?",
  "login.submit": "Anmelden",
  "login.welcome_back": "Willkommen zurück!",
  "login.failed": "Anmeldung fehlgeschlagen.",

  // Signup
  "signup.meta_title": "Registrieren",
  "signup.meta_desc": "Erstelle dein kostenloses My Within Konto.",
  "signup.title": "Konto erstellen",
  "signup.subtitle": "Kostenlos starten — du entscheidest, wann und mit wem du arbeitest.",
  "signup.footer_q": "Bereits registriert?",
  "signup.footer_link": "Anmelden",
  "signup.role_client": "Ich suche Begleitung",
  "signup.role_coach": "Ich bin Coach",
  "signup.name": "Name",
  "signup.name_placeholder": "Dein Name",
  "signup.password_placeholder": "Mindestens 8 Zeichen",
  "signup.consent_pre": "Ich akzeptiere die",
  "signup.terms": "AGB",
  "signup.consent_mid": "und",
  "signup.privacy": "Datenschutzerklärung",
  "signup.consent_post": ", willige ausdrücklich in die Verarbeitung meiner Gesundheitsdaten ein und bestätige, dass ich mindestens 16 Jahre alt bin.",
  "signup.consent_required": "Bitte bestätige die Einwilligung, um fortzufahren.",
  "signup.submit": "Kostenlos registrieren",
  "signup.created": "Konto erstellt — willkommen bei My Within!",
  "signup.failed": "Registrierung fehlgeschlagen.",

  // Dashboard
  "dash.meta_title": "Dashboard",
  "dash.welcome": "Willkommen zurück",
  "dash.hello_fallback": "Schön, dass du da bist",
  "dash.balance": "Dein Guthaben",
  "dash.credits": "Credits",
  "dash.topup": "Aufladen",
  "dash.membership": "Mitgliedschaft",
  "dash.upgrade": "Upgrade",
  "dash.manage": "Verwalten",
  "dash.next": "Weiter geht's",
  "dash.action_credits_title": "Guthaben aufladen",
  "dash.action_credits_text": "Kaufe Credits für WEVA-Reports und Inhalte.",
  "dash.action_membership_title": "Mitgliedschaft",
  "dash.action_membership_text": "Schalte unbegrenzte KI-Reflexion frei.",
  "dash.action_marketplace_title": "Marktplatz",
  "dash.action_marketplace_text": "Entdecke Angebote und Kurse von Coaches.",
  "dash.action_coaches_title": "Coaches",
  "dash.action_coaches_text": "Finde die passende Begleitung für dich.",

  // Membership tiers
  "tier.free": "Kostenlos",
  "tier.plus": "Plus",
  "tier.plus_yearly": "Plus (jährlich)",
  "tier.pro": "Pro",
  "tier.pro_yearly": "Pro (jährlich)",
  "tier.unlimited": "Unlimited",
  "tier.unlimited_yearly": "Unlimited (jährlich)",
  "tier.coach_pro": "Coach Pro",
  "tier.coach_pro_yearly": "Coach Pro (jährlich)",

  // Credits
  "credits.meta_title": "Guthaben",
  "credits.title": "Guthaben aufladen",
  "credits.subtitle": "Mit Credits schaltest du WEVA-Reports und exklusive Inhalte frei.",
  "credits.suffix": "Credits",
  "credits.popular": "Beliebt",
  "credits.incl_vat": "inkl. USt.",
  "credits.per_credit": "/Credit",
  "credits.buy": "Kaufen",
  "credits.secure": "Sichere Zahlung über Stripe. Du wirst für den Checkout kurz zu Stripe weitergeleitet und danach hierher zurückgebracht.",
  "credits.payment_received": "Zahlung erhalten — dein Guthaben wird gutgeschrieben.",
  "credits.purchase_cancelled": "Kauf abgebrochen.",
  "credits.granted": "{n} Credits gutgeschrieben.",
  "credits.failed": "Kauf fehlgeschlagen.",

  // Account
  "account.meta_title": "Konto",
  "account.title": "Konto",
  "account.referral": "Dein Empfehlungscode",
  "account.billing": "Rechnungsdaten",
  "account.billing_complete": "Vollständig",
  "account.billing_incomplete": "Unvollständig",
  "account.devices": "Angemeldete Geräte",
  "account.session": "Sitzung {n}",
  "account.logged_in": "Angemeldet",
  "account.last_active": "Zuletzt aktiv",
  "account.no_sessions": "Keine aktiven Sitzungen.",
  "account.logout": "Abmelden",
  "account.logout_all": "Alle Sitzungen beenden",
  "account.logout_all_done": "Von allen Geräten abgemeldet.",

  // Common (extended)
  "common.saving": "Speichern…",
  "common.search": "Suchen…",
  "common.none_found": "Nichts gefunden.",

  // Coach · Angebote / Produkte / Bundles
  "off.meta_title": "Coach · Angebote",
  "off.back": "Coach-Dashboard",
  "off.eyebrow": "Angebote",
  "off.title": "Angebote & Produkte",
  "off.subtitle": "Sitzungen, Pakete, Bundles und Produkte verwalten.",
  "off.tab_offerings": "Angebote",
  "off.tab_products": "Produkte",
  "off.new": "Neues Angebot",
  "off.new_bundle": "Bundle",
  "off.hide_inactive": "Inaktive ausblenden",
  "off.empty_title": "Noch keine Angebote",
  "off.empty_sub": "Erstelle dein erstes Angebot — z. B. eine 1:1-Session.",
  "off.inactive": "Inaktiv",
  "off.active": "Aktiv",
  "off.standard": "Standard",
  "off.min": "Min.",
  "off.edit": "Bearbeiten",
  "off.delete": "Löschen",
  "off.delete_confirm": "Dieses Angebot wirklich deaktivieren?",
  "off.deleted": "Angebot deaktiviert.",
  "off.saved": "Angebot gespeichert.",
  "off.save_failed": "Angebot konnte nicht gespeichert werden.",
  "off.min_price": "Mindestpreis €14,99.",
  "off.dialog_new": "Neues Angebot",
  "off.dialog_edit": "Angebot bearbeiten",
  "off.f_type": "Art",
  "off.f_custom_label": "Eigene Bezeichnung",
  "off.f_custom_ph": "z. B. Breathwork-Intensiv",
  "off.f_title": "Titel",
  "off.f_title_ph": "z. B. 90-Min Deep Dive",
  "off.f_desc": "Beschreibung",
  "off.f_desc_ph": "Was Klient:innen bekommen…",
  "off.f_duration": "Dauer (Min.)",
  "off.f_price": "Preis (EUR)",
  "off.f_modality": "Format",
  "off.f_online": "Online (Zoom)",
  "off.f_inperson": "Vor Ort",
  "off.f_location": "Ort",
  "off.f_location_note": "Ort-Hinweis (optional)",
  "off.f_location_online_ph": "Zoom (automatischer Link)",
  "off.f_location_ph": "Wien, AT · Studio-Adresse",
  "off.online_hint": "Wir erstellen automatisch einen Zoom-Link, sobald dein Zoom-Konto verbunden ist.",
  "off.f_start": "Start (ISO)",
  "off.f_start_ph": "2026-09-14T10:00",
  "off.f_end": "Ende (Retreat, ISO)",
  "off.f_end_ph": "2026-09-17T18:00",
  "off.f_capacity": "Kapazität",
  "off.f_sessions": "Anzahl Sitzungen",
  "off.cover": "Titelbild (optional)",
  "off.cover_hint": "Ein warmes 16:9-Bild oben auf der Buchungsseite.",
  "off.cover_library": "Aus Bibliothek wählen",
  "off.cover_hide": "Bibliothek schließen",
  "off.cover_remove": "Entfernen",
  "off.toggle_standard": "Als Standard-Session markieren",
  "off.toggle_standard_hint": "Wird geöffnet, wenn Klient:innen auf „Session buchen“ tippen.",
  "off.toggle_weekly": "Im Wochenkalender buchbar",
  "off.toggle_weekly_hint": "Dieses Angebot erscheint, wenn Klient:innen einen Slot wählen.",
  "off.commission_hint": "Plattformgebühr: 10 % (Free) · 5 % (Coach Pro).",
  "off.bundle_title": "Bundle erstellen",
  "off.bundle_pick": "Angebote auswählen (mind. 2)",
  "off.bundle_discount": "Rabatt (%)",
  "off.bundle_total": "Einzelpreise gesamt",
  "off.bundle_effective": "Bundle-Preis",
  "off.bundle_savings": "Ersparnis",
  "off.bundle_none": "Keine kombinierbaren Angebote. Erstelle zuerst 2 reguläre Angebote.",
  "off.bundle_need2": "Bitte mindestens 2 Angebote auswählen.",
  "off.bundle_saved": "Bundle erstellt.",
  "off.p_new": "Neues Produkt",
  "off.p_empty_title": "Noch keine Produkte",
  "off.p_empty_sub": "Produkte sind einfache Sitzungen mit Credits- oder Stripe-Zahlung.",
  "off.p_dialog_new": "Neues Produkt",
  "off.p_dialog_edit": "Produkt bearbeiten",
  "off.p_name": "Name",
  "off.p_name_ph": "z. B. Kennenlern-Gespräch",
  "off.p_desc": "Beschreibung",
  "off.p_duration": "Dauer (Min.)",
  "off.p_capacity": "Kapazität",
  "off.p_group": "Gruppensitzung",
  "off.p_payment": "Zahlung",
  "off.p_accept_credits": "Credits akzeptieren",
  "off.p_price_credits": "Preis (Credits)",
  "off.p_accept_stripe": "Stripe akzeptieren",
  "off.p_price_eur": "Preis (EUR)",
  "off.p_saved": "Produkt gespeichert.",
  "off.p_deleted": "Produkt gelöscht.",
  "off.p_delete_confirm": "Dieses Produkt wirklich löschen?",
  "off.p_payment_required": "Bitte mind. eine Zahlungsart wählen.",
  "off.p_name_required": "Bitte einen Namen eingeben.",
  "off.type.one_on_one": "1:1-Session",
  "off.type.group_online": "Gruppenkurs (online)",
  "off.type.group_inperson": "Gruppenkurs (vor Ort)",
  "off.type.retreat": "Retreat",
  "off.type.workshop": "Workshop",
  "off.type.package": "Paket",
  "off.type.custom": "Individuell…",

  // Nav (extended)
  "nav.notifications": "Mitteilungen",
  "nav.inner": "Inner Circle",
  "nav.mein_kreis": "Mein Kreis",
  "nav.pulse": "Klient:innen-Puls",
  "nav.offerings": "Angebote",
  "nav.bookings": "Buchungen",
  "nav.earnings": "Einnahmen",
  "nav.availability": "Verfügbarkeit",
  "nav.analytics": "Analytics",
  "nav.collab": "Kollaboration",
  "nav.content": "Social",
  "nav.profile": "Profil & Marke",
  "nav.verify": "Verifizierung",
  "nav.admin": "Admin",
  "nav.group.start": "Start",
  "nav.group.circles": "Kreise",
  "nav.group.sell": "Verkaufen",
  "nav.group.grow": "Wachstum",
  "nav.group.account": "Konto",
  "nav.group.admin": "Admin",
  "nav.experience.journey": "Meine Reise",
  "nav.experience.practice": "Meine Praxis",
  "nav.group.home": "Start",
  "nav.group.explore": "Entdecken",
  "nav.group.breathe": "Atmen",
  "nav.group.weva": "WEVA",
  "nav.group.connect": "Verbinden",
  "nav.group.my_space": "Mein Bereich",
  "nav.group.overview": "Übersicht",
  "nav.group.clients": "Klient:innen",
  "nav.group.schedule": "Termine & Pläne",
  "nav.group.create": "Erstellen & Anbieten",
  "nav.group.community": "Community",
  "nav.group.business": "Business",
  "nav.group.settings": "Einstellungen",
  "nav.practices": "Übungen",
  "nav.collectives": "Kollektive",
  "nav.referral": "Empfehlungen",
  "nav.client_wins": "Klient-Erfolge",
  "home.welcome_back": "Willkommen zurück.",
  "home.welcome_q": "Was würde dir heute guttun?",
  "home.action_breathe_title": "Atmen",
  "home.action_breathe_sub": "Finde Ruhe im Moment",
  "home.action_reflect_title": "Reflektieren",
  "home.action_reflect_sub": "Erkunde deine Gedanken & Gefühle",
  "home.action_weva_title": "Mit WEVA erkunden",
  "home.action_weva_sub": "Sprich es mit deiner Begleiterin durch",
  "home.continue_title": "Setze deine Reise fort",
  "home.continue_empty": "Deine nächsten Schritte erscheinen hier, sobald du loslegst.",
  "home.plan_pending": "Wochenplan wartet",
  "home.plan_cta": "Plan ansehen",
  "home.report_latest": "Neuester WEVA-Bericht",
  "home.reflections_title": "Deine Reflexionen",
  "home.stat_journal": "Journal-Einträge",
  "home.stat_reports": "WEVA-Berichte",
  "home.stat_practices": "Übungen gemacht",
  "home.stat_areas": "Bereiche erkundet",
  "home.more_title": "Mehr entdecken",
  "home.open": "Öffnen",

  // Coach · Profil & Marke
  "prof.meta_title": "Coach · Profil",
  "prof.back": "Coach-Dashboard",
  "prof.eyebrow": "Profil",
  "prof.title": "Profil & Marke",
  "prof.subtitle": "Dein öffentliches Coach-Profil und deine Marke.",
  "prof.tab_profile": "Profil",
  "prof.tab_branding": "Marke",
  "prof.photo": "Profilbild",
  "prof.photo_hint": "Profil- und Titelbild (max. 2,5 MB). Quadratisch für das Profilbild empfohlen.",
  "prof.header": "Titelbild",
  "prof.upload": "Hochladen",
  "prof.remove": "Entfernen",
  "prof.too_large": "Bild zu groß (max. 2,5 MB).",
  "prof.name": "Name",
  "prof.bio": "Über dich",
  "prof.bio_ph": "Erzähle Klient:innen, wie du arbeitest…",
  "prof.professions": "Beruf(e)",
  "prof.professions_hint": "Wähle bis zu 5 aus der Liste.",
  "prof.professions_ph": "Beruf hinzufügen…",
  "prof.topics": "Themen",
  "prof.topics_hint": "Wähle passende Themen aus.",
  "prof.topics_ph": "Thema hinzufügen…",
  "prof.methods": "Methoden",
  "prof.methods_hint": "Wähle deine Methoden/Modalitäten aus.",
  "prof.methods_ph": "Methode hinzufügen…",
  "prof.location": "Ort",
  "prof.location_ph": "Wien, Österreich",
  "prof.website": "Website",
  "prof.website_ph": "https://…",
  "prof.languages": "Sprachen",
  "prof.languages_hint": "Komma-getrennt, z. B. Deutsch, Englisch.",
  "prof.experience": "Jahre Erfahrung",
  "prof.audience": "Zielgruppe",
  "prof.audience_ph": "Für wen bist du da?",
  "prof.visibility_public": "Öffentlich sichtbar",
  "prof.visibility_hint": "Dein Profil erscheint im Marktplatz und Coach-Verzeichnis.",
  "prof.saved": "Profil gespeichert.",
  "prof.save_failed": "Profil konnte nicht gespeichert werden.",
  "prof.view_public": "Öffentliches Profil ansehen",

  // Coach · Marke (Branding)
  "brand.subtitle": "Logo, Markenfarbe und Footer für kundenseitige E-Mails & dein Profil.",
  "brand.locked_title": "Marke ist ein Coach-Pro-Feature",
  "brand.locked_sub": "Upgrade auf Coach Pro, um Logo, Farbe und Footer zu setzen.",
  "brand.upgrade": "Auf Coach Pro upgraden",
  "brand.logo": "Logo-URL",
  "brand.logo_ph": "https://… (PNG/SVG)",
  "brand.color": "Markenfarbe",
  "brand.footer": "Footer-Text",
  "brand.footer_ph": "z. B. „Mit Herz begleitet von …“ (max. 200 Zeichen)",
  "brand.saved": "Marke gespeichert.",
  "brand.reset": "Zurücksetzen",
  "brand.reset_done": "Auf Standard zurückgesetzt.",

  // Coach · Verifizierung
  "verify.meta_title": "Coach · Verifizierung",
  "verify.eyebrow": "Verifizierung",
  "verify.title": "Qualifikation verifizieren",
  "verify.subtitle": "Lade dein Zertifikat hoch, um alle Coach-Funktionen freizuschalten.",
  "verify.status": "Aktueller Status",
  "verify.status_approved": "Verifiziert",
  "verify.status_pending_ai": "KI-Prüfung läuft",
  "verify.status_pending_admin": "In Prüfung",
  "verify.status_rejected": "Abgelehnt",
  "verify.status_unverified": "Nicht verifiziert",
  "verify.approved_title": "Du bist verifiziert 🎉",
  "verify.approved_sub": "Alle Coach-Funktionen sind freigeschaltet — Kreise, Angebote, Buchungen.",
  "verify.reviewer_title": "Reviewer-Zugang aktiv",
  "verify.reviewer_sub": "Dieses Konto umgeht die Verifizierung für Prüfungen.",
  "verify.step_dpa_title": "Joint-Controller-Vereinbarung akzeptieren",
  "verify.step_dpa_sub": "Datenschutz-Vereinbarung für gemeinsam verantwortliche Stellen.",
  "verify.dpa_accept": "Ich akzeptiere die Joint-Controller-Vereinbarung.",
  "verify.dpa_accepted": "Vereinbarung akzeptiert.",
  "verify.accept_btn": "Akzeptieren",
  "verify.step_upload_title": "Zertifikat hochladen",
  "verify.step_upload_sub": "Foto/Scan deines Zertifikats (PNG/JPEG, max. 4 MB).",
  "verify.upload_btn": "Zertifikat hochladen",
  "verify.reupload_btn": "Erneut hochladen",
  "verify.uploading": "Wird hochgeladen…",
  "verify.upload_failed": "Upload fehlgeschlagen.",
  "verify.too_large": "Bild zu groß (max. 4 MB).",
  "verify.pending_admin_title": "An die Prüfung weitergeleitet",
  "verify.pending_admin_sub": "Ein Mensch prüft dein Zertifikat. Du wirst benachrichtigt, sobald es freigegeben ist.",
  "verify.rejected_title": "Verifizierung abgelehnt",
  "verify.rejected_sub": "Bitte lade ein klareres Zertifikat hoch.",
  "verify.ai_verdict": "KI-Einschätzung",
  "verify.ai_subject": "Fachbereich",
  "verify.ai_confidence": "Zuversicht",

  // Mitteilungen
  "notif.meta_title": "Mitteilungen",
  "notif.title": "Mitteilungen",
  "notif.subtitle": "Updates zu Buchungen, Kreisen und deinem Konto.",
  "notif.empty_title": "Keine Mitteilungen",
  "notif.empty_sub": "Hier erscheinen neue Updates.",
  "notif.mark_all": "Alle als gelesen",
  "notif.marked_all": "Alle als gelesen markiert.",

  // Common (Phase 4c)
  "common.refresh": "Aktualisieren",

  // Coach · Social & Inhalte (Phase 4c)
  "soc.meta_title": "Coach · Social",
  "soc.back": "Coach-Dashboard",
  "soc.eyebrow": "Social",
  "soc.title": "Social & Inhalte",
  "soc.subtitle": "Beiträge, Stories, Story-Wall, Nachrichten und WEVA — alles an einem Ort.",
  "soc.tab_posts": "Beiträge",
  "soc.tab_stories": "Stories",
  "soc.tab_wall": "Story-Wall",
  "soc.tab_impact": "Impact",
  "soc.tab_messages": "Nachrichten",
  "soc.tab_weva": "WEVA",

  "soc.posts_new": "Neuer Beitrag",
  "soc.posts_stat_posts": "Beiträge",
  "soc.posts_stat_unlocks": "Freischaltungen",
  "soc.posts_stat_credits": "Credits verdient",
  "soc.posts_stat_reports": "Meldungen",
  "soc.posts_empty_title": "Noch keine Beiträge",
  "soc.posts_empty_sub": "Erstelle deinen ersten Beitrag für den Feed.",
  "soc.posts_unlocks": "{n} Freischaltungen",
  "soc.posts_credits": "{n} Credits",
  "soc.posts_hidden": "Verborgen",
  "soc.posts_dialog_title": "Neuer Beitrag",
  "soc.posts_f_title": "Titel",
  "soc.posts_f_title_ph": "Titel des Beitrags",
  "soc.posts_f_body": "Text",
  "soc.posts_f_body_ph": "Teile einen Impuls, eine Reflexion oder eine Übung…",
  "soc.posts_paid": "Bezahlter Inhalt",
  "soc.posts_paid_sub": "Klient:innen zahlen Credits zum Freischalten.",
  "soc.posts_price": "Preis (Credits)",
  "soc.posts_price_ph": "z. B. 10",
  "soc.posts_publish": "Veröffentlichen",
  "soc.posts_publishing": "Veröffentlichen…",
  "soc.posts_created": "Beitrag veröffentlicht.",
  "soc.posts_title_required": "Bitte einen Titel eingeben.",
  "soc.posts_price_required": "Bezahlte Inhalte brauchen mind. 1 Credit.",
  "soc.posts_create_failed": "Beitrag konnte nicht erstellt werden.",

  "soc.stories_new": "Neue Story",
  "soc.stories_sub": "24-Stunden-Stories und dauerhafte Highlights.",
  "soc.stories_empty_title": "Noch keine Stories",
  "soc.stories_empty_sub": "Teile eine kurze 24-Stunden-Story mit deinen Klient:innen.",
  "soc.stories_kind_image": "Bild",
  "soc.stories_kind_text": "Text",
  "soc.stories_pick": "Bild wählen",
  "soc.stories_replace": "Bild ersetzen",
  "soc.stories_pick_hint": "Wähle ein Bild (max. 10 MB).",
  "soc.stories_text_ph": "Was möchtest du teilen?",
  "soc.stories_ttl_hint": "Stories verschwinden nach 24 Stunden automatisch.",
  "soc.stories_dialog_title": "Neue Story",
  "soc.stories_publish": "Teilen",
  "soc.stories_publishing": "Teilen…",
  "soc.stories_created": "Story geteilt.",
  "soc.stories_too_large": "Bild zu groß (max. 10 MB).",
  "soc.stories_uploading": "Wird hochgeladen…",
  "soc.stories_upload_failed": "Bild konnte nicht hochgeladen werden.",
  "soc.stories_need_content": "Bitte Bild wählen oder Text eingeben.",
  "soc.stories_create_failed": "Story konnte nicht erstellt werden.",
  "soc.stories_status_active": "Aktiv",
  "soc.stories_status_expired": "Abgelaufen",
  "soc.stories_highlight_badge": "Highlight",
  "soc.stories_views": "{n} Aufrufe",
  "soc.stories_pin": "Anheften",
  "soc.stories_unpin": "Lösen",
  "soc.stories_delete_confirm": "Diese Story wirklich löschen?",
  "soc.stories_deleted": "Story gelöscht.",
  "soc.stories_pinned": "Als Highlight angeheftet.",
  "soc.stories_unpinned": "Highlight gelöst.",
  "soc.stories_pin_title": "Als Highlight anheften",
  "soc.stories_pin_sub": "Gib dem Highlight einen kurzen Titel (optional).",
  "soc.stories_pin_ph": "z. B. Kundenstimmen",
  "soc.stories_pin_save": "Anheften",

  "soc.wall_new": "Neuer Moment",
  "soc.wall_sub": "Klient:innen-Momente mit doppelter Einwilligung öffentlich teilen.",
  "soc.wall_empty_title": "Noch keine Momente",
  "soc.wall_empty_sub": "Halte einen besonderen Fortschritt fest — mit Einwilligung der Klient:in.",
  "soc.wall_create_title": "Moment erstellen",
  "soc.wall_client": "Klient:in",
  "soc.wall_kind": "Art",
  "soc.wall_title_lbl": "Titel",
  "soc.wall_title_ph": "Kurzer, kraftvoller Titel",
  "soc.wall_body_lbl": "Text",
  "soc.wall_body_ph": "Was ist passiert? Beschreibe den Moment…",
  "soc.wall_metric_lbl": "Kennzahl (optional)",
  "soc.wall_metric_ph": "z. B. −40 % Stress",
  "soc.wall_color_lbl": "Farbe",
  "soc.wall_consent_note": "Veröffentlichung erfordert deine UND die Einwilligung der Klient:in.",
  "soc.wall_missing_fields": "Bitte Klient:in, Titel und Text ausfüllen.",
  "soc.wall_save": "Moment speichern",
  "soc.wall_saved": "Moment erstellt.",
  "soc.wall_kind_reflection": "Reflexion",
  "soc.wall_kind_wellbeing_shift": "Wohlbefinden",
  "soc.wall_kind_streak": "Serie",
  "soc.wall_kind_quote": "Zitat",
  "soc.wall_kind_milestone": "Meilenstein",
  "soc.wall_status_draft": "Entwurf",
  "soc.wall_status_published": "Veröffentlicht",
  "soc.wall_status_unlisted": "Nicht gelistet",
  "soc.wall_coach_consent": "Deine Einwilligung",
  "soc.wall_client_consent": "Einwilligung Klient:in",
  "soc.wall_consent_granted": "Erteilt",
  "soc.wall_consent_pending": "Ausstehend",
  "soc.wall_consent_waiting_client": "Wartet auf Klient:in",
  "soc.wall_review_agree": "Prüfen & zustimmen",
  "soc.wall_review": "Einwilligung ansehen",
  "soc.wall_coach_consent_title": "Deine Einwilligung",
  "soc.wall_coach_consent_body": "Mit deiner Zustimmung darf dieser Moment öffentlich geteilt werden, sobald auch die Klient:in zustimmt.",
  "soc.wall_show_name": "Meinen Namen zeigen",
  "soc.wall_show_name_sub": "Dein Name erscheint auf dem veröffentlichten Moment.",
  "soc.wall_consent_grant": "Zustimmen",
  "soc.wall_consent_revoke": "Zurückziehen",
  "soc.wall_publish": "Veröffentlichen",
  "soc.wall_unpublish": "Zurückziehen",
  "soc.wall_archive": "Archivieren",
  "soc.wall_archive_confirm": "Diesen Moment wirklich archivieren?",
  "soc.wall_published_ok": "Moment veröffentlicht.",
  "soc.wall_publish_needs_consents": "Beide Einwilligungen werden zur Veröffentlichung benötigt.",

  "soc.impact_sub": "Wie viele Menschen deine Wins bewegen.",
  "soc.impact_empty_title": "Noch keine Story-Momente",
  "soc.impact_empty_sub": "Sobald du Client-Wins veröffentlichst, siehst du hier Views, Shares und Trends.",
  "soc.impact_overall": "Gesamt-Übersicht",
  "soc.impact_views": "Views",
  "soc.impact_shares": "Shares",
  "soc.impact_previews": "Preview-Öffnungen",
  "soc.impact_engagement": "Engagement",
  "soc.impact_engagement_hint": "Views ÷ Preview-Öffnungen",
  "soc.impact_share_rate": "Share-Quote",
  "soc.impact_share_hint": "Shares ÷ Views",
  "soc.impact_trend": "Trend der letzten 7 Tage",
  "soc.impact_views_7d": "Views die letzten 7 Tage",
  "soc.impact_vs_prev": "vs. vorher",
  "soc.impact_ranking": "Wirkungs-Ranking pro Moment",

  "soc.msg_sub": "Direktnachrichten und geteilte Chats.",
  "soc.msg_shared": "Geteilte Chats",
  "soc.msg_dms": "Direktnachrichten",
  "soc.msg_empty": "Noch keine Nachrichten. Klient:innen und Coaches erscheinen hier.",
  "soc.msg_three_way": "Gemeinsame Betreuung",
  "soc.msg_input_ph": "Nachricht schreiben…",
  "soc.msg_empty_thread": "Noch keine Nachrichten. Schreib die erste 👋",
  "soc.msg_deleted": "Nachricht gelöscht",
  "soc.msg_delete_confirm": "Diese Nachricht löschen?",

  "soc.weva_sub": "Anonymisierte Muster deines Inner Circle — mit Coaching-Impulsen.",
  "soc.weva_trends_title": "Anonymisierte Kreis-Trends",
  "soc.weva_trends_clients": "{a} von {t} aktiv · {d} Tage",
  "soc.weva_trends_emotions": "Top-Emotionen",
  "soc.weva_trends_themes": "Top-Themen",
  "soc.weva_trends_beliefs": "Top-Glaubenssätze",
  "soc.weva_trends_practices": "Top-Praktiken",
  "soc.weva_intro": "Frag mich nach Mustern in deinem Inner Circle — Emotionen, Themen, Praktiken — und ich gebe dir Coaching-Impulse.",
  "soc.weva_placeholder": "Frag WEVA etwas…",
  "soc.weva_thinking": "WEVA denkt nach…",
  "soc.weva_clear": "Verlauf löschen",
  "soc.weva_clear_confirm": "Gesamten WEVA-Verlauf löschen?",
  "soc.weva_locked_title": "WEVA-Coach-Chat ist ein Coach-Pro-Feature",
  "soc.weva_locked_sub": "Upgrade auf Coach Pro, um WEVA für anonymisierte Kreis-Einblicke zu nutzen.",
  "soc.weva_upgrade": "Auf Coach Pro upgraden",
  "soc.weva_send_failed": "Nachricht konnte nicht gesendet werden.",

  // Common (Phase 4d)
  "common.close": "Schließen",
  "nav.methods": "Methoden",
  "nav.plans": "Pläne",

  // Coach · Methoden & Vorlagen (Phase 4d)
  "cm.meta_title": "Coach · Methoden",
  "cm.back": "Coach-Dashboard",
  "cm.eyebrow": "Methoden",
  "cm.title": "Methoden & Vorlagen",
  "cm.subtitle": "Eigene Übungen bauen, verwalten, als Vorlage sichern und ihre Wirkung sehen.",
  "cm.tab_methods": "Methoden",
  "cm.tab_templates": "Vorlagen",
  "cm.tab_breathwork": "Breathwork",
  "cm.tab_stats": "Statistiken",
  "cm.tab_social": "Im Feed geteilt",
  "cm.social_title": "Methoden im Social Feed",
  "cm.social_sub": "Geteilte Methoden (kostenlos oder bezahlt) erscheinen als Beiträge in deinem Feed — inklusive Aufrufe und Käufe.",
  "cm.social_cta": "Zu meinen Feed-Beiträgen",

  "cm.new_method": "Neue Methode",
  "cm.filter_all": "Alle",
  "cm.filter_shared": "Geteilt",
  "cm.filter_template": "Vorlagen",
  "cm.no_methods_title": "Noch keine Methode",
  "cm.no_methods_sub": "Fang mit einer Audio-Meditation oder einem Fragen-Set an.",
  "cm.no_templates": "Noch keine Vorlage",
  "cm.create_first": "Erste Methode erstellen",
  "cm.edit": "Bearbeiten",
  "cm.tpl": "Vorlage",
  "cm.duplicated": "Methode dupliziert.",
  "cm.deleted": "Methode gelöscht.",
  "cm.delete_confirm": "Methode „{title}“ wirklich löschen?",

  "cm.kind_audio": "Audio-Meditation",
  "cm.kind_audio_sub": "Geführte Sprach-/Musik-Session.",
  "cm.kind_video": "Video-Anleitung",
  "cm.kind_video_sub": "Kurzes Video mit dir als Coach.",
  "cm.kind_breathwork": "Breathwork",
  "cm.kind_breathwork_sub": "Verweis auf eigene Atemtechnik.",
  "cm.kind_questions": "Fragen-Set",
  "cm.kind_questions_sub": "Reflexions-Fragen, freies Antworten.",
  "cm.kind_combo": "Kombi-Methode",
  "cm.kind_combo_sub": "Mehrere Bausteine hintereinander.",
  "cm.kind_body_scan": "Körper-Scan",
  "cm.kind_body_scan_sub": "Aufmerksamkeit durch den Körper führen.",
  "cm.kind_gratitude": "Dankbarkeit",
  "cm.kind_gratitude_sub": "3 Dinge · Herzens-Fokus.",
  "cm.kind_visualization": "Visualisierung",
  "cm.kind_visualization_sub": "Innere Bilder & Zukunftsreise.",
  "cm.kind_movement": "Bewegung",
  "cm.kind_movement_sub": "Yoga · Somatic · Shaking.",
  "cm.kind_check_in": "Check-In",
  "cm.kind_check_in_sub": "Tages-Puls · Emotion & Bedürfnis.",

  "cm.vis_private": "Privat",
  "cm.vis_shared_with_clients": "Klient:innen",
  "cm.vis_public": "Öffentlich",

  "cm.pick_title": "Methode erstellen",
  "cm.pick_hint": "Wähle den Typ deiner neuen Methode.",
  "cm.editing": "Methode bearbeiten",
  "cm.change_kind": "Typ ändern",
  "cm.save_new": "Methode speichern",
  "cm.saved": "Methode gespeichert.",
  "cm.save_failed": "Methode konnte nicht gespeichert werden.",
  "cm.load_failed": "Methode konnte nicht geladen werden.",
  "cm.title_required": "Bitte einen Titel eingeben.",
  "cm.cover": "Cover-Bild (optional)",
  "cm.f_title": "Titel",
  "cm.title_ph": "Kurz & klar (max. 140 Zeichen)",
  "cm.f_subtitle": "Untertitel (optional)",
  "cm.subtitle_ph": "z. B. „Ankommen & loslassen“",
  "cm.description": "Beschreibung",
  "cm.description_ph": "Wofür ist diese Methode gedacht?",
  "cm.suggest_titles": "KI-Vorschläge",
  "cm.ai_no_titles": "Keine Vorschläge gefunden. Formuliere die Beschreibung etwas ausführlicher.",
  "cm.ai_locked": "KI-Titelvorschläge sind ein Coach-Pro-Feature.",
  "cm.audio_field": "Audio",
  "cm.video_field": "Video",
  "cm.pick_technique": "Eigene Breathwork-Technik",
  "cm.no_bw_yet": "Lege zuerst eine eigene Breathwork-Übung in der Mobile-App an.",
  "cm.questions": "Fragen",
  "cm.no_questions": "Noch keine Fragen. Füge die erste hinzu.",
  "cm.q_required": "Pflicht",
  "cm.q_prompt_ph": "Frage, z. B. „Wie fühlst du dich gerade?“",
  "cm.q_add": "Frage hinzufügen",
  "cm.steps": "Bausteine (Reihenfolge)",
  "cm.steps_empty": "Noch kein Baustein. Füge z. B. Körper-Scan + Atem + Dankbarkeit hinzu.",
  "cm.step_title_ph": "Baustein-Titel, z. B. „3 Minuten Körper-Scan“",
  "cm.step_body_ph": "Anleitungstext…",
  "cm.step_duration_ph": "Dauer (Sekunden)",
  "cm.step_breathwork": "Atem",
  "cm.step_audio": "Audio",
  "cm.step_video": "Video",
  "cm.step_body_scan": "Körper",
  "cm.step_gratitude": "Dank",
  "cm.step_visualization": "Vision",
  "cm.step_movement": "Bewegung",
  "cm.step_questions": "Fragen",
  "cm.step_check_in": "Check-In",
  "cm.step_timer": "Timer",
  "cm.step_text": "Text",
  "cm.settings": "Einstellungen",
  "cm.duration_min": "Dauer (Min.)",
  "cm.preview_seconds": "Vorschau (Sek.)",
  "cm.visibility": "Sichtbarkeit",
  "cm.price": "Preis (Credits)",
  "cm.is_template": "Als Vorlage",
  "cm.tpl_on": "Vorlage aktiv",
  "cm.tpl_off": "Als Vorlage speichern",
  "cm.ethics_title": "Coaching, kein Therapieersatz",
  "cm.ethics_body": "Formuliere deine Methode als Coaching-Angebot. Sie ersetzt keine ärztliche Diagnose oder Psychotherapie. Bei Trauma, Suizidgedanken oder akuten Beschwerden verweise an eine Fachperson.",

  "cm.media_url_ph": "URL einfügen oder Datei hochladen",
  "cm.media_upload": "Hochladen",
  "cm.media_uploading": "Lädt…",
  "cm.media_uploaded": "Datei hochgeladen.",
  "cm.media_upload_failed": "Datei konnte nicht hochgeladen werden.",

  "cm.preview_lbl": "Vorschau",
  "cm.preview_running": "Klient:innen hören/sehen genau diesen Ausschnitt vor dem Kauf.",
  "cm.preview_done": "Vorschau beendet.",

  "cm.stats_methods": "Methoden",
  "cm.stats_opens": "Aufrufe",
  "cm.stats_completions": "Abschlüsse",
  "cm.stats_rate": "Rate",
  "cm.stats_top_completed": "Renner",
  "cm.stats_top_opened": "Meist geöffnet",
  "cm.stats_empty": "Noch keine Daten. Sobald Klient:innen deine Methoden nutzen, siehst du hier deine Renner.",

  "cm.templates_sub": "Signature-Techniken, die du bei neuen Klient:innen wiederverwenden kannst. Kopiere eine, um sie anzupassen.",
  "cm.no_templates_long": "Noch keine Vorlage. Öffne eine Methode und aktiviere beim Speichern den Vorlagen-Schalter.",
  "cm.tpl_use": "Verwenden",
  "cm.tpl_copied": "Vorlage kopiert — bearbeite jetzt die Kopie.",
  "cm.tpl_done": "{n}× abgeschlossen",

  // Coach · Pläne (Phase 4d Teil 2)
  "pl.meta_title": "Coach · Pläne",
  "pl.back": "Coach-Dashboard",
  "pl.eyebrow": "Pläne",
  "pl.title": "Pläne",
  "pl.subtitle": "Tagespläne an Klient:innen zuweisen und Wochen-Breathwork-Pläne teilen.",
  "pl.tab_daily": "Tagespläne",
  "pl.tab_weekly": "Wochenpläne",

  "pl.d_sub": "Weise Klient:innen Aufgaben mit Datum, Uhrzeit und Technik zu.",
  "pl.d_new": "Plan zuweisen",
  "pl.d_empty_title": "Noch keine Pläne zugewiesen",
  "pl.d_empty_sub": "Weise deiner ersten Klient:in eine Aufgabe zu.",
  "pl.d_done": "Erledigt",
  "pl.d_pending": "Offen",
  "pl.d_missing": "Bitte Titel und mindestens eine Klient:in wählen.",
  "pl.d_assigned": "Plan an {n} Klient:in(nen) zugewiesen.",
  "pl.d_title_ph": "Titel, z. B. Abend-Atemübung",
  "pl.d_desc_ph": "Beschreibung (optional)",
  "pl.d_date": "Datum",
  "pl.d_time": "Uhrzeit",
  "pl.d_reminder": "Reminder (Min.)",
  "pl.d_technique": "Atemtechnik (optional)",
  "pl.d_clients": "Klient:innen",
  "pl.d_no_clients": "Keine passenden Klient:innen. Füge zuerst jemanden zu einem Kreis hinzu.",

  "pl.w_mobile_note": "Wochenpläne erstellst und bearbeitest du in der Mobile-App. Hier siehst du deine Pläne und teilst sie mit Klient:innen oder Kreisen.",
  "pl.w_my_master": "Meine Master-Pläne",
  "pl.w_no_plans": "Noch keine Wochenpläne. Erstelle deinen ersten direkt hier.",
  "pl.w_slots": "{n} Bausteine",
  "pl.w_flexible": "flexibel",
  "pl.w_send": "Senden",
  "pl.w_sent": "An Klient:innen gesendet",
  "pl.w_sent_hint": "Geteilte Pläne erscheinen hier mit ihrem Status.",
  "pl.w_to_client": "An Klient:in",
  "pl.w_share_target": "Plan teilen",
  "pl.w_tab_single": "Einzeln",
  "pl.w_tab_multi": "Mehrere",
  "pl.w_tab_circle": "Kreis",
  "pl.w_no_clients": "Keine Klient:innen.",
  "pl.w_no_circles": "Keine Kreise.",
  "pl.w_select_all": "Alle",
  "pl.w_deselect_all": "Keine",
  "pl.w_circle_members": "{n} Mitglieder",
  "pl.w_overwrite": "Bestehende Pläne überschreiben",
  "pl.w_msg_ph": "Optionale Nachricht…",
  "pl.w_send_plan": "Plan senden",
  "pl.w_sending": "Senden…",
  "pl.w_sent_ok": "Plan gesendet.",
  "pl.w_multi_summary": "Gesendet: {ok} · Fehlgeschlagen: {fail}",
  "pl.w_circle_summary": "Gesendet: {sent} · Übersprungen: {skipped} · Aktualisiert: {updated}",
  "pl.w_web_note": "Erstelle und bearbeite Wochenpläne direkt hier. Gesendete Kopien bei Klient:innen bleiben unverändert.",
  "pl.w_new": "Neuer Wochenplan",
  "pl.w_create_plan": "Plan erstellen",
  "pl.w_editor_new": "Wochenplan erstellen",
  "pl.w_editor_edit": "Wochenplan bearbeiten",
  "pl.w_editor_sub": "Benenne den Plan, wähle den Wochenstart und füge Bausteine pro Tag hinzu.",
  "pl.w_default_name": "Meine Wochenpraxis",
  "pl.w_name": "Name",
  "pl.w_name_ph": "z. B. Meine Wochenpraxis",
  "pl.w_desc": "Beschreibung",
  "pl.w_desc_ph": "Optional",
  "pl.w_week_start": "Wochenstart (Mo)",
  "pl.w_slots_lbl": "Bausteine",
  "pl.w_add_slot": "Baustein",
  "pl.w_no_slots": "Noch kein Baustein. Füge Übungen für die Woche hinzu.",
  "pl.w_slot_day": "Tag",
  "pl.w_slot_time": "Uhrzeit",
  "pl.w_slot_duration": "Dauer (Min.)",
  "pl.w_slot_category": "Kategorie",
  "pl.w_slot_technique": "Übung",
  "pl.w_slot_reminder": "Erinnerung",
  "pl.w_slot_note": "Notiz (optional)",
  "pl.w_slot_save": "Baustein speichern",
  "pl.w_cat_breathing": "Atem",
  "pl.w_cat_deep_within": "Deep Within",
  "pl.w_cat_rdr": "RDR",
  "pl.w_cat_custom": "Meine Breathwork",
  "pl.w_cat_coach_method": "Meine Methoden",
  "pl.w_days": "Mo,Di,Mi,Do,Fr,Sa,So",
  "pl.w_rem_start": "Zum Start",
  "pl.w_rem_min": "{n} Min vorher",
  "pl.w_rem_hour": "1 Std vorher",
  "pl.w_need_name": "Bitte einen Namen eingeben.",
  "pl.w_need_slots": "Füge mindestens einen Baustein hinzu.",
  "pl.w_need_tech": "Bitte eine Übung wählen.",
  "pl.w_created": "Wochenplan erstellt.",
  "pl.w_updated": "Wochenplan aktualisiert.",
  "pl.w_save_failed": "Wochenplan konnte nicht gespeichert werden.",
  "pl.w_delete_confirm": "Wochenplan „{name}“ löschen?",
  "pl.w_deleted": "Wochenplan gelöscht.",
  "pl.w_no_custom": "Noch keine eigene Breathwork-Übung. Lege eine im Methoden-Tab an.",
  "pl.w_no_methods": "Noch keine Methoden.",

  // Coach · Breathwork-Techniken (Verbesserung)
  "bw.new": "Neue Übung",
  "bw.edit_existing": "Übung bearbeiten",
  "bw.name": "Name der Übung",
  "bw.name_ph": "z. B. Box-Breath 4-4-4-4",
  "bw.rhythm": "Rhythmus (Sekunden)",
  "bw.inhale": "Ein",
  "bw.hold_in": "Halten",
  "bw.exhale": "Aus",
  "bw.hold_out": "Halten",
  "bw.length": "Länge",
  "bw.by_reps": "Wiederholungen",
  "bw.by_duration": "Gesamtdauer",
  "bw.reps": "Runden",
  "bw.duration_s": "Sekunden",
  "bw.estimated": "Geschätzt",
  "bw.cycle": "Zyklus",
  "bw.notes": "Notiz für Klient:in (optional)",
  "bw.notes_ph": "z. B. Abends vor dem Schlafen",
  "bw.save_new": "Übung speichern",
  "bw.saved": "Übung gespeichert.",
  "bw.save_failed": "Übung konnte nicht gespeichert werden.",
  "bw.delete_confirm": "Übung „{name}“ löschen?",
  "bw.deleted": "Übung gelöscht.",
  "bw.saved_list": "Deine Übungen",
  "bw.empty": "Noch keine eigene Übung gespeichert.",

  // Nav (Phase 4e)
  "nav.ads": "Werbung",
  "nav.recommendations": "Empfehlungen",

  // ── Analytics-Deepdive (Phase 4e · e1) ──
  "an.back": "Coach-Dashboard",
  "an.eyebrow": "Analytics",
  "an.title": "Analytics-Deepdive",
  "an.subtitle": "12 Kacheln: Wachstum, Sessions, WEVA, Content, Umsatz, Vergleiche & Reports.",
  "an.period_week": "Woche",
  "an.period_month": "Monat",
  "an.period_quarter": "Quartal",
  "an.period_year": "Jahr",
  "an.period_all": "Gesamt",
  "an.period_sync": "Der Zeitraum gilt für alle Kacheln mit Zeitbezug.",
  "an.pro_locked_title": "Coach Pro schaltet die volle Tiefe frei",
  "an.pro_locked_sub": "Umsatz-, Retention-Analysen und Reports sind Teil von Coach Pro.",
  "an.pro_upgrade": "Auf Coach Pro upgraden",
  "an.insights_kicker": "Top-Bewegung",
  "an.insights_vs_prev": "vs. letzte Woche",
  "an.insights_tap": "Top-3 Veränderungen ansehen",
  "an.insights_modal_title": "Deine Top-Veränderungen",
  "an.insights_modal_sub": "Die stärksten Bewegungen gegenüber der Vorwoche.",
  "an.insights_empty": "Noch nicht genug Daten für einen Vergleich.",
  "an.tip_button": "Was zeigt mir das?",
  "an.tip_loading": "WEVA liest die Zahlen…",
  "an.tip_error": "Konnte gerade keine Einschätzung laden.",
  "an.tip_source": "KI-Einschätzung auf Basis deiner Daten",
  "an.t1": "Profil auf einen Blick",
  "an.t2": "Klient:innen-Wachstum",
  "an.t3": "Sessions & Buchungen",
  "an.t4": "WEVA-Gruppenanalyse",
  "an.t5": "Wochenpläne-Performance",
  "an.t6": "Content-Performance",
  "an.t7": "Inner vs. Local Circle",
  "an.t8": "Affiliate-Performance",
  "an.t9": "Engagement & Kommunikation",
  "an.t10": "Klient:innen-Ziele",
  "an.t11": "Zeitraum-Vergleich",
  "an.t12": "Reports & Export",
  "an.t1_clients": "Klient:innen gesamt",
  "an.t1_ic": "Inner",
  "an.t1_lc": "Local",
  "an.t1_general": "Allgemein",
  "an.t1_sessions": "Sessions abgeschlossen",
  "an.t1_offerings": "Aktive Angebote",
  "an.t1_gross": "Bruttoumsatz",
  "an.t1_since": "Dabei seit",
  "an.t2_new": "Neu",
  "an.t2_churn": "Abgänge",
  "an.t2_net": "Netto",
  "an.t2_cumulative": "Kumuliert",
  "an.t3_total": "Buchungen",
  "an.t3_completed": "Abgeschlossen",
  "an.t3_cancelled": "Storniert",
  "an.t3_cancel_rate": "Storno-Quote",
  "an.t3_avg_dur": "Ø Dauer",
  "an.t3_util": "Auslastung",
  "an.t3_hours": "Beliebteste Uhrzeiten",
  "an.t3_weekdays": "Beliebteste Wochentage",
  "an.t4_empty": "Noch keine WEVA-Daten deiner Klient:innen.",
  "an.t4_client_count": "Klient:innen",
  "an.t4_reports": "Berichte",
  "an.t4_emotions": "Top-Emotionen",
  "an.t4_emo_drop": "Emotions-Auflösung · letzte 90 Tage",
  "an.t4_emo_drop_hint": "Basierend auf {n} Sitzungen · ≥2 je Emotion",
  "an.t4_themes": "Themen",
  "an.t4_trend": "Intensitäts-Trend",
  "an.t4_before": "Vorher",
  "an.t4_after": "Nachher",
  "an.t5_empty": "Noch keine Wochenpläne gesendet.",
  "an.t5_sent": "Gesendet",
  "an.t5_open_rate": "Öffnungsrate",
  "an.t5_completion": "Abschlussrate",
  "an.t5_sessions_done": "Sitzungen erledigt",
  "an.t5_top_tech": "Top-Techniken",
  "an.t6_empty": "Noch keine Inhalte veröffentlicht.",
  "an.t6_posts": "Beiträge",
  "an.t6_views": "Aufrufe",
  "an.t6_favorites": "Favoriten",
  "an.t6_revenue": "Umsatz",
  "an.t6_top": "Top-Inhalte",
  "an.t7_empty": "Noch keine Kreis-Daten.",
  "an.t7_ic": "Inner Circle",
  "an.t7_lc": "Local Circle",
  "an.t7_members": "Mitglieder",
  "an.t7_revenue": "Umsatz",
  "an.t7_messages": "Nachrichten",
  "an.t7_snapshots": "Lieferungen",
  "an.t8_empty": "Noch keine Empfehlungen über deinen Code.",
  "an.t8_referrals": "Empfehlungen",
  "an.t8_conversion": "Conversion",
  "an.t8_revenue": "Umsatz",
  "an.t8_active_phases": "Aktive Phasen",
  "an.t8_phase_break": "Phasen-Aufschlüsselung",
  "an.t9_msgs": "Nachrichten gesendet",
  "an.t9_response": "Ø Antwortzeit",
  "an.t9_snap_delivered": "Lieferungen erledigt",
  "an.t9_snap_pending": "Lieferungen offen",
  "an.t9_circle_activity": "Kreis-Aktivität",
  "an.t10_empty": "Noch keine Ziele deiner Klient:innen.",
  "an.t10_client_count": "Klient:innen",
  "an.t10_goals_total": "Ziele gesamt",
  "an.t10_goals_done": "Ziele erreicht",
  "an.t10_beliefs_total": "Glaubenssätze",
  "an.t10_beliefs_trans": "Transformiert",
  "an.t10_top_cats": "Top-Kategorien",
  "an.t10_show_examples": "Anonyme Beispiele zeigen",
  "an.t10_hide_examples": "Beispiele ausblenden",
  "an.t10_examples_note": "Anonymisiert — keine Namen, nur Kategorie & Formulierung.",
  "an.t10_goals": "Ziele",
  "an.t10_beliefs": "Glaubenssätze",
  "an.t11_period_a": "Zeitraum A",
  "an.t11_period_b": "Zeitraum B",
  "an.t11_gross": "Bruttoumsatz",
  "an.t11_bookings": "Buchungen",
  "an.t11_msgs": "Nachrichten",
  "an.t11_new_clients": "Neue Klient:innen",
  "an.t12_hint": "Wähle Kacheln aus und exportiere einen individuellen Report.",
  "an.t12_templates": "Gespeicherte Vorlagen",
  "an.t12_templates_none": "Noch keine Vorlage gespeichert.",
  "an.t12_template_run": "Export",
  "an.t12_pick": "Kacheln für den Report",
  "an.t12_all_on": "Alle",
  "an.t12_all_off": "Keine",
  "an.t12_tpl_name_ph": "Vorlagen-Name",
  "an.t12_tpl_save": "Als Vorlage",
  "an.t12_tpl_saved": "Vorlage gespeichert.",
  "an.t12_pdf": "PDF",
  "an.t12_csv": "CSV",
  "an.t12_xlsx": "Excel",
  "an.t12_download_failed": "Download fehlgeschlagen. Bitte erneut versuchen.",

  // ── Werbung / Kampagnen (Phase 4e · e2) ──
  "ads.back": "Coach-Dashboard",
  "ads.eyebrow": "Werbung",
  "ads.title": "Werbe-Kampagnen",
  "ads.subtitle": "Bewerbe Beiträge & Angebote mit KI-Zielgruppe, Budget und Auswertung.",
  "ads.wallet": "Werbe-Guthaben",
  "ads.wallet_hint": "Guthaben für impression- oder klick-basierte Kampagnen.",
  "ads.topup": "Aufladen",
  "ads.topup_ok": "Werbe-Guthaben aufgeladen.",
  "ads.topup_title": "Werbe-Guthaben aufladen",
  "ads.topup_sub": "Aktuelles Guthaben: {balance}",
  "ads.topup_custom": "Eigener Betrag",
  "ads.topup_confirm": "{amount} aufladen",
  "ads.topup_note": "Sichere Zahlung über Stripe. EU-Rechnung inklusive.",
  "ads.topup_billing": "Bitte zuerst deine Rechnungsdaten vervollständigen (Konto).",
  "ads.new_campaign": "Neue Kampagne",
  "ads.new_campaign_sub": "In 3 Schritten erstellt — inkl. KI-Zielgruppe.",
  "ads.offerings": "Angebote verwalten",
  "ads.offerings_sub": "Sessions, Pakete & Preise bearbeiten.",
  "ads.reco_title": "Vorschläge zum Bewerben",
  "ads.reco_sub": "Automatisch nach organischer Resonanz gewählt.",
  "ads.reco_cta": "Jetzt bewerben",
  "ads.reco_reason_default": "Starke organische Resonanz.",
  "ads.reco_reason_views": "Viele Aufrufe — ideal zum Skalieren.",
  "ads.reco_reason_reactions": "Viele Reaktionen deiner Community.",
  "ads.reco_reason_comments": "Lebhafte Kommentare & Gespräche.",
  "ads.reco_reason_bookmarks": "Oft gespeichert — echtes Interesse.",
  "ads.reco_reason_freshness": "Frisch & aktuell — perfekt für einen Boost.",
  "ads.reco_reason_bookings": "Starke Buchungszahlen.",
  "ads.reco_reason_favorites": "Häufig favorisiert.",
  "ads.impressions": "Impressionen",
  "ads.clicks": "Klicks",
  "ads.ctr": "CTR",
  "ads.total_spent": "Ausgegeben",
  "ads.budget_left": "Budget übrig",
  "ads.my_campaigns": "Meine Kampagnen",
  "ads.empty": "Noch keine Kampagne. Erstelle deine erste Kampagne.",
  "ads.untitled": "Ohne Titel",
  "ads.subject_post": "Beitrag",
  "ads.subject_offering": "Angebot",
  "ads.billing_impression": "pro Impression",
  "ads.billing_click": "pro Klick",
  "ads.status_all": "Alle",
  "ads.status_running": "Läuft",
  "ads.status_paused": "Pausiert",
  "ads.status_pending_review": "In Prüfung",
  "ads.status_approved": "Freigegeben",
  "ads.status_completed": "Beendet",
  "ads.status_rejected": "Abgelehnt",
  "ads.pause": "Pausieren",
  "ads.resume": "Fortsetzen",
  "ads.stop": "Stoppen",
  "ads.view_details": "Details",
  "ads.spent_of": "{spent} von {total} ausgegeben",
  "ads.new_title": "Neue Kampagne",
  "ads.new_step": "Schritt {n} von 3",
  "ads.pick_subject": "Was möchtest du bewerben?",
  "ads.pick_subject_hint": "Wähle einen eigenen Beitrag oder ein Angebot.",
  "ads.subject_offerings": "Angebote",
  "ads.subject_posts": "Beiträge",
  "ads.no_subjects": "Noch keine Beiträge oder Angebote zum Bewerben.",
  "ads.audience": "Zielgruppe",
  "ads.ai_button": "KI-Vorschlag",
  "ads.ai_ok": "Zielgruppe vorgeschlagen.",
  "ads.ai_why": "Warum diese Zielgruppe",
  "ads.field_themes": "Themen",
  "ads.field_regions": "Regionen",
  "ads.field_education_backgrounds": "Ausbildung",
  "ads.field_life_situations": "Lebenssituationen",
  "ads.field_other_traits": "Weitere Merkmale",
  "ads.budget": "Budget",
  "ads.daily_eur": "Täglich (€)",
  "ads.duration_days": "Laufzeit (Tage)",
  "ads.total": "Gesamtbudget",
  "ads.billing_mode": "Abrechnung",
  "ads.payment": "Zahlung",
  "ads.pay_stripe": "Stripe",
  "ads.pay_credits": "Guthaben",
  "ads.credits_short": "Guthaben reicht nicht — bitte aufladen.",
  "ads.no_credits": "Dein Werbe-Guthaben reicht nicht aus.",
  "ads.new_ok": "Kampagne erstellt — jetzt in Prüfung.",
  "ads.next": "Weiter",
  "ads.back_step": "Zurück",
  "ads.launch": "Kampagne starten",
  "ads.detail_title": "Kampagne",
  "ads.detail_not_found": "Kampagne nicht gefunden.",
  "ads.range": "{n} Tage",
  "ads.chart_title": "Impressionen & Klicks pro Tag",
  "ads.range_totals": "Summe · {n} Tage",

  // ── Empfehlungen (Phase 4e · e3) ──
  "recs.back": "Coach-Dashboard",
  "recs.eyebrow": "Empfehlungen",
  "recs.title": "Empfehlungen",
  "recs.subtitle": "Wirkung deiner Beitrags-Empfehlungen & warme Empfehlungen auf deinem Profil.",
  "recs.tab_posts": "Beitrags-Empfehlungen",
  "recs.tab_testimonials": "Profil-Empfehlungen",
  "recs.sent": "Gesendet",
  "recs.opened": "Geöffnet",
  "recs.saved": "Gespeichert",
  "recs.booked": "Gebucht",
  "recs.per_post": "Pro Beitrag",
  "recs.see_clients": "Klient:innen ansehen",
  "recs.untitled": "Ohne Titel",
  "recs.posts_empty_title": "Noch keine Empfehlungen gesendet",
  "recs.posts_empty_sub": "Empfiehl Klient:innen passende Beiträge — die Wirkung erscheint hier.",
  "recs.detail_sub": "Pro Klient:in: geöffnet, gespeichert, gebucht.",
  "recs.no_clients": "Noch keine Klient:innen für diesen Beitrag.",
  "recs.unknown_client": "Unbekannte:r Klient:in",
  "recs.dismissed": "Verworfen",
  "recs.pending": "Offen",
  "recs.testimonials_empty_title": "Noch keine Empfehlungen",
  "recs.testimonials_empty_sub": "Klient:innen können nach einer Session eine warme Empfehlung hinterlassen.",
  "recs.testimonials_count": "{n} Empfehlung(en) auf deinem Profil",
  "recs.deleted": "Empfehlung entfernt.",

  // ── Buchungen-Tiefe (Phase 4f) ──
  "bk.back": "Coach-Dashboard",
  "bk.eyebrow": "Buchungen",
  "bk.title": "Buchungen",
  "bk.subtitle": "Sitzungen, Umbuchungen und Stornorichtlinie verwalten.",
  "bk.tab_bookings": "Buchungen",
  "bk.tab_reschedule": "Umbuchungen",
  "bk.tab_refund": "Stornorichtlinie",
  "bk.kpi_upcoming": "Kommend",
  "bk.kpi_completed": "Abgeschlossen",
  "bk.kpi_pending": "Storno-Anfragen",
  "bk.kpi_gross": "Gesamtumsatz",
  "bk.scope_upcoming": "Kommend",
  "bk.scope_cancellation_pending": "Storno-Anfragen",
  "bk.scope_completed": "Abgeschlossen",
  "bk.scope_cancelled": "Storniert",
  "bk.scope_all": "Alle",
  "bk.status_requested": "Angefragt",
  "bk.status_confirmed": "Bestätigt",
  "bk.status_paid": "Bezahlt",
  "bk.status_pending": "Ausstehend",
  "bk.status_completed": "Abgeschlossen",
  "bk.status_pending_cancellation": "Storno angefragt",
  "bk.status_cancelled_refunded": "Storniert (erstattet)",
  "bk.status_cancelled_no_refund": "Storniert",
  "bk.status_cancelled_refund_pending": "Storniert (Erstattung offen)",
  "bk.status_declined": "Abgelehnt",
  "bk.online": "Online",
  "bk.session": "Sitzung",
  "bk.client": "Klient:in",
  "bk.reason": "Grund",
  "bk.refund_per_policy": "Erstattung lt. Richtlinie: {pct}%",
  "bk.approve_refund": "Genehmigen & erstatten",
  "bk.decline": "Ablehnen",
  "bk.refunded": "Erstattet: {amount} ({pct}%)",
  "bk.empty_title": "Keine Buchungen",
  "bk.empty_sub": "In diesem Bereich gibt es aktuell nichts zu sehen.",
  "bk.load_failed": "Buchungen konnten nicht geladen werden.",
  "bk.approved_toast": "Stornierung genehmigt & Erstattung veranlasst.",
  "bk.declined_toast": "Stornierung abgelehnt.",
  "bk.action_failed": "Aktion fehlgeschlagen.",
  "bk.rs_title": "Auto-Umbuchung",
  "bk.rs_sub": "Wie weit im Voraus Klient:innen Sitzungen automatisch umbuchen dürfen.",
  "bk.rs_window_label": "Auto-Freigabe-Fenster (Stunden vor Sitzung)",
  "bk.rs_window_unit": "Std.",
  "bk.rs_saved": "Auto-Umbuchung ist jetzt {n} Std. vor der Sitzung.",
  "bk.rs_hint": "Klient:innen können nur automatisch umbuchen, wenn die Sitzung mindestens so weit in der Zukunft liegt UND der neue Slot ebenso weit entfernt ist. 0 = immer deine Freigabe nötig.",
  "bk.rs_invalid": "Bitte eine Zahl zwischen 0 und 336 Stunden eingeben.",
  "bk.rs_pending_title": "Offene Anfragen",
  "bk.rs_pending_empty": "Keine offenen Anfragen. 🌱",
  "bk.rs_currently": "Aktuell",
  "bk.rs_reason_too_close": "⚠️ Zu kurz vor Sitzungsbeginn angefragt",
  "bk.rs_reason_no_slot": "ℹ️ Keiner der Slots der Klient:in war frei",
  "bk.rs_client_windows": "Vorschläge der Klient:in",
  "bk.rs_approve": "Freigeben",
  "bk.rs_reject_ph": "Optionale Nachricht an die Klient:in",
  "bk.rs_counter": "🕰️ Gegenvorschläge",
  "bk.rs_reject": "Ablehnen",
  "bk.rs_approved_toast": "{name}s Sitzung wurde verschoben.",
  "bk.rs_rejected_toast": "{name} wird benachrichtigt.",
  "bk.cp_title": "Gegenvorschläge senden",
  "bk.cp_sub": "Schlage {name} alternative Zeiten vor.",
  "bk.cp_add_slot": "Zeit hinzufügen",
  "bk.cp_message_ph": "Optionale Nachricht",
  "bk.cp_send": "Vorschläge senden",
  "bk.cp_sent": "Gegenvorschläge gesendet.",
  "bk.cp_need_one": "Bitte mindestens eine Zeit wählen.",
  "bk.rf_warn_bold": "Die Plattform übernimmt nie Verluste.",
  "bk.rf_warn_body": "Jede Erstattung geht zu deinen Lasten. Stripe erstattet die Bearbeitungsgebühr der Zahlung NICHT — sie bleibt bei Stripe und wird von deiner Auszahlung abgezogen. Wähle Stufen, die du dir leisten kannst.",
  "bk.rf_your_tiers": "Deine Stufen",
  "bk.rf_tiers_hint": "Stufen gelten in absteigender Reihenfolge der Stunden vor der Sitzung.",
  "bk.rf_hours_before": "Stunden vorher",
  "bk.rf_percent": "Erstattung %",
  "bk.rf_add_tier": "Stufe hinzufügen",
  "bk.rf_reset": "Standard",
  "bk.rf_estimator": "Was kostet dich das?",
  "bk.rf_sample_price": "Beispielpreis",
  "bk.rf_at_tier": "Bei Stufe",
  "bk.rf_refund_amount": "Erstattungsbetrag",
  "bk.rf_stripe_fee": "Verlorene Stripe-Gebühr",
  "bk.rf_out_of_pocket": "Deine Kosten",
  "bk.rf_commission_kept": "Plattform-Provision (bleibt fällig)",
  "bk.rf_net_kept": "Dein Netto-Behalt",
  "bk.rf_msg_to_clients": "Nachricht an Klient:innen",
  "bk.rf_msg_ph": "z. B. Umbuchung ist mit 48 Std. Vorlauf kostenlos.",
  "bk.rf_save": "Speichern",
  "bk.rf_saved": "Deine Stornorichtlinie wurde aktualisiert.",

  // Zielgruppen-Vorlagen (Wizard-Verbesserung)
  "ads.tpl_label": "Zielgruppen-Vorlagen",
  "ads.tpl_none": "Noch keine Vorlage gespeichert.",
  "ads.tpl_save": "Speichern",
  "ads.tpl_name_ph": "Vorlagen-Name",
  "ads.tpl_saved": "Zielgruppe als Vorlage gespeichert.",
  "ads.tpl_applied": "Vorlage „{name}“ übernommen.",
  "ads.tpl_deleted": "Vorlage gelöscht.",
  "ads.tpl_save_hint": "Speichert die aktuellen Zielgruppen-Felder zur Wiederverwendung.",
  "zoom.title": "Zoom",
  "zoom.soon": "Wird vom Team eingerichtet — bald verfügbar.",
  "zoom.connected": "Verbunden",
  "zoom.hint": "Verbinde dein Zoom-Konto für automatische Meeting-Links bei Online-Buchungen.",
  "zoom.connect": "Zoom verbinden",
  "zoom.disconnect": "Trennen",
  "zoom.t_connected": "Zoom-Konto verbunden.",
  "zoom.t_error": "Zoom-Verbindung fehlgeschlagen.",
  "zoom.t_disconnected": "Zoom getrennt.",
  "zoom.not_setup": "Zoom ist noch nicht eingerichtet.",

  "pl.tab_programs": "Atem-Programme",
  "bp.sub": "Baue mehrtägige Atem-Programme aus 3–5 Techniken und teile sie per Zuweisung oder Code.",
  "bp.new": "Neues Programm",
  "bp.empty_title": "Noch keine Atem-Programme",
  "bp.empty_sub": "Erstelle dein erstes mehrtägiges Programm für deine Klient:innen.",
  "bp.techniques_n": "{n} Techniken",
  "bp.days_n": "{n} Tage",
  "bp.assigned_n": "{n} zugewiesen",
  "bp.share": "Teilen",
  "bp.archive_confirm": "Programm „{name}“ archivieren?",
  "bp.archived": "Programm archiviert.",
  "bp.editor_new_title": "Neues Atem-Programm",
  "bp.editor_edit_title": "Programm bearbeiten",
  "bp.editor_desc": "Wähle 3–5 Techniken und lege Dauer & Rhythmus fest.",
  "bp.name_ph": "Name des Programms",
  "bp.desc_ph": "Kurze Beschreibung (optional)",
  "bp.days_label": "Dauer (Tage)",
  "bp.rhythm_label": "Rhythmus",
  "bp.tech_count": "Techniken ({n}/5)",
  "bp.min": "min",
  "bp.note_ph": "Hinweis",
  "bp.need_valid": "Name und 3–5 Techniken erforderlich.",
  "bp.created": "Programm erstellt.",
  "bp.updated": "Programm aktualisiert.",
  "bp.save_failed": "Speichern fehlgeschlagen.",
  "bp.share_title": "„{name}“ teilen",
  "bp.share_desc": "Weise das Programm direkt einer Klient:in zu oder teile den Code {code}.",
  "bp.no_clients": "Noch keine Klient:innen.",
  "bp.assign_note_ph": "Persönliche Nachricht (optional)",
  "bp.assign": "Zuweisen",
  "bp.sending": "Senden…",
  "bp.assigned_ok": "Programm zugewiesen.",
  "bp.assign_failed": "Zuweisung fehlgeschlagen.",
  "bp.sched_all_daily": "Alle täglich",
  "bp.sched_rotate": "Rotierend",
  "bp.tech_box": "Box-Atmung",
  "bp.tech_478": "4-7-8",
  "bp.tech_coherent": "Kohärente Atmung",
  "bp.tech_physiological_sigh": "Physiologischer Seufzer",
  "bp.tech_cooling": "Kühlende Atmung",
  "bp.tech_bhramari": "Bhramari",
  "bp.tech_nadi_shodhana": "Wechselatmung",
  "bp.tech_ocean": "Ozean-Atem",
  "bp.tech_wim_hof": "Wim-Hof",
  "bp.tech_kapalabhati": "Kapalabhati",

  "cd.back": "Klient:innen-Puls",
  "cd.no_access_title": "Kein Zugriff",
  "cd.no_access_sub": "Für diese Klient:in besteht keine aktive Beziehung.",
  "cd.client_fallback": "Klient:in",
  "cd.upcoming": "Kommende Sitzungen ({n})",
  "cd.no_upcoming": "Keine kommenden Sitzungen.",
  "cd.past": "Vergangene Sitzungen ({n})",
  "cd.no_past": "Noch keine vergangenen Sitzungen.",
  "cd.plans": "Wochenpläne ({n})",
  "cd.no_plans": "Keine Wochenpläne geteilt.",
  "cd.plan_meta": "{slots} Slots · {done} erledigt · {week}",
  "cd.flexible": "flexibel",
  "cd.session_fallback": "Sitzung",
  "cd.sharing_title": "Geteilte Daten",
  "cd.no_sharing": "Diese Klient:in teilt derzeit keine Deep-Within-Daten mit dir.",
  "cd.analysis_title": "Analyse",
  "cd.digestions": "Verdauungen",
  "cd.transformations": "Transformationen",
  "cd.journal": "Journal",
  "cd.no_emotions": "Keine geteilten Emotionsdaten im Zeitraum.",
  "cd.weva": "WEVA-Berichte ({n})",
  "cd.no_weva": "Noch keine WEVA-Berichte für diese Klient:in.",
  "cd.days_n": "{n} Tage",
  "cd.snapshots_n": "{n} Snapshot-Anfrage(n)",
  "cd.attachments": "Geteilte Anhänge ({n})",
  "cd.load_failed": "Klient:in konnte nicht geladen werden.",
  "cd.scope_share_events": "Ereignisse",
  "cd.scope_share_hrv": "HRV",
  "cd.scope_share_plans": "Pläne",
  "cd.scope_share_ai_reports": "KI-Berichte",
  "cd.scope_share_feed_activity": "Feed-Aktivität",
  "cd.scope_share_beliefs": "Glaubenssätze",
  "cd.scope_share_upper_limits": "Upper Limits",
  "cd.scope_share_goals": "Ziele",
  "cd.scope_share_comfortzone": "Komfortzone",
  "cd.scope_share_coping": "Coping",
  "cd.scope_share_journal": "Journal",
  "cd.scope_share_weva_reports": "WEVA-Berichte",
  "cd.count_beliefs": "Glaubenssätze",
  "cd.count_upper_limits": "Upper Limits",
  "cd.count_goals": "Ziele",
  "cd.count_comfortzone": "Komfortzone",
  "cd.count_coping": "Coping",
  "cd.count_journal": "Journal-Einträge",
  "cd.count_ai_reports": "KI-Berichte",
  "cd.count_events": "Ereignisse",

  // ── Phase A P1 ──
  // Collab-Tiefe
  "col.tab_projects": "Projekte",
  "col.tab_stats": "Statistiken",
  "col.tab_ai": "KI-Empfehlungen",
  "col.stats_title": "Bald verfügbar",
  "col.stats_body": "Buchungen, Umsatz und Klient:innen-Bindung je Kollaboration in einer übersichtlichen Dashboard-Ansicht.",
  "col.ai_title": "Bald verfügbar",
  "col.ai_body": "WEVA findet passende Coaches für neue Kollaborationen auf Basis gemeinsamer Themen, Zielgruppen und Verfügbarkeit.",
  "col.project_type_offering": "Angebot",
  "col.project_type_circle": "Kreis",
  "col.project_status_active": "Aktiv",
  "col.project_status_archived": "Archiviert",
  "col.project_empty_active": "Noch keine aktiven Projekte",
  "col.project_empty_archived": "Keine archivierten Projekte",
  "col.project_empty_hint": "Gemeinsame Angebote und Kreise erscheinen hier als Projekte.",
  "col.project_members_n": "{n} Mitglieder",
  "col.project_tasks": "Aufgaben",
  "col.project_revenue": "Gesamtumsatz",
  "col.project_my_share": "Dein Anteil ({pct}%)",
  "col.project_participants": "Teilnehmende",
  "col.project_team": "Coach-Team",
  "col.project_documents": "Dokumente",
  "col.project_purchases": "Käufe",

  // WEVA-Snapshot-Vergleich
  "cd.snap_title": "WEVA-Snapshot-Vergleich",
  "cd.snap_request": "Snapshot anfragen",
  "cd.snap_requesting": "Wird angefragt…",
  "cd.snap_requested": "Snapshot-Anfrage gesendet.",
  "cd.snap_request_failed": "Anfrage fehlgeschlagen.",
  "cd.snap_need_more": "Noch nicht genug Daten für einen Vergleich. Vorhandene Snapshots: {count}. Zwei genehmigte Snapshots werden benötigt.",
  "cd.snap_days_between": "{n} Tage zwischen den Snapshots",
  "cd.snap_beliefs_new": "{n} neue Glaubenssätze",
  "cd.snap_beliefs_dissolved": "{n} aufgelöst",
  "cd.snap_beliefs_recurring": "{n} wiederkehrend",
  "cd.snap_pillars_shifted": "Verschobene Schwerpunkte",
  "cd.snap_pillar_realize": "Erkennen",
  "cd.snap_pillar_designate": "Benennen",
  "cd.snap_pillar_release": "Loslassen",
  "cd.snap_practice_shift": "Nächste Praxis geändert",
  "cd.snap_previous": "Vorheriger",
  "cd.snap_latest": "Aktuellster",

  // Consent-Forms
  "cf.meta_title": "Einwilligungen",
  "cf.back": "Coach-Dashboard",
  "cf.eyebrow": "Einwilligungen",
  "cf.title": "Einverständniserklärungen",
  "cf.subtitle": "Erstelle Vorlagen, die Klient:innen vor der Buchung digital unterschreiben.",
  "cf.new": "Neue Vorlage",
  "cf.empty_title": "Noch keine Vorlagen",
  "cf.empty_sub": "Lege eine Einverständniserklärung an, die vor der Buchung unterschrieben werden muss.",
  "cf.badge_required": "Pflicht vor Buchung",
  "cf.sig_count": "{n} Unterschriften",
  "cf.delete_confirm": "Diese Vorlage wirklich archivieren?",
  "cf.deleted": "Vorlage archiviert.",
  "cf.saved": "Vorlage gespeichert.",
  "cf.dialog_new": "Neue Einverständniserklärung",
  "cf.dialog_edit": "Vorlage bearbeiten",
  "cf.dialog_desc": "Titel und Text der Erklärung. Klient:innen unterschreiben digital in der App.",
  "cf.f_title": "Titel",
  "cf.f_title_ph": "z. B. Haftungsausschluss Breathwork",
  "cf.f_body": "Text",
  "cf.f_body_ph": "Schreibe hier den vollständigen Text der Einverständniserklärung…",
  "cf.f_required": "Pflicht vor der Buchung",
  "cf.f_required_hint": "Klient:innen müssen unterschreiben, bevor sie buchen können.",
  "cf.version_note": "Textänderungen erhöhen die Version — bestehende Unterschriften bleiben erhalten.",
  "cf.err_title": "Bitte einen Titel angeben.",
  "cf.err_body": "Bitte einen Text angeben.",
  "cf.sig_title": "Unterschriften",
  "cf.sig_empty": "Noch keine Unterschriften.",
  "cf.sig_version": "Version {v}",

  // Post-Scheduler
  "ps.tab_label": "Planer",
  "ps.new": "Neuer Entwurf",
  "ps.saved": "Gespeichert.",
  "ps.published": "Veröffentlicht.",
  "ps.status_draft": "Entwürfe",
  "ps.status_scheduled": "Geplant",
  "ps.status_published": "Veröffentlicht",
  "ps.next_hint": "Nächster Beitrag „{title}“ geht live am {when}.",
  "ps.wd_mon": "Mo",
  "ps.wd_tue": "Di",
  "ps.wd_wed": "Mi",
  "ps.wd_thu": "Do",
  "ps.wd_fri": "Fr",
  "ps.wd_sat": "Sa",
  "ps.wd_sun": "So",
  "ps.undated_title": "Entwürfe ohne Datum",
  "ps.undated_empty": "Keine ungeplanten Entwürfe.",
  "ps.dialog_new": "Neuer Beitrag",
  "ps.dialog_edit": "Beitrag bearbeiten",
  "ps.dialog_desc": "Lege einen Entwurf an oder plane die Veröffentlichung für später.",
  "ps.f_title": "Titel",
  "ps.f_title_ph": "Überschrift des Beitrags",
  "ps.f_body": "Inhalt",
  "ps.f_body_ph": "Schreibe deinen Beitrag…",
  "ps.f_scheduled": "Geplant für",
  "ps.f_scheduled_hint": "Leer lassen für einen Entwurf ohne Datum. Mit Datum wird automatisch veröffentlicht.",
  "ps.f_inner_circle": "Nur Inner Circle",
  "ps.publish_now": "Jetzt veröffentlichen",
  "ps.err_title": "Bitte einen Titel angeben.",

  // Affiliate-Angebote
  "aff.tab_label": "Affiliate",
  "aff.intro": "Externe Affiliate-Links, die in deinem öffentlichen Profil erscheinen.",
  "aff.new": "Neues Affiliate-Angebot",
  "aff.saved": "Gespeichert.",
  "aff.deleted": "Gelöscht.",
  "aff.delete_confirm": "Dieses Affiliate-Angebot wirklich löschen?",
  "aff.locked_title": "Nur für Coach Pro",
  "aff.locked_sub": "Affiliate-Angebote sind für Coach-Pro-Abonnent:innen und Founder-50/500-Mitglieder verfügbar.",
  "aff.empty_title": "Noch keine Affiliate-Angebote",
  "aff.empty_sub": "Verlinke Produkte, die du empfiehlst — mit automatischem Werbe-Hinweis.",
  "aff.ad_badge": "Werbung",
  "aff.inactive": "Inaktiv",
  "aff.dialog_new": "Neues Affiliate-Angebot",
  "aff.dialog_edit": "Angebot bearbeiten",
  "aff.dialog_desc": "Der Link wird im externen Browser geöffnet und automatisch als Werbung gekennzeichnet.",
  "aff.f_title": "Titel",
  "aff.f_title_ph": "z. B. Mein Lieblings-Journal",
  "aff.f_url": "Affiliate-Link",
  "aff.f_desc": "Beschreibung",
  "aff.f_desc_ph": "Kurze Beschreibung (max. 400 Zeichen)",
  "aff.f_category": "Kategorie",
  "aff.f_category_ph": "z. B. Bücher",
  "aff.f_price": "Preis",
  "aff.f_price_ph": "optional",
  "aff.f_cover": "Cover-Bild",
  "aff.f_cover_hint": "Optional. Erscheint auf der Affiliate-Karte in deinem öffentlichen Profil.",
  "aff.compete_hint": "Hinweis: Links zu Wettbewerber-Apps oder Plattformen mit denselben Funktionen wie My Within sind nicht erlaubt.",
  "aff.ack_label": "Ich bin mir der Kennzeichnungspflicht bewusst und kennzeichne den Link als Werbung.",
  "aff.ack_compete": "Ich bestätige, dass dieser Link nicht zu einer konkurrierenden Plattform führt.",
  "aff.err_title": "Bitte einen Titel angeben.",
  "aff.err_url": "Bitte eine gültige URL (http/https) angeben.",
  "aff.err_ack": "Bitte beide Bestätigungen anhaken.",

  // Coach-Setup
  "cs.meta_title": "Coach-Einrichtung",
  "cs.back": "Coach-Dashboard",
  "cs.eyebrow": "Einrichtung",
  "cs.title": "Coach-Einrichtung",
  "cs.subtitle": "Vier Schritte zum startklaren Coach-Profil — danach gibt's das Founding-Coach-Badge.",
  "cs.progress_label": "{done} von {total} Schritten erledigt",
  "cs.badge_title": "Founding-Coach-Badge aktiv ✨",
  "cs.badge_sub": "Du trägst noch {n} Tage das Founding-Coach-Badge auf deinem Profil.",
  "cs.step_n": "Schritt {n}",
  "cs.done": "Erledigt",
  "cs.mark_done": "Als erledigt markieren",
  "cs.step_consent_title": "Einverständniserklärung anlegen",
  "cs.step_consent_sub": "Erstelle eine Vorlage, die Klient:innen vor der Buchung unterschreiben.",
  "cs.step_consent_cta": "Zu den Einwilligungen",
  "cs.step_story_title": "Erste Story teilen",
  "cs.step_story_sub": "Zeig dich auf der Story-Wall und baue Vertrauen auf.",
  "cs.step_story_cta": "Zu Social & Inhalte",
  "cs.step_program_title": "Atem-Programm erstellen",
  "cs.step_program_sub": "Lege ein Programm an, das du Klient:innen zuweisen kannst.",
  "cs.step_program_cta": "Zu den Plänen",
  "cs.step_invite_title": "Erste:n Klient:in einladen",
  "cs.step_invite_sub": "Teile deinen Einladungscode und hole deine ersten Klient:innen an Bord.",
  "cs.step_invite_cta": "Einladungscode anzeigen",

  // ── Phase A P2 · Einstellungen-Hub ──
  "cset.meta_title": "Einstellungen",
  "cset.back_dashboard": "Coach-Dashboard",
  "cset.eyebrow": "Konto",
  "cset.title": "Einstellungen",
  "cset.subtitle": "Konto, Buchungsregeln, Marke, Berichte und Guthaben an einem Ort.",
  "cset.group_account": "Konto",
  "cset.group_bookings": "Buchungen",
  "cset.group_brand": "Marke & Berichte",
  "cset.group_billing": "Abrechnung",
  "cset.group_language": "Sprache",
  "cset.row_profile": "Profil & Marke",
  "cset.row_profile_sub": "Öffentliches Profil, Bio & Branding.",
  "cset.row_verify": "Verifizierung",
  "cset.row_verify_sub": "Qualifikation hochladen & Status.",
  "cset.row_availability": "Verfügbarkeit",
  "cset.row_availability_sub": "Wöchentliche Slots öffnen & schließen.",
  "cset.row_refund": "Stornierung & Rückerstattung",
  "cset.row_refund_sub": "Eigene Rückerstattungs-Stufen & Kosten.",
  "cset.row_reschedule": "Umbuchungen",
  "cset.row_reschedule_sub": "Auto-Freigabe-Fenster & offene Anfragen.",
  "cset.row_branding": "Custom Branding",
  "cset.row_branding_sub": "Logo, Markenfarbe & E-Mail-Fußzeile.",
  "cset.row_digest": "Weekly-Digest-Vorschau",
  "cset.row_digest_sub": "Deine Collab-Buchungen der letzten Woche.",
  "cset.row_credits": "Guthaben · {n}",
  "cset.row_credits_sub": "Credits aufladen für Werbung & mehr.",
  "cset.row_language": "App-Sprache",
  "cset.logout": "Abmelden",

  // Stornierung & Rückerstattung
  "refpol.meta_title": "Stornierung & Rückerstattung",
  "refpol.eyebrow": "Buchungen",
  "refpol.title": "Stornierung & Rückerstattung",
  "refpol.subtitle": "Lege eigene Rückerstattungs-Stufen fest, die die Plattform-Standards überschreiben.",
  "refpol.warn_bold": "Die Plattform trägt nie Verluste.",
  "refpol.warn_body": "Jede Rückerstattung geht von deinen Einnahmen ab. Stripe erstattet die Bearbeitungsgebühr NICHT — sie bleibt bei Stripe und wird von deiner Auszahlung abgezogen. Wähle nur Stufen, die du dir leisten kannst.",
  "refpol.your_tiers": "Deine Stufen",
  "refpol.tiers_hint": "Stufen greifen in absteigender Reihenfolge der Stunden vor der Session.",
  "refpol.hours_before": "Stunden vorher",
  "refpol.refund_pct": "Erstattung %",
  "refpol.add_tier": "Stufe hinzufügen",
  "refpol.reset": "Auf Standard zurücksetzen",
  "refpol.cost_title": "Was kostet eine Rückerstattung?",
  "refpol.sample_price": "Beispielpreis",
  "refpol.est_refund": "Erstattungsbetrag",
  "refpol.est_stripe": "Verlorene Stripe-Gebühr",
  "refpol.est_oop": "Deine Eigenkosten",
  "refpol.est_commission": "Plattform-Provision (bleibt fällig)",
  "refpol.est_net": "Dein Netto-Behalt",
  "refpol.notes": "Nachricht an Klient:innen",
  "refpol.notes_ph": "z. B. Umbuchung ist bis 48h vorher kostenlos.",
  "refpol.save": "Richtlinie speichern",
  "refpol.saved": "Richtlinie gespeichert.",

  // Umbuchungen
  "resch.meta_title": "Umbuchungen",
  "resch.eyebrow": "Buchungen",
  "resch.title": "Umbuchungs-Einstellungen",
  "resch.subtitle": "Wie weit im Voraus Klient:innen Sessions automatisch umbuchen dürfen.",
  "resch.window_label": "Auto-Freigabe-Fenster (Stunden vor der Session)",
  "resch.window_hint": "Klient:innen können nur automatisch umbuchen, wenn die Session mindestens so weit in der Zukunft liegt UND der neue Slot ebenso weit entfernt ist. 0 = immer deine Freigabe nötig.",
  "resch.save": "Speichern",
  "resch.saved": "Gespeichert.",
  "resch.invalid": "Bitte eine Zahl zwischen 0 und 336 eingeben.",
  "resch.pending_title": "Offene Anfragen",
  "resch.pending_empty": "Keine offenen Anfragen. 🌱",
  "resch.currently": "Aktuell",
  "resch.reason_too_close": "⚠️ Zu kurz vor dem Session-Start angefragt",
  "resch.reason_no_slot": "ℹ️ Keiner der Wunsch-Slots war frei",
  "resch.client_windows": "Von Klient:in vorgeschlagen",
  "resch.approve": "Freigeben",
  "resch.approved": "Freigegeben.",
  "resch.reject_ph": "Optionale Nachricht an Klient:in",
  "resch.reject": "Anfrage ablehnen",
  "resch.rejected": "Abgelehnt.",

  // Custom Branding
  "cbr.meta_title": "Custom Branding",
  "cbr.eyebrow": "Marke",
  "cbr.title": "Custom Branding",
  "cbr.subtitle": "Logo, Markenfarbe und Fußzeile für deine klientenseitigen E-Mails.",
  "cbr.locked_title": "Nur für Coach Pro",
  "cbr.locked_sub": "Custom Branding ist Teil von Coach Pro. Upgrade, um dein eigenes Logo und deine Farben zu nutzen.",
  "cbr.f_logo": "Logo-URL",
  "cbr.f_logo_hint": "Öffentliche https-URL deines Logos (erscheint in E-Mails).",
  "cbr.f_color": "Markenfarbe",
  "cbr.f_footer": "E-Mail-Fußzeile",
  "cbr.f_footer_ph": "z. B. Mit Liebe, dein Coach-Name · Impressum/Links",
  "cbr.save": "Branding speichern",
  "cbr.saved": "Branding gespeichert.",
  "cbr.reset": "Zurücksetzen",
  "cbr.reset_confirm": "Branding auf Standard zurücksetzen?",
  "cbr.reset_done": "Auf Standard zurückgesetzt.",
  "cbr.err_logo": "Logo-URL muss mit http:// oder https:// beginnen.",
  "cbr.err_color": "Farbe muss im Format #RRGGBB sein (z. B. #6B8E6E).",

  // Weekly-Digest-Vorschau
  "wdig.meta_title": "Weekly Digest",
  "wdig.eyebrow": "Berichte",
  "wdig.title": "Weekly-Digest-Vorschau",
  "wdig.subtitle": "Deine Collab-Buchungen der letzten Woche — so wie im E-Mail-Digest.",
  "wdig.this_week": "Diese Woche",
  "wdig.bookings": "Buchungen",
  "wdig.gross": "Brutto-Umsatz",
  "wdig.trend": "4-Wochen-Trend",
  "wdig.offerings": "Nach Angebot",
  "wdig.offerings_empty": "Diese Woche noch keine Collab-Buchungen.",
  "wdig.n_bookings": "{n} Buchungen",
  "wdig.last_sent": "Zuletzt gesendet {when} · {n} Buchungen · {gross}",

  // Guthaben / Credits
  "cred.meta_title": "Guthaben",
  "cred.eyebrow": "Abrechnung",
  "cred.title": "Guthaben",
  "cred.subtitle": "Lade Credits auf, um Werbung zu schalten und Premium-Funktionen zu nutzen.",
  "cred.balance": "Aktuelles Guthaben",
  "cred.per_credit": "{price} pro Credit",
  "cred.buy": "Kaufen",
  "cred.mock_granted": "{n} Credits gutgeschrieben (Testmodus).",
  "cred.vat_note": "Preise inkl. USt. Rechnung von Inside Out Harmony e.U. (Österreich).",

  // ── Phase A P2 Teil 2 · Einstellungen-Zeilen ──
  "cset.row_professional": "Fachprofil & Zertifikate",
  "cset.row_professional_sub": "Beruf, Methoden, Qualifikationen & Nachweise.",
  "cset.row_checkin": "Check-in-Vorlage",
  "cset.row_checkin_sub": "Warme Nachricht für stille Klient:innen.",
  "cset.group_growth": "Wachstum",
  "cset.row_referral": "Empfehlen & verdienen",
  "cset.row_referral_sub": "Dein Code, Links & Belohnungen.",
  "cset.row_ic_invites": "Inner-Circle-Einladungen",
  "cset.row_ic_invites_sub": "Klient:innen einladen & Annahmen verfolgen.",
  "cset.row_wins": "Klient:innen-Erfolge",
  "cset.row_wins_sub": "Erfolgsgeschichten & Testimonials.",
  "cset.row_collectives": "Kollektive",
  "cset.row_collectives_sub": "Coach-Allianzen mit geteilten Umsätzen.",
  "cset.group_support": "Support & Hilfe",
  "cset.row_support": "Support-Tickets",
  "cset.row_support_sub": "Frag das My-Within-Team direkt.",
  "cset.row_help": "Hilfe & FAQ",
  "cset.row_help_sub": "Antworten auf häufige Fragen.",
  "cset.row_tour": "Rundgang",
  "cset.row_tour_sub": "Schneller Überblick über dein Dashboard.",
  "cset.row_upgrade": "Coach Pro",
  "cset.row_upgrade_sub": "Upgrade für 10% Provision, Branding & mehr.",

  // Support
  "sup.meta_title": "Support", "sup.eyebrow": "Support", "sup.title": "Support & Betreuung",
  "sup.subtitle": "Stell deine Frage direkt ans My-Within-Team — wir melden uns persönlich.",
  "sup.new": "Neue Anfrage", "sup.new_desc": "Wähle ein Thema und beschreibe dein Anliegen.",
  "sup.f_category": "Thema", "sup.f_subject": "Betreff (optional)", "sup.f_subject_ph": "Kurzer Titel",
  "sup.f_body": "Deine Nachricht", "sup.f_body_ph": "Beschreibe dein Anliegen so konkret wie möglich…",
  "sup.submit": "Absenden", "sup.created": "Anfrage gesendet.", "sup.err_cat": "Bitte mindestens ein Thema wählen.", "sup.err_body": "Bitte beschreibe dein Anliegen.",
  "sup.empty_title": "Noch keine Anfragen", "sup.empty_sub": "Stell deine erste Support-Anfrage — wir sind für dich da.",
  "sup.n_msg": "{n} Nachrichten",
  "sup.status_open": "Offen", "sup.status_in_progress": "In Bearbeitung", "sup.status_answered": "Beantwortet", "sup.status_closed": "Geschlossen",
  "sup.reply_ph": "Antwort schreiben…", "sup.send": "Senden", "sup.close": "Ticket schließen", "sup.close_confirm": "Ticket wirklich schließen?", "sup.closed": "Geschlossen.", "sup.is_closed": "Dieses Ticket ist geschlossen. Für neue Fragen bitte eine neue Anfrage erstellen.",

  // Referral
  "ref.meta_title": "Empfehlen", "ref.eyebrow": "Wachstum", "ref.title": "Empfehlen & verdienen",
  "ref.subtitle": "Teile My Within und erhalte Belohnungen für jede Anmeldung über deinen Code.",
  "ref.your_code": "Dein Empfehlungscode", "ref.share": "Teilen", "ref.copied": "Link kopiert.",
  "ref.links": "Deine Links", "ref.web_link": "Web-Link", "ref.app_link": "App-Link",
  "ref.rewards_title": "So funktionieren Belohnungen",
  "ref.rule_coach_bonus": "{pct}% Bonus auf Klient:innen-Abos, die du wirbst — bis zu {months} Monate.",
  "ref.rule_c2c": "{eur} € Guthaben pro geworbener Person — bis zu {max}×/Jahr.",
  "ref.rule_note": "Belohnungen werden nach der Rückerstattungsfrist freigegeben.",

  // Check-in-Vorlage
  "chk.meta_title": "Check-in-Vorlage", "chk.eyebrow": "Buchungen", "chk.title": "Check-in-Vorlage",
  "chk.subtitle": "Deine warme Standard-Nachricht für stille Klient:innen aus dem Klient:innen-Puls.",
  "chk.default_hint": "Du nutzt aktuell die Standard-Vorlage. Passe sie an, um deinen Ton zu treffen.",
  "chk.f_template": "Vorlagentext", "chk.preview": "Vorschau", "chk.save": "Vorlage speichern", "chk.saved": "Gespeichert.", "chk.err_short": "Bitte mindestens 10 Zeichen.",

  // Upgrade
  "upg.meta_title": "Coach Pro", "upg.eyebrow": "Abo", "upg.title": "Upgrade auf Coach Pro",
  "upg.subtitle": "Niedrigere Provision, dein eigenes Branding und alle Premium-Tools.",
  "upg.already_pro": "Du bist bereits Coach Pro — danke, dass du dabei bist! ✨",
  "upg.best_value": "Bester Preis", "upg.plan_monthly": "Monatlich", "upg.plan_yearly": "Jährlich", "upg.per_month": "Monat", "upg.per_year": "Jahr",
  "upg.f_commission": "Nur 10% Provision auf Sitzungen", "upg.f_unlimited_weva": "Unbegrenzte WEVA-Analysen", "upg.f_branding": "Eigenes Branding (Logo & Farbe)",
  "upg.f_analytics": "Erweiterte Analytics", "upg.f_priority": "Priority-WEVA-Verarbeitung", "upg.f_group_tools": "Gruppen- & Kollektiv-Tools", "upg.f_bulk_export": "Bulk-Export deiner Daten",
  "upg.subscribe": "Jetzt upgraden", "upg.current": "Aktueller Plan", "upg.pay_credits": "Mit {n} Credits zahlen", "upg.activated": "Coach Pro aktiviert!", "upg.vat_note": "Preise inkl. 20% österr. USt. Jederzeit kündbar.",

  // Help / FAQ
  "help.meta_title": "Hilfe", "help.eyebrow": "Hilfe", "help.title": "Hilfe & FAQ", "help.subtitle": "Schnelle Antworten auf die häufigsten Coach-Fragen.",
  "help.q_getting_started": "Wie starte ich als Coach?", "help.a_getting_started": "Durchlaufe die Coach-Einrichtung (4 Schritte): Einwilligung anlegen, erste Story teilen, ein Atem-Programm erstellen und deine erste:n Klient:in einladen.",
  "help.q_payouts": "Wie bekomme ich meine Auszahlungen?", "help.a_payouts": "Verbinde dein Stripe-Konto unter Einnahmen. Auszahlungen laufen automatisch nach der Rückerstattungsfrist — abzüglich der Plattform-Provision.",
  "help.q_clients": "Wie sehe ich stille Klient:innen?", "help.a_clients": "Der Klient:innen-Puls zeigt, wer länger inaktiv war. Von dort kannst du einen warmen Check-in senden oder einen KI-Nudge entwerfen.",
  "help.q_pro": "Was bringt Coach Pro?", "help.a_pro": "Coach Pro senkt deine Provision auf 10%, schaltet eigenes Branding, erweiterte Analytics, Priority-WEVA und Gruppen-Tools frei.",
  "help.q_branding": "Wie nutze ich mein eigenes Branding?", "help.a_branding": "Mit Coach Pro kannst du unter Einstellungen → Custom Branding dein Logo, deine Markenfarbe und eine E-Mail-Fußzeile hinterlegen.",
  "help.q_refunds": "Wie funktionieren Rückerstattungen?", "help.a_refunds": "Unter Einstellungen → Stornierung & Rückerstattung legst du eigene Stufen fest. Beachte: Stripe-Gebühren werden nicht erstattet und gehen von deiner Auszahlung ab.",
  "help.contact_sub": "Keine Antwort gefunden? Schreib uns direkt.", "help.contact_cta": "Support kontaktieren",

  // Tour
  "tour.meta_title": "Rundgang", "tour.eyebrow": "Willkommen", "tour.title": "Dein Coach-Rundgang", "tour.subtitle": "Die wichtigsten Stationen deines Dashboards in 5 Schritten.", "tour.step_n": "Schritt {n}",
  "tour.clients_title": "Klient:innen begleiten", "tour.clients_sub": "Puls prüfen, stille Klient:innen erkennen & warm nachfassen.",
  "tour.plans_title": "Pläne & Programme", "tour.plans_sub": "Tagespläne zuweisen und Atem-Programme teilen.",
  "tour.offerings_title": "Angebote verkaufen", "tour.offerings_sub": "Sitzungen, Pakete & Affiliate-Angebote einrichten.",
  "tour.circles_title": "Kreise aufbauen", "tour.circles_sub": "Inner & Local Circle für wiederkehrende Einnahmen.",
  "tour.analytics_title": "Wachstum messen", "tour.analytics_sub": "Analytics-Deepdive zu Umsatz, WEVA & Bindung.",
  "tour.cta_sub": "Bereit? Schließe deine Einrichtung ab.", "tour.cta": "Zur Coach-Einrichtung",

  // Inner-Circle-Einladungen
  "ici.meta_title": "Inner-Circle-Einladungen", "ici.back": "Inner Circle", "ici.eyebrow": "Inner Circle", "ici.title": "Einladungen verwalten",
  "ici.subtitle": "Lade Klient:innen in deinen Inner Circle ein und verfolge Annahmen.",
  "ici.stat_sent": "Gesendet", "ici.stat_accept_rate": "Annahmerate", "ici.stat_active": "Aktive Abos", "ici.stat_retention": "30-Tage-Bindung",
  "ici.invite_title": "Per E-Mail einladen", "ici.emails_ph": "E-Mail-Adressen, durch Komma oder Zeile getrennt", "ici.note_ph": "Persönliche Notiz (optional, max. 200 Zeichen)",
  "ici.send": "Einladungen senden", "ici.sent": "{n} Einladungen gesendet.", "ici.err_email": "Bitte mindestens eine gültige E-Mail angeben.",
  "ici.list_title": "Gesendete Einladungen", "ici.empty": "Noch keine Einladungen gesendet.",
  "ici.status_pending": "Ausstehend", "ici.status_accepted": "Angenommen", "ici.status_revoked": "Zurückgezogen",

  // Kollektive
  "col2.meta_title": "Kollektive", "col2.eyebrow": "Kollaboration", "col2.title": "Kollektive", "col2.subtitle": "Schließe dich mit anderen Coaches zu einer Allianz mit geteilten Umsätzen zusammen.",
  "col2.new": "Neues Kollektiv", "col2.new_desc": "Gib deinem Kollektiv einen Namen und eine Beschreibung.",
  "col2.f_name": "Name", "col2.f_name_ph": "z. B. Breathwork-Allianz Wien", "col2.f_desc": "Beschreibung", "col2.f_desc_ph": "Worum geht es in diesem Kollektiv?", "col2.f_cover": "Titelbild",
  "col2.err_name": "Bitte einen Namen angeben.", "col2.created": "Kollektiv erstellt.", "col2.empty_title": "Noch keine Kollektive", "col2.empty_sub": "Erstelle ein Kollektiv oder warte auf eine Einladung.",
  "col2.members_n": "{n} Mitglieder", "col2.owner": "Inhaber:in", "col2.status_draft": "Entwurf", "col2.status_active": "Aktiv", "col2.status_archived": "Archiviert",
  "col2.detail_meta": "Kollektiv", "col2.you_invited": "Du wurdest zu diesem Kollektiv eingeladen.", "col2.accept": "Annehmen", "col2.decline": "Ablehnen", "col2.resp_accepted": "Angenommen.", "col2.resp_declined": "Abgelehnt.",
  "col2.members": "Mitglieder", "col2.invite": "Einladen", "col2.share_pct": "{pct}% Umsatzanteil", "col2.mstatus_invited": "Eingeladen", "col2.mstatus_declined": "Abgelehnt",
  "col2.publish": "Veröffentlichen", "col2.archive": "Archivieren", "col2.saved": "Gespeichert.", "col2.invited": "Eingeladen.", "col2.err_email": "Bitte eine gültige E-Mail angeben.",
  "col2.invite_title": "Coach einladen", "col2.invite_email": "Coach-E-Mail", "col2.invite_share": "Umsatzanteil %",

  // Klient:innen-Erfolge
  "win.meta_title": "Klient:innen-Erfolge", "win.eyebrow": "Social", "win.title": "Klient:innen-Erfolge", "win.subtitle": "Verwandle echte Fortschritte in Erfolgsgeschichten — mit Einwilligung deiner Klient:innen.",
  "win.suggestions": "KI-Vorschläge", "win.suggestions_empty": "Aktuell keine Vorschläge. Sie erscheinen, wenn Klient:innen messbare Fortschritte machen.", "win.create": "Als Win erstellen", "win.requested": "Erstellt — zur Freigabe an Klient:in gesendet.",
  "win.my_wins": "Deine Wins", "win.empty": "Noch keine Wins erstellt.", "win.delete_confirm": "Diesen Win wirklich löschen?", "win.deleted": "Gelöscht.",
  "win.pending": "Warte auf Freigabe", "win.approved": "Freigegeben", "win.private": "Privat",

  // Fachprofil-Fortschritt
  "pon.meta_title": "Fachprofil", "pon.eyebrow": "Profil", "pon.title": "Fachprofil & Fortschritt", "pon.subtitle": "Vervollständige dein Fachprofil, damit Klient:innen dir vertrauen.", "pon.progress": "{done} von {total} Bereichen ausgefüllt",
  "pon.step_profession": "Hauptberuf gewählt", "pon.step_methods": "Methoden hinzugefügt", "pon.step_focus": "Schwerpunkte gewählt", "pon.step_qualifications": "Qualifikationen hinterlegt", "pon.step_languages": "Sprachen gewählt", "pon.step_certificates": "Zertifikat hochgeladen",
  "pon.certificates": "Zertifikate", "pon.cert_add": "Hochladen", "pon.cert_empty": "Noch keine Zertifikate. PDF, JPG oder PNG (max. 20 MB).", "pon.cert_uploaded": "Zertifikat hochgeladen.", "pon.cert_fail": "Upload fehlgeschlagen.", "pon.cert_delete_confirm": "Dieses Zertifikat wirklich löschen?", "pon.cert_deleted": "Gelöscht.", "pon.edit_in_profile": "Fachprofil im Profil bearbeiten",

  // EVA-Nudge (Klient-Detail)
  "nudge.title": "KI-Nudge entwerfen", "nudge.hint": "Lass WEVA eine warme, kurze Nachricht auf Basis der letzten Reflexion deiner:s Klient:in entwerfen. Du prüfst & sendest selbst.",
  "nudge.generate": "Nudge entwerfen", "nudge.regenerate": "Neu entwerfen", "nudge.generating": "Entwerfe…", "nudge.failed": "Konnte gerade keinen Nudge entwerfen.", "nudge.theme": "Thema", "nudge.copy": "Kopieren", "nudge.send_hint": "Tipp: Kopiere den Text und sende ihn über deine Nachrichten an die:den Klient:in.",
  "nav.coach_hub": "Coaches",
  "nav.group.book": "Buchen",
  "nav.my_bookings": "Buchungen",
  "bkc.hub_title": "Coaches & Buchen",
  "bkc.hub_sub": "Deine Begleiter:innen und ihre buchbaren Angebote.",
  "bkc.my_coaches": "Meine Coaches",
  "bkc.no_coaches": "Noch keine Coaches",
  "bkc.no_coaches_sub": "Entdecke passende Begleitung und buche deine erste Session.",
  "bkc.browse_all": "Alle Coaches entdecken",
  "bkc.view_profile": "Profil ansehen",
  "bkc.offerings": "Angebote",
  "bkc.no_products": "Keine buchbaren Angebote.",
  "bkc.book_cta": "Buchen",
  "bkc.group": "Gruppe",
  "bkc.min": "Min.",
  "bkc.with_coach": "mit {name}",
  "bkc.back": "Zurück",
  "bkc.pick_date": "Datum wählen",
  "bkc.slots": "Verfügbare Zeiten",
  "bkc.no_slots": "Keine freien Zeiten an diesem Tag.",
  "bkc.payment": "Zahlung",
  "bkc.pay_credits": "{n} Credits",
  "bkc.pay_card": "Karte",
  "bkc.confirm_credits": "Mit {n} Credits buchen",
  "bkc.confirm_card": "Für {amount} buchen",
  "bkc.select_slot_first": "Bitte wähle zuerst eine Zeit.",
  "bkc.checkout_opened": "Checkout in neuem Tab geöffnet …",
  "bkc.booked": "Buchung bestätigt!",
  "bkc.book_failed": "Buchung fehlgeschlagen.",
  "bkc.product_not_found": "Angebot nicht gefunden.",
  "bkc.bookings_title": "Meine Buchungen",
  "bkc.bookings_sub": "Deine kommenden und vergangenen Sessions.",
  "bkc.upcoming": "Bevorstehend",
  "bkc.past": "Vergangen",
  "bkc.none": "Noch keine Buchungen",
  "bkc.none_sub": "Buche deine erste Session mit einem Coach.",
  "bkc.no_upcoming": "Keine bevorstehenden Buchungen.",
  "bkc.no_past": "Noch keine vergangenen Sessions.",
  "bkc.open_details": "Details",
  "bkc.join_zoom": "Zoom beitreten",
  "bkc.cancel": "Stornieren",
  "bkc.cancel_request": "Stornierung anfragen",
  "bkc.cancel_confirm": "Diese Buchung wirklich stornieren?",
  "bkc.cancel_sent": "Stornierungsanfrage gesendet.",
  "bkc.marketplace": "Marktplatz",
  "bkc.status_confirmed": "Bestätigt",
  "bkc.status_paid": "Bezahlt",
  "bkc.status_pending": "Ausstehend",
  "bkc.status_payment_pending": "Zahlung offen",
  "bkc.status_cancelled": "Storniert",
  "bkc.status_pending_cancellation": "Storno angefragt",
  "bkc.status_cancelled_refunded": "Storniert · erstattet",
  "bkc.status_cancelled_no_refund": "Storniert · keine Erstattung",
  "bkc.status_cancelled_refund_pending": "Storniert · Erstattung offen",
  "bkc.refund_title": "Stornobedingungen",
  "bkc.refund_intro": "So viel würdest du bei Stornierung jetzt zurückerhalten:",
  "bkc.refund_tier_72": "Mehr als 72 Std. vorher · 100 %",
  "bkc.refund_tier_24": "24–72 Std. vorher · 50 %",
  "bkc.refund_tier_now": "Weniger als 24 Std. vorher · 0 %",
  "bkc.refund_you_get": "Du erhältst zurück",
  "bkc.refund_pct": "{pct}% Rückerstattung",
  "bkc.refund_amount": "≈ {amount}",
  "bkc.refund_hours_left": "noch {hours} Std. bis zur Session",
  "bkc.refund_note": "Die endgültige Erstattung bestätigt dein Coach.",
  "bkc.reason_ph": "Grund (optional)",
  "bkc.submit_cancel": "Stornierung anfragen",
  "bkc.session_title": "Session",
  "bkc.session_not_found": "Session nicht gefunden.",
  "bkc.when": "Wann",
  "bkc.where": "Wo",
  "bkc.your_coach": "Dein Coach",
  "bkc.virtual": "Online-Session",
  "bkc.join_meeting": "Meeting beitreten",
  "bkc.link_tba": "Link folgt noch.",
  "bkc.in_person": "Vor Ort",
  "bkc.location_tba": "Ort folgt noch.",
  "bkc.in_person_hint": "Dein Coach teilt dir die genaue Adresse mit.",
  "bkc.time_tba": "Termin folgt",
  "bkc.note_title": "Deine Notiz für den Coach",
  "bkc.note_hint": "Teile vorab, woran du arbeiten möchtest.",
  "bkc.note_ph": "Worum soll es in der Session gehen?",
  "bkc.note_saved_at": "Gespeichert am {when}",
  "bkc.save": "Speichern",
  "bkc.clear": "Löschen",
  "bkc.saved": "Gespeichert.",
  "bkc.cancel_policy": "Stornierung: aktuell {pct}% Rückerstattung.",
  "bkc.duration_min": "{n} Min.",
  "bkc.email": "E-Mail",
  "bkc.phone": "Anrufen",

  // Session booking (sb)
  "sb.title": "Session buchen",
  "sb.back": "Zurück",
  "sb.not_found": "Coach nicht gefunden.",
  "sb.pick_offering": "Angebot wählen",
  "sb.no_offerings": "Dieser Coach hat aktuell keine buchbaren Angebote.",
  "sb.minutes": "{n} Min.",
  "sb.credits_label": "Credits",
  "sb.payment": "Zahlungsart",
  "sb.pay_credits": "Mit Credits zahlen",
  "sb.pay_card": "Mit Karte zahlen",
  "sb.credits_balance": "Guthaben: {balance} Credits",
  "sb.credits_insufficient": "Es fehlen {need} Credits (du hast {have}).",
  "sb.add_credits": "Credits aufladen",
  "sb.preferred_time": "Wunschtermin",
  "sb.available_times": "Verfügbare Zeiten",
  "sb.no_slots_day": "Keine freien Slots an diesem Tag — probiere ein anderes Datum.",
  "sb.note_title": "Kurze Notiz (optional)",
  "sb.note_ph": "Was möchtest du besprechen?",
  "sb.legal": "Einmalige Abrechnungsprüfung. Der Coach bestätigt, sobald die Zahlung durch ist.",
  "sb.confirm_credits": "Für {credits} Credits buchen",
  "sb.confirm_card": "Für {amount} buchen",
  "sb.confirm_insufficient": "Nicht genug Credits",
  "sb.booked": "Deine Session ist reserviert 💛",
  "sb.book_failed": "Buchung fehlgeschlagen.",

  // Collab packages (cov)
  "cov.packages_title": "Collab-Pakete",
  "cov.packages_sub": "Von mehreren Coaches gemeinsam gestaltete Pakete.",
  "cov.none": "Aktuell sind keine Collab-Pakete verfügbar.",
  "cov.not_found": "Paket nicht gefunden.",
  "cov.coaches": "Coaches",
  "cov.included": "Enthalten",
  "cov.kind_training": "Training",
  "cov.kind_one_on_one": "1:1-Session",
  "cov.kind_product": "Produkt",
  "cov.min": "Min.",
  "cov.capacity": "{n} von {total} frei",
  "cov.total": "Gesamt",
  "cov.payment": "Zahlung",
  "cov.balance": "Guthaben: {balance}",
  "cov.insufficient": "Es fehlen {need} (du hast {have}).",
  "cov.add_credits": "Credits aufladen",
  "cov.book_credits": "Für {credits} Credits buchen",
  "cov.book_card": "Für {amount} buchen",
  "cov.full": "Ausgebucht",
  "cov.book_failed": "Buchung fehlgeschlagen.",
  "cov.booked_title": "Paket gebucht",
  "cov.booked_sub": "Alles bereit. Deine Coaches wurden benachrichtigt.",
  "cov.booked_blocks": "Dein Paket",
  "cov.booked_ready": "Bereit",
  "cov.booked_slot": "Termin: {when}",
  "cov.booked_slot_pending": "Termin noch offen",
  "cov.booked_home": "Zu meinen Buchungen",
  "cov.slot_title": "Termine wählen",
  "cov.slot_sub": "Lege für jede 1:1-Session einen Termin fest.",
  "cov.slot_all_done": "Alle Termine festgelegt",
  "cov.slot_pending": "{n} Termin(e) offen",
  "cov.slot_pick_coach": "Coach wählen",
  "cov.slot_pick_slot": "Termin wählen",
  "cov.slot_none": "Keine freien Termine.",
  "cov.slot_save": "Termin speichern",
  "cov.slot_saved": "Festgelegte Termine",
  "cov.slot_skip": "Später erledigen",
  "cov.slot_done": "Fertig",

  // Deep Within + Journal + Practices (Welle 1)
  "nav.deep_within": "Deep Within",
  "nav.journal": "Journal",
  "dw.title": "Deep Within",
  "dw.subtitle": "Dein Raum, um dich selbst zu erkennen, zu benennen und loszulassen.",
  "dw.in_progress": "in sanfter Arbeit",
  "dw.transformed": "transformiert",
  "dw.hero_practices_title": "Erkennen · Benennen · Loslassen",
  "dw.hero_practices_sub": "Geführte Praktiken, um Gefühltes zu wandeln.",
  "dw.hero_journal_title": "Journaling",
  "dw.hero_journal_sub": "Schreib dich frei — Tag für Tag.",
  "dw.soon": "Bald verfügbar",
  "dw.buckets_heading": "Deine Bereiche",
  "dw.entries": "{n} Einträge",
  "dw.not_found": "Bereich nicht gefunden.",
  "dw.add": "Hinzufügen",
  "dw.edit": "Bearbeiten",
  "dw.delete": "Löschen",
  "dw.save": "Speichern",
  "dw.cancel": "Abbrechen",
  "dw.saved": "Gespeichert.",
  "dw.save_failed": "Speichern fehlgeschlagen.",
  "dw.deleted": "Gelöscht.",
  "dw.delete_failed": "Löschen fehlgeschlagen.",
  "dw.delete_confirm": "Diesen Eintrag wirklich löschen?",
  "dw.primary_required": "Bitte fülle das Hauptfeld aus.",
  "dw.tab_own": "Eigene",
  "dw.tab_weva": "WEVA",
  "dw.tab_all": "Alle",
  "dw.tab_progress": "In sanfter Arbeit",
  "dw.tab_transformed": "Transformiert",
  "dw.empty_title": "Noch nichts hier",
  "dw.empty_sub": "Lege deinen ersten Eintrag an, wenn du bereit bist.",
  "dw.status_label": "Status",
  "dw.status_open": "Offen",
  "dw.status_in_progress": "In Arbeit",
  "dw.status_transformed": "Transformiert",
  "dw.weva_toggle": "In WEVA-Reflexion einbeziehen",
  "dw.readonly_weva": "Von WEVA erkannt — nur Status & WEVA-Schalter änderbar.",
  "dw.show_details": "Weitere Details",
  "dw.hide_details": "Details ausblenden",
  "dw.f.reframe": "Neue, stärkende Formulierung",
  "dw.f.reframe_ph": "Wie möchtest du es stattdessen sehen?",
  "dw.f.frequency": "Häufigkeit",
  "dw.f.origin": "Ursprung",
  "dw.f.body_location": "Körperstelle",
  "dw.f.physical_pain": "Körperliche Empfindung",
  "dw.f.applied_practice": "Angewandte Praxis",
  "dw.ul.title": "Upper Limit",
  "dw.ul.title_ph": "Wie bremst du dich, wenn es gut läuft?",
  "dw.ul.life_area": "Lebensbereich",
  "dw.ul.symptoms": "Symptome",
  "dw.ul.symptoms_ph": "z. B. Sorgen, Streit (Komma-getrennt)",
  "dw.ul.trigger": "Auslöser",
  "dw.ul.core_false_belief": "Zugrundeliegender Glaubenssatz",
  "dw.ul.zone_of_genius_impact": "Auswirkung auf deine Genialität",
  "dw.beliefs.title": "Glaubenssätze",
  "dw.beliefs.sub": "Überzeugungen, die dich prägen",
  "dw.beliefs.field": "Glaubenssatz",
  "dw.beliefs.ph": "Was glaubst du über dich oder die Welt?",
  "dw.fears.title": "Ängste",
  "dw.fears.sub": "Was dich zurückhält",
  "dw.fears.field": "Angst",
  "dw.fears.ph": "Wovor hast du Angst?",
  "dw.surroundings.title": "Umfeld",
  "dw.surroundings.sub": "Menschen & Orte um dich",
  "dw.surroundings.field": "Umfeld",
  "dw.surroundings.ph": "Welcher Teil deines Umfelds beschäftigt dich?",
  "dw.dreams.title": "Träume",
  "dw.dreams.sub": "Wohin du dich sehnst",
  "dw.dreams.field": "Traum",
  "dw.dreams.ph": "Wovon träumst du?",
  "dw.values.title": "Werte",
  "dw.values.sub": "Was dir wichtig ist",
  "dw.values.field": "Wert",
  "dw.values.ph": "Welcher Wert leitet dich?",
  "dw.strengths.title": "Stärken",
  "dw.strengths.sub": "Worauf du bauen kannst",
  "dw.strengths.field": "Stärke",
  "dw.strengths.ph": "Welche Stärke trägst du in dir?",
  "dw.habits.title": "Gewohnheiten",
  "dw.habits.sub": "Deine täglichen Muster",
  "dw.habits.field": "Gewohnheit",
  "dw.habits.ph": "Welche Gewohnheit möchtest du betrachten?",
  "dw.boundaries.title": "Grenzen",
  "dw.boundaries.sub": "Was du schützt",
  "dw.boundaries.field": "Grenze",
  "dw.boundaries.ph": "Welche Grenze möchtest du setzen?",
  "dw.upper-limits.title": "Upper Limits",
  "dw.upper-limits.sub": "Wo du dich selbst bremst",
  "jr.title": "Journal",
  "jr.subtitle": "Ein ruhiger Ort für deine Gedanken.",
  "jr.new_ph": "Was bewegt dich gerade?",
  "jr.mood": "Stimmung",
  "jr.weva": "In WEVA einbeziehen",
  "jr.save": "Eintrag speichern",
  "jr.saved": "Eintrag gespeichert.",
  "jr.save_failed": "Speichern fehlgeschlagen.",
  "jr.empty_err": "Bitte schreibe zuerst etwas.",
  "jr.empty_title": "Noch keine Einträge",
  "jr.empty_sub": "Dein erster Eintrag wartet auf dich.",
  "jr.delete": "Löschen",
  "jr.delete_confirm": "Diesen Eintrag wirklich löschen?",
  "jr.deleted": "Eintrag gelöscht.",
  "pr.title": "Erkennen · Benennen · Loslassen",
  "pr.subtitle": "Geführte, evidenzbasierte Praktiken, um Gefühltes sicher zu wandeln. Kommt in einer der nächsten Wellen.",
  "pr.soon": "Bald verfügbar",
  "pr.pillar_realize": "Erkennen",
  "pr.pillar_designate": "Benennen",
  "pr.pillar_release": "Loslassen",

  // Practices (Erkennen·Benennen·Loslassen) — ported from mobile
  "back": "Zurück",
  "body_arms": "Arme",
  "body_belly": "Bauch",
  "body_chest": "Brust",
  "body_face": "Gesicht",
  "body_feet": "Füße",
  "body_head": "Kopf",
  "body_heart": "Herz",
  "body_hips": "Hüften",
  "body_legs": "Beine",
  "body_lower_back": "Unterer Rücken",
  "body_mark_neutral": "Neutral",
  "body_mark_open": "Offen",
  "body_mark_tense": "Angespannt",
  "body_pelvis": "Becken",
  "body_shoulders": "Schultern",
  "body_solar_plexus": "Solarplexus",
  "body_throat": "Kehle",
  "body_upper_back": "Oberer Rücken",
  "bodymap_hint": "Tippe eine Region an: angespannt → neutral → offen.",
  "emdr_hint": "Hole die Erinnerung oder das Gefühl in den Sinn und folge dem Punkt.",
  "emdr_rounds": "Runden",
  "emdr_min_rounds": "Mindestens 10 Runden zum Fortfahren ({n}/10)",
  "emdr_speed": "Geschwindigkeit",
  "emdr_speed_fast": "Schnell",
  "emdr_speed_med": "Mittel",
  "emdr_speed_slow": "Langsam",
  "emo_abandoned": "verlassen",
  "emo_accomplished": "erfüllt",
  "emo_aching": "schmerzend",
  "emo_amazed": "erstaunt",
  "emo_anger": "Wut",
  "emo_annoyed": "genervt",
  "emo_anxious": "ängstlich",
  "emo_ashamed": "beschämt",
  "emo_betrayed": "verraten",
  "emo_bitter": "bitter",
  "emo_cherished": "geliebt",
  "emo_confident": "selbstsicher",
  "emo_confused": "verwirrt",
  "emo_connected": "verbunden",
  "emo_contemptuous": "verachtend",
  "emo_content": "zufrieden",
  "emo_critical": "kritisch",
  "emo_curious": "neugierig",
  "emo_defeated": "geschlagen",
  "emo_disappointed": "enttäuscht",
  "emo_disgust": "Ekel",
  "emo_disoriented": "desorientiert",
  "emo_disrespected": "respektlos behandelt",
  "emo_eager": "eifrig",
  "emo_embarrassed": "peinlich berührt",
  "emo_empty": "leer",
  "emo_energized": "energiegeladen",
  "emo_enraged": "rasend",
  "emo_excited": "aufgeregt",
  "emo_exposed": "entblößt",
  "emo_fear": "Angst",
  "emo_frozen": "erstarrt",
  "emo_frustrated": "frustriert",
  "emo_furious": "wütend",
  "emo_grateful": "dankbar",
  "emo_grief": "trauernd",
  "emo_guilty": "schuldig",
  "emo_hateful": "hasserfüllt",
  "emo_heartbroken": "gebrochen",
  "emo_helpless": "hilflos",
  "emo_hopeless": "hoffnungslos",
  "emo_hostile": "feindselig",
  "emo_hurt": "verletzt",
  "emo_impatient": "ungeduldig",
  "emo_inadequate": "ungenügend",
  "emo_insecure": "unsicher",
  "emo_intrigued": "fasziniert",
  "emo_irritated": "gereizt",
  "emo_isolated": "isoliert",
  "emo_jealous": "eifersüchtig",
  "emo_jolted": "durchgerüttelt",
  "emo_joy": "Freude",
  "emo_judgmental": "urteilend",
  "emo_lonely": "einsam",
  "emo_lost": "verloren",
  "emo_loving": "liebevoll",
  "emo_mourning": "trauernd",
  "emo_nauseated": "übel",
  "emo_open": "offen",
  "emo_overwhelmed": "überwältigt",
  "emo_paralyzed": "gelähmt",
  "emo_peaceful": "friedlich",
  "emo_perplexed": "ratlos",
  "emo_powerless": "ohnmächtig",
  "emo_primary": "Primär",
  "emo_proud": "stolz",
  "emo_repulsed": "abgestoßen",
  "emo_resentful": "grollend",
  "emo_restless": "unruhig",
  "emo_revolted": "angewidert",
  "emo_sadness": "Trauer",
  "emo_scared": "erschrocken",
  "emo_secondary": "Sekundär",
  "emo_seen": "gesehen",
  "emo_shocked": "geschockt",
  "emo_small": "klein",
  "emo_specific": "Spezifisch",
  "emo_startled": "erschrocken",
  "emo_superior": "überlegen",
  "emo_surprise": "Überraschung",
  "emo_tearful": "tränenreich",
  "emo_tender": "zärtlich",
  "emo_terrified": "verängstigt",
  "emo_threatened": "bedroht",
  "emo_thrilled": "begeistert",
  "emo_trapped": "gefangen",
  "emo_unfair": "unfair",
  "emo_unseen": "ungesehen",
  "emo_unworthy": "unwürdig",
  "emo_violent": "gewalttätig",
  "emo_warm": "warm",
  "emo_worried": "besorgt",
  "favorite": "Favorit",
  "p_abc_a_label": "A — Was ist passiert? (nur Fakten)",
  "p_abc_a_ph": "Meine Chefin sagte…",
  "p_abc_b_label": "B — Was habe ich daraus gemacht?",
  "p_abc_b_ph": "Dass ich nicht kompetent bin…",
  "p_abc_c_label": "C — Wie habe ich mich gefühlt und gehandelt?",
  "p_abc_c_ph": "Ich erstarrte, ging aus dem Weg…",
  "p_abc_dispute_label": "Ist B objektiv wahr? Welche Lesart gibt es noch?",
  "p_abc_dispute_ph": "Vielleicht war sie auch gestresst…",
  "p_abc_intro_body": "A (Auslöser) → B (Bewertung / Glaubenssatz) → C (Konsequenz). Die Magie liegt bei B.",
  "p_abc_intro_title": "Sieh die Abfolge",
  "p_abc_model": "ABC-Modell",
  "p_abc_model_desc": "Auslöser → Bewertung → Konsequenz. Sieh die Abfolge.",
  "p_abc_newc_label": "Wenn ich den neuen Glaubenssatz hätte — wie sähe C aus?",
  "p_abc_title": "ABC-Modell",
  "p_body_scan": "Körperscan",
  "p_body_scan_bodymap_hint": "Tippe jede Region an, um ihren Zustand zu markieren.",
  "p_body_scan_bodymap_label": "Wo spürst Du es?",
  "p_body_scan_desc": "Von Kopf bis Fuß spüren und markieren, was Aufmerksamkeit will.",
  "p_body_scan_intro_body": "Bewege Deine Aufmerksamkeit langsam vom Scheitel zu den Sohlen. Markiere, was verspannt, neutral oder offen ist.",
  "p_body_scan_intro_title": "Von Scheitel bis Sohle spüren",
  "p_body_scan_invite_breath": "Angeatmet werden",
  "p_body_scan_invite_label": "Was möchte diese Stelle?",
  "p_body_scan_invite_movement": "Bewegung",
  "p_body_scan_invite_stillness": "Nur Präsenz",
  "p_body_scan_invite_touch": "Eine fürsorgliche Hand",
  "p_body_scan_invite_words": "Warme Worte",
  "p_body_scan_mood_after": "Nachher",
  "p_body_scan_mood_before": "Vorher",
  "p_body_scan_sensation_label": "Was ist die deutlichste Empfindung?",
  "p_body_scan_sensation_ph": "Ein enger Ring um meine Kehle…",
  "p_body_scan_title": "Körper-Scan",
  "p_cb_after": "Nachher",
  "p_cb_before": "Vorher",
  "p_cb_dur_20": "20 Min.",
  "p_cb_dur_30": "30 Min.",
  "p_cb_dur_40": "40 Min.",
  "p_cb_dur_starter": "10 Min. (Einstieg)",
  "p_cb_duration_label": "Sitzungsdauer",
  "p_cb_exp_calm": "Tiefe Ruhe",
  "p_cb_exp_heat": "Hitze / Kälte",
  "p_cb_exp_images": "Lebendige Bilder",
  "p_cb_exp_movement": "Körper wollte sich bewegen",
  "p_cb_exp_nothing": "Nichts Dramatisches",
  "p_cb_exp_tears": "Tränen",
  "p_cb_exp_tetany": "Kribbeln / Tetanie",
  "p_cb_experience_label": "Was tauchte während des Atmens auf? (danach markieren)",
  "p_cb_intention_label": "Deine Absicht für diese Sitzung",
  "p_cb_intention_ph": "Trauer fließen lassen…",
  "p_cb_intro_body": "Durchgängiges Ein- und Ausatmen ohne Pause. Am besten begleitet durch eine Facilitator oder eine geführte Session. 20–40 Minuten.",
  "p_cb_intro_title": "Kreisatmung",
  "p_cb_posture_bed": "Auf Bett / Matte",
  "p_cb_posture_chair": "Sitzend auf einem Stuhl",
  "p_cb_posture_floor": "Boden",
  "p_cb_posture_label": "Wo wirst Du liegen oder sitzen?",
  "p_cb_reflection_label": "Reflexion",
  "p_cb_title": "Verbundene Atemarbeit",
  "p_cognitive_restructuring": "Kognitive Umstrukturierung",
  "p_cognitive_restructuring_desc": "Einen schweren Gedanken prüfen, einen leichteren wählen.",
  "p_connected_breath": "Verbundenes Atmen",
  "p_connected_breath_desc": "Kreisförmige Atmung, um festgehaltene Emotionen zu bewegen.",
  "p_core_deeper1_label": "Wenn es das voll bekäme — was gäbe ihm das?",
  "p_core_deeper1_ph": "Vielleicht Sicherheit.",
  "p_core_deeper2_label": "Und wenn es DAS voll bekäme?",
  "p_core_integration_label": "Wie verändert sich die ursprüngliche Reaktion, wenn Du das schon hast?",
  "p_core_intro_body": "Frage jede Reaktion: „Wenn Du alles bekommst, was Du willst — was gäbe mir das?\" — bis Du einen Kernzustand erreichst (Frieden, Liebe, Sein).",
  "p_core_intro_title": "Folge dem Weg nach Hause",
  "p_core_state_being": "Sein / Okness",
  "p_core_state_label": "Welcher Kernzustand fühlt sich am nächsten an?",
  "p_core_state_love": "Liebe",
  "p_core_state_oneness": "Einheit",
  "p_core_state_peace": "Frieden",
  "p_core_transformation": "Core Transformation",
  "p_core_transformation_desc": "Einer Reaktion bis zu ihrer tiefsten positiven Absicht folgen.",
  "p_core_transformation_title": "Kern-Transformation",
  "p_core_trigger_label": "Mit welcher Reaktion arbeitest Du?",
  "p_core_trigger_ph": "Wenn meine Partnerschaft meine Nachrichten ignoriert, werde ich wütend…",
  "p_core_want_label": "Was möchte dieser Teil?",
  "p_core_want_ph": "Ich möchte gesehen werden.",
  "p_cr_balanced_label": "Ein ausgeglichenerer Gedanke",
  "p_cr_balanced_ph": "Manchmal habe ich es schwer UND ich bin schon durch schwere Zeiten gewachsen.",
  "p_cr_belief_after": "Wie wahr fühlt sich der ausgeglichene Gedanke jetzt an?",
  "p_cr_belief_before": "Wie wahr fühlt er sich an? (1 niedrig – 10 hoch)",
  "p_cr_dist_all_or_nothing": "Alles-oder-Nichts",
  "p_cr_dist_catastrophizing": "Katastrophisieren",
  "p_cr_dist_label": "Welche kognitiven Verzerrungen spielen mit?",
  "p_cr_dist_labeling": "Etikettieren",
  "p_cr_dist_mind_reading": "Gedankenlesen",
  "p_cr_dist_personalizing": "Personalisieren",
  "p_cr_dist_should": "\"Sollte\"-Aussagen",
  "p_cr_evidence_against": "Beweise GEGEN den Gedanken",
  "p_cr_evidence_for": "Beweise FÜR den Gedanken",
  "p_cr_heavy_label": "Schreibe den schweren Gedanken auf",
  "p_cr_heavy_ph": "Ich werde nie gut genug sein…",
  "p_cr_intro_body": "Ein schwerer Gedanke ist keine Tatsache. Wiege ihn ab, dann wähle einen wahreren.",
  "p_cr_intro_title": "Prüfe den Gedanken",
  "p_cr_title": "Kognitive Umstrukturierung",
  "p_dream_log": "Traumtagebuch",
  "p_dream_log_desc": "Träume festhalten - Symbole, Gefühle, Übergänge.",
  "p_dream_log_intro_body": "Träume verblassen in Minuten. Schreibe auf, was Du erinnerst — auch Fragmente tragen Bedeutung.",
  "p_dream_log_intro_title": "Fange den Faden ein",
  "p_dream_log_narrative_label": "Erzähle ihn — wenn möglich, in der Gegenwart.",
  "p_dream_log_narrative_ph": "Ich gehe durch…",
  "p_dream_log_question_label": "Welche Frage stellt dieser Traum?",
  "p_dream_log_question_ph": "…",
  "p_dream_log_sym_animal": "Tier",
  "p_dream_log_sym_fire": "Feuer",
  "p_dream_log_sym_house": "Haus / Raum",
  "p_dream_log_sym_light": "Licht / Dunkel",
  "p_dream_log_sym_person": "Person",
  "p_dream_log_sym_threshold": "Schwelle / Tür",
  "p_dream_log_sym_vehicle": "Fahrzeug",
  "p_dream_log_sym_water": "Wasser",
  "p_dream_log_symbols_hint": "Wähle so viele, wie passen.",
  "p_dream_log_symbols_label": "Symbole, die auffielen",
  "p_dream_log_title": "Traumtagebuch",
  "p_dream_log_title_label": "Ein kurzer Titel für diesen Traum",
  "p_dream_log_title_ph": "Die endlose Treppe",
  "p_dream_log_tone_grieving": "Trauernd",
  "p_dream_log_tone_joyful": "Freudig",
  "p_dream_log_tone_label": "Das Grundgefühl war…",
  "p_dream_log_tone_mystery": "Geheimnisvoll",
  "p_dream_log_tone_peaceful": "Friedlich",
  "p_dream_log_tone_tense": "Angespannt",
  "p_emdr": "EMDR (Selbstanwendung)",
  "p_emdr_desc": "Bilaterale Stimulation mit Erinnerung oder Gefühl.",
  "p_emdr_intro_body": "Dies ist eine Selbstanwendungs-Anpassung von EMDR — für sanften Alltagsstress, nicht für tiefes Trauma. Für letzteres wende Dich an eine approbierte Fachperson.",
  "p_emdr_intro_title": "Bilaterale Stimulation",
  "p_emdr_session_hint": "Absolviere 1–3 Sets à 20–30 Runden. Zwischen den Sets atme und lass Bilder treiben.",
  "p_emdr_session_label": "Beobachte den Punkt, während Du das Ziel im Sinn hältst",
  "p_emdr_shift_label": "Was hat sich in Bild, Körper oder Gedanken verschoben?",
  "p_emdr_suds_after": "SUDS jetzt (0 – 10)",
  "p_emdr_suds_before": "SUDS — Belastung jetzt (0 ruhig – 10 max)",
  "p_emdr_target_label": "Ziel: hole eine Erinnerung oder ein Gefühl in den Sinn",
  "p_emdr_target_ph": "Der Moment gestern, als…",
  "p_emdr_title": "EMDR (Selbstanwendung)",
  "p_emotion_wheel": "Gefühlsrad",
  "p_emotion_wheel_after": "Nachdem Du es benannt hast — wie geht es Dir?",
  "p_emotion_wheel_before": "Vorher",
  "p_emotion_wheel_desc": "Präzise benennen, was du fühlst - von weit zu spezifisch.",
  "p_emotion_wheel_intro_body": "Wenn wir es benennen können, können wir ihm begegnen. Bewege Dich von weit zu eng.",
  "p_emotion_wheel_intro_title": "Präzision verändert alles",
  "p_emotion_wheel_title": "Emotionsrad",
  "p_emotion_wheel_trigger_label": "Was hat das ausgelöst?",
  "p_emotion_wheel_trigger_ph": "Ein kurzer Satz…",
  "p_emotion_wheel_wheel_label": "Bewege Dich nach außen — allgemein → spezifisch",
  "p_inner_critic": "Der innere Kritiker",
  "p_inner_critic_desc": "Begegne der inneren Stimme - was schützt sie eigentlich?",
  "p_inner_critic_intro_body": "Der innere Kritiker ist nicht Du — er ist ein Teil von Dir, der Dich auf alte Weise zu schützen versucht. Begegne ihm, höre zu, danke ihm.",
  "p_inner_critic_intro_title": "Begegne der Stimme",
  "p_inner_critic_mood_after": "Und jetzt?",
  "p_inner_critic_mood_before": "Wie geht es Dir, bevor wir anfangen?",
  "p_inner_critic_mood_before_hint": "1 = schwer, 10 = leicht",
  "p_inner_critic_protect_hint": "Schaue unter die Härte. Welche Angst lebt dort?",
  "p_inner_critic_protect_label": "Wovor versucht er, Dich zu schützen?",
  "p_inner_critic_response_label": "Was könntest Du liebevoll zurücksagen?",
  "p_inner_critic_response_ph": "Danke, dass Du mich schützen willst. Ich höre Dich, und ich schaff das.",
  "p_inner_critic_title": "Der innere Kritiker",
  "p_inner_critic_tone_label": "In welchem Ton spricht er?",
  "p_inner_critic_tone_opt_anxious": "Ängstlich & katastrophisierend",
  "p_inner_critic_tone_opt_cold": "Kalt & abweisend",
  "p_inner_critic_tone_opt_harsh": "Hart & schneidend",
  "p_inner_critic_tone_opt_pushy": "Fordernd & drängend",
  "p_inner_critic_voice_label": "Was sagt Dein Kritiker heute zu Dir?",
  "p_inner_critic_voice_ph": "Du wirst nie…",
  "p_parts_age_label": "Wie alt fühlt er sich an?",
  "p_parts_age_ph": "7, 42 oder zeitlos",
  "p_parts_intro_body": "Du hast viele innere Teile. Wähle einen, der heute aktiv ist — gib ihm einen Namen, ein Alter, und höre zu.",
  "p_parts_intro_title": "Begegne den Teilen",
  "p_parts_message_label": "Was möchte er, dass Du weißt?",
  "p_parts_name_label": "Gib diesem Teil einen Namen",
  "p_parts_name_ph": "Die Übererfüllerin",
  "p_parts_role_exile": "Exil (trägt Schmerz)",
  "p_parts_role_firefighter": "Feuerwehrmann/-frau",
  "p_parts_role_label": "Welche Rolle hat er?",
  "p_parts_role_manager": "Managerin / Planerin",
  "p_parts_role_protector": "Schutzfigur",
  "p_parts_role_witness": "Innere Zeugin",
  "p_parts_self_label": "Was antwortet Dein ruhiges Selbst?",
  "p_parts_self_ph": "Ich höre Dich. Danke, dass Du das trägst.",
  "p_parts_work": "Teilearbeit (Ego-States)",
  "p_parts_work_desc": "Deine inneren Anteile als Charaktere mit Rollen kennenlernen.",
  "p_parts_work_title": "Teile-Arbeit",
  "p_the_work": "The Work (Byron Katie)",
  "p_the_work_belief_label": "Schreibe den belastenden Gedanken auf",
  "p_the_work_belief_ph": "Sie sollten mich so lieben, wie ich es will.",
  "p_the_work_desc": "Vier Fragen und eine Umkehrung für einen belastenden Glaubenssatz.",
  "p_the_work_intro_body": "Bringe einen belastenden Glaubenssatz. Stelle ihm vier Fragen. Dann kehre ihn um.",
  "p_the_work_intro_title": "Vier Fragen & eine Umkehr",
  "p_the_work_q1_label": "1. Ist es wahr?",
  "p_the_work_q2_label": "2. Kannst Du absolut sicher wissen, dass es wahr ist?",
  "p_the_work_q3_label": "3. Wie reagierst Du — was passiert — wenn Du diesen Gedanken glaubst?",
  "p_the_work_q4_label": "4. Wer wärst Du ohne diesen Gedanken?",
  "p_the_work_title": "The Work (Byron Katie)",
  "p_the_work_turnaround_label": "Kehre ihn um — schreibe eine Umkehr, die sich genauso wahr, oder wahrer anfühlt.",
  "p_the_work_turnaround_ph": "Ich sollte mich so lieben, wie ich es von ihnen möchte.",
  "p_tre": "TRE",
  "p_tre_after": "Nachher",
  "p_tre_before": "Vorher",
  "p_tre_desc": "Trauma-lösende Übungen - den Körper zittern lassen.",
  "p_tre_intro_body": "TRE ermüdet den Psoas und löst den Zitterreflex. Mach es auf einer weichen Unterlage. Stopp jederzeit möglich. Nicht bei tiefem Trauma ohne Begleitung.",
  "p_tre_intro_title": "Lass den Körper zittern",
  "p_tre_reflection_label": "Was hast Du wahrgenommen?",
  "p_tre_session_hint": "Folge jeder Phase. Das Zittern ist sicher, wenn es frei fließt.",
  "p_tre_session_label": "Geführte Sitzung",
  "p_tre_title": "TRE",
  "p_yesno_no": "Nein",
  "p_yesno_unsure": "Unsicher",
  "p_yesno_yes": "Ja",
  "pillar_designate": "Benennen",
  "pillar_designate_desc": "Benennen und ordnen, was du siehst.",
  "pillar_realize": "Erkennen",
  "pillar_realize_desc": "Sehen, was wirklich da ist.",
  "pillar_release": "Loslassen",
  "pillar_release_desc": "Lass es durch dich hindurchziehen.",
  "practices_hub_subtitle": "Zwölf begleitete Praktiken über die drei Säulen.",
  "practices_hub_title": "Erkennen - Benennen - Loslassen",
  "saving": "Speichern...",
  "tre_hint": "Folge den 4 Phasen. Stopp jederzeit, wenn Du Dich unsicher fühlst.",
  "tre_intensity_lbl": "Zitter-Intensität (0 – 10)",
  "tre_phase_fatigue": "2. Wandsitz-Ermüdung",
  "tre_phase_rest": "4. Integrations-Ruhe",
  "tre_phase_tremor": "3. Zitter-Phase (liegend)",
  "tre_phase_warmup": "1. Aufwärmen (Füße, Waden)",
  "ui_continue": "Weiter",
  "ui_could_not_save": "Konnte nicht gespeichert werden",
  "ui_please_try_again": "Bitte erneut versuchen.",
  "ui_save_finish": "Speichern & abschließen",
  "unfavorite": "Favorit entfernen",
  "widget_pause": "Pause",
  "widget_resume": "Fortsetzen",
  "widget_start": "Start",
  // Deep Within tabs, insights, workings + view switcher (iter250)
  "nav.switch_to_client": "Zu meinem Bereich",
  "nav.switch_to_coach": "Zum Coach-Bereich",
  "dw.tab_practice": "Praxis",
  "dw.tab_insights": "Insights",
  "dw.tab_history": "Verlauf",
  "dw.insights_total": "Einträge gesamt",
  "dw.insights_streak_current": "Aktuelle Serie",
  "dw.insights_streak_longest": "Längste Serie",
  "dw.insights_mood_delta": "Ø Veränderung",
  "dw.insights_7d": "Letzte 7 Tage",
  "dw.insights_by_pillar": "Nach Säule",
  "dw.insights_mood": "Stimmung",
  "dw.insights_mood_before": "vorher",
  "dw.insights_mood_after": "nachher",
  "dw.insights_sources": "Quellen",
  "dw.insights_top": "Lieblingsübung",
  "dw.insights_empty_title": "Noch keine Daten",
  "dw.insights_empty_sub": "Schließe eine Übung ab oder lege einen Eintrag an — dann erscheinen hier deine Einsichten.",
  "dw.src_practices": "Übungen",
  "dw.src_goals": "Ziele",
  "dw.src_comfortzone": "Komfortzone",
  "dw.src_coping": "Coping",
  "dw.src_journal": "Journal",
  "dw.history_full_log": "Ganzer Verlauf",
  "dw.history_empty_title": "Noch keine Übungen",
  "dw.history_empty_sub": "Deine abgeschlossenen Übungen erscheinen hier.",
  "dw.workings": "Journey",
  "dw.workings_add": "Schritt",
  "dw.workings_none": "Noch keine Schritte in dieser Journey.",
  "dw.working_saved": "Schritt gespeichert.",
  "dw.working_title": "Journey-Schritt",
  "dw.working_sub": "Halte fest, was sich beim Arbeiten verändert hat.",
  "dw.working_intensity": "Intensität",
  "dw.working_success": "Erfolgsgefühl",
  "dw.working_reflection": "Was hat sich verändert?",
  "dw.working_still": "Ich arbeite noch daran",
  "dw.working_hint_progress": "Bleibt in sanfter Arbeit.",
  "dw.working_hint_done": "Wird als transformiert markiert.",
  "practices_history_title": "Übungs-Verlauf",
  "practices_history_sub": "Alle abgeschlossenen Übungen.",
  "practices_history_empty_title": "Noch keine Übungen",
  "practices_history_empty_sub": "Starte eine Übung aus dem Practices-Hub.",
  "practices_delete_confirm": "Diesen Eintrag wirklich löschen?",

  // --- WEVA / EVA (Phase B Epic C+B · Welle 2) ---
  "weva": "WEVA",
  "weva_full_name": "Wellbeing Emotional Vitality Assistant",
  "weva_freemium_notice": "WEVA ist ein KI-Feature — mit Plus (€5,97/Mon.) oder höher schaltest du Chat, Berichte, Glaubenssatz-Analyse und Insights frei.",
  "weva_tab_insight": "Einsicht",
  "weva_action_insight_sub": "Sieh WEVAs neueste Reflexion auf einen Blick.",
  "weva_action_chat": "Mit WEVA chatten",
  "weva_action_chat_sub": "WEVA hört nur zu, wenn du sie einlädst.",
  "weva_action_reports": "Berichte erstellen",
  "weva_action_reports_sub": "Wähle Zeiträume und Quellen für deinen Bericht.",
  "weva_action_beliefs": "Deine Glaubenssätze",
  "weva_action_beliefs_sub": "Deine Tabelle + WEVAs Beobachtungen nebeneinander.",
  "weva_tab_history": "KI-Verlauf",
  "weva_report_fallback_title": "Bericht",
  "ui_latest_reflection": "Neueste WEVA-Reflexion",
  "ui_open_full_report": "Vollen Bericht öffnen",
  "ui_no_report_yet": "Noch kein WEVA-Bericht. Erstelle einen im WEVA-Tab.",
  "weva_generate_report_cta": "Bericht erstellen",
  "eva_chat": "Chat mit WEVA",
  "eva_chat_sub": "Frag WEVA nach deinen Mustern, Emotionen oder nächsten Schritten.",
  "eva_chat_tab_chat": "Chat",
  "eva_chat_tab_past": "Verlauf",
  "eva_chat_tab_reports": "Berichte",
  "eva_chat_empty": "Sag WEVA hallo - sie erinnert sich, was du geteilt hast.",
  "eva_chat_send_hint": "WEVA antwortet basierend auf deinem Journal, deinen Breakouts und dem letzten Digest.",
  "eva_chat_thinking": "WEVA reflektiert…",
  "eva_chat_placeholder": "Was bewegt dich gerade?",
  "eva_chat_used": "{n}/{q} Nachrichten heute",
  "eva_chat_limit_hit": "Tageslimit erreicht - upgrade, um weiter zu chatten.",
  "eva_chat_clear": "Gespräch löschen",
  "eva_chat_clear_confirm": "Das gesamte Gespräch mit WEVA löschen?",
  "eva_chat_new_session": "Neuen Chat starten",
  "eva_chat_past_empty": "Deine vergangenen Chats erscheinen hier, sobald du ein Gespräch beendest.",
  "eva_chat_current_pill": "Aktuell",
  "eva_chat_msgs_short": "Nachr.",
  "eva_chat_empty_session": "leere Sitzung",
  "eva_chat_reflecting": "Reflektiere…",
  "eva_chat_view_report": "Bericht ansehen",
  "eva_chat_make_report": "Bericht erstellen",
  "eva_chat_reports_empty": "Nach einem Chat tippe auf «Bericht erstellen» im Verlauf-Tab. Zusammenfassungen erscheinen hier.",
  "eva_chat_report_fallback": "Chat-Bericht",
  "insights_2": "Einblicke",
  "delete_report": "Bericht löschen",
  "eva_chat_voice_locked": "Spracheingabe benötigt Plus, Pro oder Ultimate.",
  "journal_upgrade_cta": "Jetzt freischalten",
  "cancel": "Abbrechen",
  "delete": "Löschen",
  "popup_report_failed": "Bericht fehlgeschlagen",
  "popup_not_enough_credits": "Nicht genug Credits",
  "popup_signup_required": "Anmeldung erforderlich",
  "popup_signup_to_report": "Bitte schließe die Anmeldung ab, um diesen Report zu erstellen.",
  "weekly_digest": "Wochenbericht",
  "what_weva_noticed": "Was WEVA bemerkt hat",
  "a_gentle_next_step": "Ein sanfter nächster Schritt",
  "weva_didn_t_leave_a_summary_for_this": "WEVA hat für diese Woche keine Zusammenfassung hinterlassen.",
  "talk_with_weva_about_this": "Sprich mit WEVA darüber",
  "retry": "Erneut versuchen",
  "weva_report": "WEVA Bericht",
  "report_not_found": "Bericht nicht gefunden.",
  "expand_all": "Alle ausklappen",
  "collapse_all": "Alle einklappen",
  "since_your_last_report": "Seit Ihrem letzten Bericht",
  "this_is_your_first_weva_report": "Dies ist Ihr erster WEVA Bericht",
  "welcome_to_the_journey_come_back_after": "Willkommen auf dieser Reise. Komm nach deinem nächsten Übungsfenster zurück – die \\\"Vorher-Nachher\\\"-Karte wird ab jetzt dein Wachstum verfolgen.",
  "tap_to_open_previous_report": "Tippen, um vorherigen Bericht zu öffnen ›",
  "try_this_first": "Probiere dies zuerst aus",
  "try_this_next": "Probiere dies als Nächstes aus",
  "open_the_practice": "Übung öffnen ›",
  "open_the_beliefs_table": "Glaubenssätze-Tabelle öffnen ›",
  "weva_reports_title": "Neuen WEVA-Bericht erstellen",
  "weva_reports_sub": "Wähle, was WEVA berücksichtigen soll.",
  "weva_reports_scope_all": "Alle Daten",
  "one_timeframe_applied_to_all_sources": "Ein Zeitrahmen gilt für alle Quellen.",
  "weva_reports_include_realize": "Erkennen-Daten einbeziehen",
  "weva_reports_include_designate": "Benennen-Daten einbeziehen",
  "weva_reports_include_release": "Loslassen-Daten einbeziehen",
  "weva_reports_include_breakouts": "Breathwork-Sessions einbeziehen",
  "weva_reports_include_goals": "Meine Ziele einbeziehen",
  "weva_reports_include_comfortzone": "Meine Komfortzone einbeziehen",
  "weva_reports_include_coping": "Meine Bewältigung einbeziehen",
  "weva_reports_include_journal": "Mein Journal einbeziehen",
  "my_beliefs_section_title": "Meine Glaubenssätze",
  "upper_limits_section_title": "Meine oberen Grenzen",
  "weva_reports_include_prior": "Ältere WEVA-Berichte einbeziehen",
  "weva_reports_generate": "Bericht erstellen",
  "weva_reports_history": "Frühere Berichte",
  "your_reports_will_live_here": "Deine Berichte erscheinen hier.",
  "no_reports_match_your_filters": "Keine Berichte entsprechen deinen Filtern.",
  "search_reports": "Berichte durchsuchen …",
  "weva_lang_picker_label": "Report-Sprache",
  "weva_lang_picker_hint": "Der WEVA-Report wird in dieser Sprache geschrieben.",
  "get_a_weva_report": "Einen WEVA-Bericht erhalten",
  "reports_left": "Berichte verbleibend",
  "every_report_distils_your_recent": "Jeder Bericht destilliert deine aktuelle Atemarbeit, Tagebücher, Ziele und Komfortzonenarbeit in eine klare Reflexion von WEVA.",
  "confirm_delete_weva_report_title": "Diesen WEVA-Report löschen?",
  "confirm_delete_weva_report_body": "Das lässt sich nicht rückgängig machen.",
  "confirm_delete": "Löschen",
  "popup_delete_failed": "Löschen fehlgeschlagen",
  "nav.weva": "WEVA",
  "weva_subtitle": "Dein persönlicher KI-Vitalitätsbegleiter.",
  "weva_action_digests": "Wöchentliche Reflexionen",
  "weva_action_digests_sub": "WEVAs wöchentliche Zusammenfassungen deiner inneren Arbeit.",
  "weva_digests_title": "Wöchentliche Reflexionen",
  "weva_digests_sub": "WEVAs wöchentliche Zusammenfassungen deiner inneren Arbeit.",
  "weva_digests_empty": "Noch keine wöchentlichen Reflexionen. Sie erscheinen, sobald du regelmäßig übst.",
  "weva_reflects_title": "WEVA reflektiert",
  "weva_reflects_sub": "Das Herzstück dieses Berichts",
  "weva_recommended_title": "Übungen für genau jetzt",
  "weva_recommended_sub": "Tippen zum Öffnen",
  "weva_beliefs_noticed_title": "Glaubenssätze, die WEVA bemerkt hat",
  "weva_comp_new_entries": "Neue Einträge",
  "weva_comp_practice_days": "Übungstage",
  "weva_comp_mood_delta": "Ø Stimmung Δ",
  "weva_comp_beliefs": "Glaubenssätze",
  "weva_generating": "WEVA reflektiert…",
  "weva_no_data": "Keine Daten im gewählten Zeitraum. Übe zuerst etwas und versuche es dann erneut.",
  "weva_credits_needed": "Dieser Bericht benötigt 15 Credits (oder ein Plus-/Pro-Abo). Jetzt Credits aufladen?",
  "weva_scope_sources": "Quellen & Zeiträume",
  "weva_reports_left": "Berichte übrig",
  "weva_report_language": "Bericht-Sprache",
  "weva_tts_play": "Vorlesen",
  "weva_tts_stop": "Stopp",


  // --- Collaboration (Teilen mit Coach) ---
  "collaboration_2": "Zusammenarbeit",
  "decide_who_sees_what_only_coaches_whose": "Entscheide, wer was sieht. Nur Coaches, deren innerem Kreis du beigetreten bist, können deine Daten erhalten.",
  "you_re_not_connected_to_any_coach_yet": "Du bist noch mit keinem Coach verbunden.",
  "inner_circle_2": "Innerer Kreis",
  "collab_join": "Beitreten",
  "allow_to_collaborate_with": "Zusammenarbeit erlauben mit:",
  "even_in_a_3_way_chat_each_coach_only": "Auch in einem 3er-Chat sieht jeder Coach nur die Daten, die du mit IHM geteilt hast. Niemand sieht die andere Seite.",
  "nav.collaboration": "Zusammenarbeit",
  "collab_share_events": "Breakout-Ereignisse + Emotionen",
  "collab_share_hrv": "HRV + Herzfrequenz-Signal",
  "collab_share_plans": "Übungspläne + Kalender",
  "collab_share_ai_reports": "KI-Analyseberichte",
  "collab_share_feed": "Feed-Aktivität",
  "collab_not_in_circle": "Nicht im inneren Kreis",
  "collab_active": "Innerer Kreis · aktiv",
  "collab_join_first": "Tritt zuerst dem inneren Kreis dieses Coaches bei.",
  "collab_saved": "Freigabe aktualisiert",


  // --- Epic E (Journal depth) + Epic F (Goals) ---
  "goals_action_archive": "Archivieren",
  "goals_action_complete": "Als erledigt markieren",
  "goals_actions_body": "Wähle eine Aktion für dieses Ziel.",
  "goals_actions_title": "Ziel-Aktionen",
  "goals_add": "Hinzufügen",
  "goals_add_first": "Erstes Ziel hinzufügen",
  "goals_empty_body": "Ein Ziel hilft dir und WEVA zu sehen, wohin du gehst. Füge dein erstes hinzu - es dauert 3 Minuten.",
  "goals_empty_title": "Noch keine Ziele",
  "goals_framework_recap": "Dein Rahmen",
  "goals_last_scale": "Letzter Check-in: {n}/10",
  "goals_log_note_ph": "Optional: Eine Notiz zu heute (privat)",
  "goals_log_progress": "Fortschritt eintragen",
  "goals_log_prompt": "Wo stehst du heute bei diesem Ziel, von 1 (weit) bis 10 (voll gelebt)?",
  "goals_more_hint": "Öffne alle deine Ziele",
  "goals_no_progress_yet": "Noch kein Fortschritt eingetragen",
  "goals_progress_card": "Fortschritt",
  "goals_progress_last_n": "Letzte {n} Check-ins",
  "goals_q1_hint": "Welches Gefühl suchst du wirklich? Frieden, Verbindung, Selbstvertrauen, Freiheit? Schreibe frei, mit deinen eigenen Worten.",
  "goals_q1_num": "SCHRITT 1 · INTROSPEKTION",
  "goals_q1_placeholder": "Ich spüre, ich suche…",
  "goals_q1_short": "Emotionales Bedürfnis",
  "goals_q1_title": "Erkenne dein wahres emotionales Bedürfnis.",
  "goals_q2_hint": "Von vage zu konkret. z. B. \\\"Ich möchte in Konflikten mit mehr Mitgefühl reagieren\\\" statt \\\"Ich möchte netter sein.\\\"",
  "goals_q2_num": "SCHRITT 2 · SPEZIFITÄT",
  "goals_q2_placeholder": "Konkret möchte ich…",
  "goals_q2_short": "Konkretes Ziel",
  "goals_q2_title": "Mach dein Ziel konkret.",
  "goals_q3_high": "Voll gelebt",
  "goals_q3_hint": "Das ist dein Ausgangswert - ohne Urteil. Später trägst du Check-ins auf derselben Skala ein.",
  "goals_q3_low": "Weit",
  "goals_q3_num": "SCHRITT 3 · MESSBARKEIT",
  "goals_q3_scale_hint": "1 = weit davon entfernt   ·   10 = voll gelebt",
  "goals_q3_short": "Startpunkt",
  "goals_q3_title": "Wo stehst du heute bei diesem Ziel, von 1 bis 10?",
  "goals_q4_hint": "Warum ist dir dieses Gefühl wichtig? Was wird möglich, wenn du es lebst?",
  "goals_q4_num": "SCHRITT 4 · ATTRAKTIVITÄT",
  "goals_q4_placeholder": "Das ist mir wichtig, weil…",
  "goals_q4_short": "Dein Warum",
  "goals_q4_title": "Verbinde das Ziel mit einem tiefen emotionalen Warum.",
  "goals_q5_hint": "Passe es so an, dass es um deine eigenen Reaktionen geht, nicht um das, was andere tun müssen. Halte es erreichbar.",
  "goals_q5_num": "SCHRITT 5 · RELEVANZ",
  "goals_q5_placeholder": "Das liegt in meiner Kontrolle, weil…",
  "goals_q5_short": "Realismus",
  "goals_q5_title": "Liegt dieses Ziel in deiner eigenen Kontrolle und ist realistisch?",
  "goals_q6_hint": "z. B. \\\"In den nächsten vier Wochen\\\", \\\"Bis Ende des Sommers\\\".",
  "goals_q6_num": "SCHRITT 6 · ZEITRAHMEN",
  "goals_q6_placeholder": "In den nächsten…",
  "goals_q6_short": "Zeitrahmen",
  "goals_q6_title": "In welchem Zeitrahmen möchtest du das leben?",
  "goals_q7_hint": "Sprich sie dir selbst zu, dann schreibe sie hier auf. Das ist dein schriftliches Versprechen - freundlich und ehrlich.",
  "goals_q7_num": "SCHRITT 7 · SCHRIFTLICHE VERPFLICHTUNG",
  "goals_q7_placeholder": "Ich verpflichte mich…",
  "goals_q7_short": "Verpflichtung",
  "goals_q7_title": "Schreibe deine Verpflichtung in deinen eigenen Worten.",
  "goals_section_subtitle": "Setze die Ziele, die deine Praxis leiten.",
  "goals_section_title": "Meine Ziele",
  "goals_see_all": "Alle {n} Ziele ansehen",
  "goals_status_active": "Aktiv",
  "goals_status_archived": "Archiviert",
  "goals_status_completed": "Abgeschlossen",
  "goals_status_paused": "Pausiert",
  "goals_title_placeholder": "z. B. In Konflikten mit Mitgefühl reagieren",
  "goals_view_all": "Alle Ziele ansehen",
  "goals_weva_analyze": "Mit WEVA analysieren",
  "goals_weva_card_title": "WEVAs Reflexion",
  "goals_weva_challenges": "Sanfte Einladungen",
  "goals_weva_enable_body": "WEVA liest deine sieben Antworten und Check-ins, dann bietet sie eine mitfühlende Reflexion - Stärken, sanfte Einladungen und einen freundlichen nächsten Schritt. Du kannst das jederzeit ausschalten.",
  "goals_weva_enable_first_body": "Aktiviere WEVA für dieses Ziel oben, dann führe die Analyse aus.",
  "goals_weva_enable_first_title": "Schalte WEVAs Reflexion zuerst ein",
  "goals_weva_enable_title": "Lass WEVA dieses Ziel reflektieren",
  "goals_weva_next_step": "Ein freundlicher nächster Schritt",
  "goals_weva_no_analysis_yet": "Noch keine Reflexion. Tippe auf Analysieren, um WEVA einzuladen.",
  "goals_weva_regenerate": "Erneut reflektieren",
  "goals_weva_strengths": "Was du bereits trägst",
  "goals_wizard_discard_body": "Du hast schon angefangen. Ohne Speichern verlassen?",
  "goals_wizard_discard_confirm": "Verwerfen",
  "goals_wizard_discard_title": "Ziel verwerfen?",
  "goals_wizard_final_h": "Fast geschafft - eine letzte Entscheidung",
  "goals_wizard_final_hint": "Optional: Lass WEVA dieses Ziel privat reflektieren.",
  "goals_wizard_final_num": "FAST GESCHAFFT",
  "goals_wizard_recap": "Deine Verpflichtung in Kurzform",
  "goals_wizard_recap_title": "Titel",
  "goals_wizard_save": "Ziel speichern",
  "goals_wizard_step_of": "Schritt {n} von {total}",
  "goals_wizard_title_h": "Gib deinem Ziel einen kurzen Namen",
  "goals_wizard_title_hint": "Eine Zeile, die du wiedererkennst. Du kannst sie jederzeit ändern.",
  "goals_wizard_title_num": "ZIEL-TITEL",
  "journal_tab_entries": "Journal-Einträge",
  "journal_tab_weva": "WEVA-Einblick",
  "journal_recording": "Aufnahme… tippen zum Stoppen",
  "journal_transcribing": "Transkribiere…",
  "journal_transcription_ready": "Transkript bereit. Bearbeiten oder speichern.",
  "journal_tap_to_record": "Tippen zum Aufnehmen",
  "journal_permission_denied": "Mikrofon abgelehnt - bitte in den Systemeinstellungen erlauben.",
  "journal_locked_voice": "Sprach-Journal ist ein Plus-Feature.",
  "journal_monthly_used": "{n}/{q} Einträge in diesem Monat",
  "journal_saved": "Eintrag gespeichert. Beziehe ihn jederzeit in einen WEVA-Bericht ein.",
  "journal_empty": "Noch keine Einträge. Deine erste Reflexion ist einen Atemzug entfernt.",
  "journal_subtitle": "Dein privater Reflexionsraum - schreibe oder sprich.",
  "journal_prompt": "Wie fühlst du dich heute? Welche Emotionen, Situationen oder Überzeugungen sind gerade lebendig?",
  "journal_placeholder": "z. B. Vor dem Meeting spürte ich Enge in der Brust. Ich glaubte, ich würde erstarren…",
  "journal_mood": "Stimmung",
  "journal_save": "Eintrag speichern",
  "journal_new_entry": "Neuer Eintrag",
  "journal_tap_to_open": "Tippen zum Öffnen",
  "journal_entry_detail_title": "Journal-Eintrag",
  "journal_take_this_further": "Weiter vertiefen",
  "journal_work_alone_title": "Alleine daran arbeiten",
  "journal_work_alone_sub": "Erstelle einen WEVA-Einblick, der sich nur auf diesen Eintrag konzentriert, um seine Muster zu sehen.",
  "journal_work_coach_title": "Mit einem Coach arbeiten",
  "journal_work_coach_sub": "Sitzung buchen — dein Eintrag wird angehängt, damit sich der Coach vorbereiten kann.",
  "journal_delete_confirm": "Diesen Eintrag löschen? Nicht rückgängig.",
  "journal_weva_included": "Du hast {n} {reportWord} in deinem {plan}-Plan enthalten.",
  "journal_weva_credits_hint": "Ein WEVA-Einblick = 15 Credits. Oder upgrade, um monatliche Reports einzuschließen.",
  "journal_weva_report_singular": "Report",
  "journal_weva_report_plural": "Reports",
  "journal_pick_prompt": "Markiere 1+ Einträge, um einen Report zu fokussieren — oder lasse leer für die letzten 30 Tage.",
  "journal_pick_selected_singular": "{n} Eintrag ausgewählt",
  "journal_pick_selected_plural": "{n} Einträge ausgewählt",
  "journal_pick_clear": "Zurücksetzen",
  "journal_pick_empty": "Schreibe deinen ersten Journal-Eintrag — dann komm zurück und markiere ihn für einen Report.",
  "journal_weva_btn_picked": "WEVA-Report erstellen ({n} Einträge)",
  "journal_weva_btn_30d": "WEVA-Report erstellen (letzte 30 Tage)",
  "journal_weva_btn_picked_credits": "WEVA-Report erstellen ({n} Einträge) · 15 Credits",
  "journal_weva_btn_30d_credits": "WEVA-Report erstellen (letzte 30 Tage) · 15 Credits",
  "journal_weva_hint_picked": "WEVA konzentriert sich auf die markierten Einträge und deckt wiederkehrende Gefühle, Überzeugungen und Muster auf.",
  "journal_weva_hint_30d": "Fasst deine letzten Journal-Einträge zu einer kohärenten Geschichte aus Gefühlen, Überzeugungen und Mustern zusammen.",
  "journal_weva_history_empty": "Noch keine WEVA-Reports — erstelle deinen ersten, um Muster über deine Einträge hinweg zu sehen.",
  "journal_weva_report_fallback": "Report erstellt.",
  "journal_journey_title": "Mit einem Coach reisen",
  "journal_journey_sub": "Jemand, der dich durch das begleitet, was deine Einträge offenbaren.",
  "journal_new_entry_a11y": "Neuer Journal-Eintrag",
  "eva": "WEVA",
  "eva_full_name": "Wellbeing Emotional Vitality Assistant",
  "eva_latest_insight": "Letzte WEVA-Erkenntnis",
  "eva_tag_emotions": "Emotionen",
  "eva_tag_beliefs": "Überzeugungen",
  "eva_tag_behaviors": "Verhalten",
  "eva_tag_body": "Körperzeichen",
  "eva_tag_situations": "Situationen",
  "eva_tag_themes": "Themen",
  "eva_reflection": "WEVAs Impuls",
  "picked": "AUSGEWÄHLT",
  "goal_voice_hint": "Sprich einfach ein — wir tippen mit.",
  "continue": "Weiter",
  "more": "more",
  "error": "Fehler",
  "done": "Fertig",
  "close": "Schließen",
  "save": "Speichern",
  "nav.goals": "Ziele",
  "jr_voice_hint": "Sprich einfach ein — wir tippen mit.",
  "jr_voice_start": "Sprachaufnahme",
  "jr_voice_stop": "Aufnahme stoppen",
  "jr_voice_mic_denied": "Mikrofonzugriff verweigert. Bitte im Browser erlauben.",
  "jr_tab_entries": "Einträge",
  "jr_tab_weva": "WEVA-Einblick",

  "goals_coach_cta_title": "Mit einem Coach daran arbeiten",
  "goals_coach_cta_sub": "Finde einen Coach und bucht gemeinsam an diesem Ziel.",


  // --- Epic D (Breathwork client) ---
  "best_for": "Ideal für",
  "breathwork": "Breathwork",
  "breathwork_insights_sub": "Übungszeit, Erfolge und Muster aus deinen Sessions.",
  "breathwork_insights_title": "Einsichten",
  "breathwork_plan_examples": "Beispielpläne",
  "breathwork_plan_from_coach": "Plan vom Coach",
  "breathwork_plan_sub": "Setze morgendliche, mittägliche und abendliche Anker.",
  "breathwork_plan_title": "Dein Wochenplan",
  "breathwork_start_sub": "Emotion wählen, Kontext teilen, atmen.",
  "breathwork_start_title": "Session starten",
  "breathwork_subtitle": "Emotionen mit dem Atem durch den Körper bewegen.",
  "breathwork_techniques_sub": "Vor dem Start jede Technik erkunden.",
  "breathwork_techniques_title": "Techniken-Bibliothek",
  "confirm_decline": "Ablehnen",
  "confirm_decline_plan_body": "Du kannst jederzeit deine eigene Version erstellen.",
  "confirm_decline_plan_title": "Plan ablehnen?",
  "confirm_delete_plan_body": "Das lässt sich nicht rückgängig machen.",
  "confirm_delete_plan_title": "Diesen Plan löschen?",
  "duration_2": "Laufzeit",
  "explanation_how_it_works": "So funktioniert's",
  "how_to": "Anleitung",
  "intensity_2": "Intensität",
  "intensity_gentle": "sanft",
  "intensity_intense": "intensiv",
  "intensity_medium": "mittel",
  "lib_session_back_btn": "Zurück zur Bibliothek",
  "lib_session_note_ph": "Was ist dir aufgefallen?",
  "lib_session_note_sub": "Eine kurze Notiz für dich — optional.",
  "lib_session_note_title": "Wie war deine Session?",
  "lib_session_start_btn": "Session starten",
  "lib_session_wellbeing_sub": "1 = ausgelaugt, 10 = strahlend",
  "lib_session_wellbeing_title": "Wie fühlst du dich jetzt?",
  "lib_tech_478_body": "Die 4-7-8-Atmung, bekannt gemacht von Dr. Andrew Weil, wirkt wie ein natürliches Beruhigungsmittel für das Nervensystem. Die lange Ausatmung aktiviert den Vagusnerv und bereitet Körper und Geist auf Schlaf oder tiefe Ruhe vor.",
  "lib_tech_478_step1": "Atme mit einem sanften Laut vollständig durch den Mund aus.",
  "lib_tech_478_step2": "Schließe den Mund und atme 4 Sekunden durch die Nase ein.",
  "lib_tech_478_step3": "Halte den Atem 7 Sekunden an.",
  "lib_tech_478_step4": "Atme 8 Sekunden lang langsam durch den Mund aus.",
  "lib_tech_478_step5": "Mache 4 Zyklen, dann ruhe kurz nach.",
  "lib_tech_bhramari_body": "Bhramari — die Bienenatmung — nutzt ein sanftes summendes Ausatmen, das den Vagusnerv in Schwingung versetzt. Tiefe vagale Beruhigung, ideal bei Angst, Schlaflosigkeit und Einschlaf-Ritualen.",
  "lib_tech_bhramari_step1": "Sitze aufrecht und schließe die Augen.",
  "lib_tech_bhramari_step2": "Atme langsam durch die Nase ein.",
  "lib_tech_bhramari_step3": "Summe beim Ausatmen leise wie eine Biene.",
  "lib_tech_bhramari_step4": "Lass die Vibration Gesicht und Brust füllen.",
  "lib_tech_bhramari_step5": "Setze das 6 bis 10 Runden fort.",
  "lib_tech_box_body": "Box-Atmung ist ein einfacher 4-teiliger Rhythmus, der dein Nervensystem in Minuten stabilisiert. Spezialkräfte nutzen sie vor belastenden Entscheidungen — unauffällig, überall einsetzbar, wirkungsvoll.",
  "lib_tech_box_step1": "Atme 4 Sekunden ruhig durch die Nase ein.",
  "lib_tech_box_step2": "Halte den Atem 4 Sekunden sanft angehalten.",
  "lib_tech_box_step3": "Atme 4 Sekunden durch den Mund aus.",
  "lib_tech_box_step4": "Halte 4 Sekunden mit leeren Lungen.",
  "lib_tech_box_step5": "Wiederhole diese Box 3 bis 10 Minuten.",
  "lib_tech_coherent_body": "Kohärente Atmung (5-5) bringt Atem und Herzrhythmus in Resonanz und erhöht die Herzratenvariabilität. Schon 5 Minuten führen dich vom Stress in einen ruhigen, klaren Zustand — Kardiologen empfehlen sie als tägliche Praxis.",
  "lib_tech_coherent_step1": "Atme sanft 5 Sekunden durch die Nase ein.",
  "lib_tech_coherent_step2": "Atme sanft 5 Sekunden durch die Nase aus.",
  "lib_tech_coherent_step3": "Bleib weich — ohne Anstrengung, ohne Zwang.",
  "lib_tech_coherent_step4": "Setze das 5 bis 20 Minuten fort.",
  "lib_tech_cooling_body": "Sitali — der kühlende Atem — kühlt Körper und Geist buchstäblich. Ideal für hitzige Momente: Wut, Aufgeregtheit, körperliche Hitze oder Wechseljahres-Wallungen. Ein sommerlicher Yoga-Klassiker.",
  "lib_tech_cooling_step1": "Rolle die Zunge zu einer Röhre (oder spitze sanft die Lippen).",
  "lib_tech_cooling_step2": "Atme langsam durch den Mund über die kühle Zunge ein.",
  "lib_tech_cooling_step3": "Schließe den Mund und atme sanft durch die Nase aus.",
  "lib_tech_cooling_step4": "Setze das 3 bis 8 Minuten fort.",
  "lib_tech_kapalabhati_body": "Kapalabhati — der schädelscheinende Atem — nutzt scharfe Ausatmungen und passive Einatmungen, um Körper und Geist zu energetisieren. Ideal am Morgen. Bei Schwindel oder Schwangerschaft überspringen.",
  "lib_tech_kapalabhati_step1": "Passive Einatmungen, scharfe Ausatmungen durch die Nase.",
  "lib_tech_kapalabhati_step2": "Der Bauch zieht sich bei jeder Ausatmung nach innen.",
  "lib_tech_kapalabhati_step3": "Beginne mit 30 Pulsen — Pause — wiederhole 2 bis 3 Runden.",
  "lib_tech_kapalabhati_step4": "Bei Schwindel sofort stoppen.",
  "lib_tech_nadi_shodhana_body": "Wechselatmung (Nadi Shodhana) bringt die linke und rechte Gehirnhälfte in Balance und klärt geistigen Nebel. Traditionelle Yoga-Technik — 5 Minuten für mehr Klarheit.",
  "lib_tech_nadi_shodhana_step1": "Schließe das rechte Nasenloch mit dem Daumen und atme links ein.",
  "lib_tech_nadi_shodhana_step2": "Schließe das linke mit dem Ringfinger und atme rechts aus.",
  "lib_tech_nadi_shodhana_step3": "Atme rechts ein.",
  "lib_tech_nadi_shodhana_step4": "Schließe das rechte und atme links aus.",
  "lib_tech_nadi_shodhana_step5": "Das ist eine Runde — mache 5 bis 10.",
  "lib_tech_ocean_body": "Ujjayi — der Ozean-Atem — erzeugt ein sanftes Flüstern in der Kehle, das die Aufmerksamkeit verankert wie Wellen am Strand. Der klassische Meditations- und Yoga-Atem.",
  "lib_tech_ocean_step1": "Verenge sanft den Rachenraum.",
  "lib_tech_ocean_step2": "Atme mit einem leisen, ozeanähnlichen Flüstern.",
  "lib_tech_ocean_step3": "Nur du selbst solltest ihn hören.",
  "lib_tech_ocean_step4": "Lass ihn zum Anker deiner Aufmerksamkeit werden.",
  "lib_tech_physiological_sigh_body": "Das physiologische Seufzen ist der schnellste Weg, akuten Stress zu lösen — doppelte Einatmung gefolgt von langem Ausatmen, entdeckt vom Stanford-Neurowissenschaftler Dr. Andrew Huberman. Wirkt in unter einer Minute.",
  "lib_tech_physiological_sigh_step1": "Nimm einen langen, ruhigen Atemzug durch die Nase.",
  "lib_tech_physiological_sigh_step2": "Setze eine zweite kürzere Einatmung obenauf.",
  "lib_tech_physiological_sigh_step3": "Lass alles mit einem langen, ruhigen Ausatmen durch den Mund los.",
  "lib_tech_physiological_sigh_step4": "Wiederhole 1 bis 3 Mal — spüre die Veränderung.",
  "lib_tech_wim_hof_body": "Die Wim-Hof-Methode kombiniert 30 schnelle tiefe Atemzüge mit einer Atempause. Sie überflutet den Körper mit Sauerstoff und baut Resilienz auf. Intensiv — nie beim Autofahren oder im Wasser üben.",
  "lib_tech_wim_hof_step1": "30 tiefe Atemzüge — voll einatmen, das Ausatmen fallen lassen (nicht erzwingen).",
  "lib_tech_wim_hof_step2": "Nach #30 ausatmen und so lange halten, wie es sich angenehm anfühlt.",
  "lib_tech_wim_hof_step3": "Wenn nötig, tief einatmen und 15 Sekunden halten.",
  "lib_tech_wim_hof_step4": "Wiederhole 3 bis 4 Runden.",
  "lib_tech_wim_hof_step5": "Bei Unwohlsein sofort stoppen — nie beim Autofahren oder im Wasser.",
  "phase_exhale": "Ausatmen",
  "phase_hold_in": "Halten",
  "phase_hold_out": "Pause",
  "phase_inhale": "Einatmen",
  "popup_adopted": "Übernommen ✓",
  "popup_plan_under_myplans": "Der Plan liegt jetzt unter „Meine Pläne“. Öffne ihn, um ihn anzupassen oder neu zu planen.",
  "posture_lying": "Rückenlage auf einer Matte",
  "posture_reclined": "Halb liegend, mit Kissen abgestützt",
  "posture_seated_chair": "Aufrecht im Stuhl sitzend",
  "posture_seated_cross": "Im Schneidersitz aufrecht",
  "posture_standing": "Aufrecht stehend",
  "recommended_posture": "Empfohlene Haltung",
  "session_done_btn": "Fertig",
  "session_success_body": "Diese Atmung hat sich gelohnt. Bleib in diesem Gefühl.",
  "session_success_title": "Gut gemacht!",
  "tech_478": "4-7-8 Atmung",
  "tech_478_bestfor": "Schlaf, Angst",
  "tech_478_desc": "4 ein, 7 halten, 8 aus. Beruhigt das Nervensystem.",
  "tech_478_step1": "Vollständig durch den Mund ausatmen.",
  "tech_478_step2": "4 Sekunden durch die Nase einatmen.",
  "tech_478_step3": "7 Sekunden halten.",
  "tech_478_step4": "8 Sekunden durch den Mund ausatmen.",
  "tech_478_step5": "4 Zyklen durchführen — dann ruhen.",
  "tech_bhramari": "Bhramari (Bienenatem)",
  "tech_bhramari_bestfor": "Vagus-Tonus, Ruhe",
  "tech_bhramari_desc": "Beim Ausatmen summen - vagale Beruhigung.",
  "tech_bhramari_step1": "Aufrecht sitzen, Augen schließen.",
  "tech_bhramari_step2": "Durch die Nase einatmen.",
  "tech_bhramari_step3": "Beim Ausatmen wie eine Biene summen.",
  "tech_bhramari_step4": "Die Vibration im Gesicht und in der Brust spüren.",
  "tech_bhramari_step5": "6–10 Runden fortsetzen.",
  "tech_box": "Box-Atmung (4-4-4-4)",
  "tech_box_bestfor": "Stress, Fokus",
  "tech_box_desc": "Gleich ein / halten / aus / halten. Schneller Reset.",
  "tech_box_step1": "4 Sekunden durch die Nase einatmen.",
  "tech_box_step2": "4 Sekunden halten.",
  "tech_box_step3": "4 Sekunden durch den Mund ausatmen.",
  "tech_box_step4": "4 Sekunden leer halten.",
  "tech_box_step5": "3–10 Minuten wiederholen.",
  "tech_coherent": "Kohärente Atmung (5-5)",
  "tech_coherent_bestfor": "Erdung, Herzratenvariabilität",
  "tech_coherent_desc": "5s ein, 5s aus. Verankert die HRV.",
  "tech_coherent_step1": "Sanft 5 Sekunden einatmen.",
  "tech_coherent_step2": "Sanft 5 Sekunden ausatmen.",
  "tech_coherent_step3": "Weich halten — keine Anstrengung.",
  "tech_coherent_step4": "5–20 Minuten fortsetzen.",
  "tech_connected": "Verbundenes Atmen",
  "tech_connected_bestfor": "Emotionale Befreiung",
  "tech_connected_desc": "Kreisförmig, ohne Pause. Emotionale Freisetzung; nur begleitet.",
  "tech_connected_learn_more": "Über diese Praxis lesen",
  "tech_connected_step1": "Kontinuierliches Ein- + Ausatmen ohne Pause.",
  "tech_connected_step2": "Durch Mund oder Nase atmen.",
  "tech_connected_step3": "Nur mit ausgebildeter Begleitung oder in einem sicher gehaltenen Raum durchführen.",
  "tech_connected_step4": "Emotionen können auftauchen — das ist der Sinn.",
  "tech_cooling": "Kühlender Atem (Sitali)",
  "tech_cooling_bestfor": "Hitze, Wut, Unruhe",
  "tech_cooling_desc": "Langsam einatmen über gerollte Zunge - lässt Hitze und Reizbarkeit los.",
  "tech_cooling_step1": "Die Zunge zu einer Röhre einrollen (oder Lippen spitzen).",
  "tech_cooling_step2": "Langsam durch den Mund über die kühle Zunge einatmen.",
  "tech_cooling_step3": "Mund schließen, sanft durch die Nase ausatmen.",
  "tech_cooling_step4": "3–8 Minuten wiederholen.",
  "tech_kapalabhati": "Kapalabhati (Schädelscheinend)",
  "tech_kapalabhati_bestfor": "Wachheit",
  "tech_kapalabhati_desc": "Scharfe Ausatmungen, passive Einatmungen. Aktivierend.",
  "tech_kapalabhati_step1": "Passive Einatmung, scharfe Ausatmung durch die Nase.",
  "tech_kapalabhati_step2": "Der Bauch zieht sich bei jeder Ausatmung ein.",
  "tech_kapalabhati_step3": "30 Pulse starten — Pause — 2–3 Runden wiederholen.",
  "tech_kapalabhati_step4": "Bei Schwindel abbrechen.",
  "tech_nadi_shodhana": "Nadi Shodhana (Wechselatmung)",
  "tech_nadi_shodhana_bestfor": "Balance, Fokus",
  "tech_nadi_shodhana_desc": "Balance zwischen linker und rechter Hemisphäre.",
  "tech_nadi_shodhana_step1": "Rechtes Nasenloch schließen, durch das linke einatmen.",
  "tech_nadi_shodhana_step2": "Linkes schließen, durch das rechte ausatmen.",
  "tech_nadi_shodhana_step3": "Durch das rechte einatmen.",
  "tech_nadi_shodhana_step4": "Rechtes schließen, durch das linke ausatmen.",
  "tech_nadi_shodhana_step5": "Das ist eine Runde — 5–10 Runden durchführen.",
  "tech_ocean": "Ozean-Atem (Ujjayi)",
  "tech_ocean_bestfor": "Meditationsanker",
  "tech_ocean_desc": "Kehle sanft verengen - meditativer Anker.",
  "tech_ocean_step1": "Den hinteren Rachenraum leicht verengen.",
  "tech_ocean_step2": "Mit einem sanften, ozeanartigen Flüstern atmen.",
  "tech_ocean_step3": "Nur für dich selbst hörbar halten.",
  "tech_ocean_step4": "Lass es zum Anker deiner Aufmerksamkeit werden.",
  "tech_physiological_sigh": "Physiologisches Seufzen",
  "tech_physiological_sigh_bestfor": "Akuter Stress",
  "tech_physiological_sigh_desc": "Doppel-Einatmung + langes Ausatmen - schnellster Stressabbau.",
  "tech_physiological_sigh_step1": "Ein langes Einatmen durch die Nase.",
  "tech_physiological_sigh_step2": "Dann ein zweites, kleineres Einatmen obendrauf.",
  "tech_physiological_sigh_step3": "Langes, langsames Ausatmen durch den Mund.",
  "tech_physiological_sigh_step4": "1–3 Mal wiederholen.",
  "tech_practice_guide_only": "Angeleitete Praxis",
  "tech_practice_guide_only_body": "Diese Technik ist eine angeleitete Praxis - folge den Schritten oben. Ein In-App-Player dafür ist in Arbeit.",
  "tech_wim_hof": "Wim Hof",
  "tech_wim_hof_bestfor": "Energie, Widerstandskraft",
  "tech_wim_hof_desc": "30 tiefe Atemzüge → Retention → Erholung. Energetisierend.",
  "tech_wim_hof_step1": "30 tiefe Atemzüge — voll ein, ausströmen lassen (nicht forcieren).",
  "tech_wim_hof_step2": "Nach dem 30. so lange wie angenehm ausgeatmet halten.",
  "tech_wim_hof_step3": "Tief einatmen und 15 Sekunden halten.",
  "tech_wim_hof_step4": "3–4 Runden wiederholen.",
  "tech_wim_hof_step5": "Niemals beim Fahren oder im Wasser durchführen.",
  "technique_not_found": "Technik nicht gefunden",
  "ui_accept_activate": "Annehmen & aktivieren",
  "ui_adopt": "Diesen Plan übernehmen",
  "ui_create_plan": "Plan erstellen",
  "ui_days": "Tage",
  "ui_decline": "Ablehnen",
  "ui_min": "min",
  "ui_my_plans": "Meine Pläne",
  "ui_no_coach_plans_sub": "Sobald ein Coach dir einen Plan sendet, erscheint er hier.",
  "ui_no_coach_plans_title": "Keine Coach-Pläne offen",
  "ui_no_plans_sub": "Erstelle einen oder übernimm eine Vorlage.",
  "ui_no_plans_title": "Noch keine Pläne",
  "ui_pending_action": "wartet auf deine Antwort",
  "ui_sessions": "Sessions",
  "ui_slots": "Slots",
  "ui_templates_empty_sub": "Aktualisiere oder prüfe deine Verbindung.",
  "ui_templates_empty_title": "Beispiele konnten nicht geladen werden",

  "nav.breathwork": "Breathwork",
  "nav.breakout": "Breakout",


  // --- Epic G+H (Feed + Messages client) ---
  "feed": "Feed",
  "feed_tab_global": "Global",
  "feed_tab_regional": "Regional",
  "feed_tab_interest": "Interessen",
  "feed_search_placeholder": "Suche Titel, Coach oder Hashtag…",
  "no_posts_yet": "Noch keine Beiträge.",
  "loading": "Laden...",
  "coach": "Coach",
  "post_paid_chip": "PAID",
  "post_sponsored_chip": "Gesponsert",
  "unlock_credits": "Freischalten · {n} Guthaben",
  "paid_locked": "Kostenpflichtige Vorschau",
  "post_book_now": "Jetzt buchen",
  "post_action_react": "Reagieren",
  "post_action_comment": "Kommentieren",
  "post_action_save": "Speichern",
  "post_action_share": "Teilen",
  "report_post_title": "Beitrag melden",
  "report_reason_spam": "Spam oder irreführend",
  "report_reason_inappropriate": "Unangemessene Inhalte",
  "report_reason_medical_claim": "Unbelegte medizinische Aussage",
  "report_reason_other": "Sonstiges",
  "reported": "Gemeldet. Danke dir.",
  "description": "Beschreibung",
  "submit": "Absenden",
  "reaction_heart": "Herz",
  "reaction_inspired": "Inspiriert",
  "reaction_moved": "Bewegt",
  "reaction_strong": "Stark",
  "block_user_cta": "Diese:n Nutzer:in blockieren",
  "chats": "Chats",
  "chats_tab_all": "Alle",
  "chats_tab_circles": "Kreise",
  "chats_tab_direct": "Direkt",
  "chats_tab_shared": "Geteilt",
  "no_conversations": "Noch keine Gespräche.",
  "my_circles": "Meine Kreise",
  "shared_chats": "Gemeinsame Coaching-Chats",
  "direct_messages": "Direktnachrichten",
  "three_way_care": "3-fache Clients-Betreuung",
  "members": "Mitglieder",
  "message_deleted": "Nachricht gelöscht",
  "message": "Nachricht",
  "no_messages_hint": "Sende eine Nachricht, um das Gespräch zu beginnen.",
  "write_a_message": "Nachricht schreiben...",
  "delete_message_title": "Nachricht löschen?",
  "delete_message_confirm": "This message will be replaced with a “deleted” placeholder for everyone in the chat.",
  "something_went_wrong": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
  "nav.feed": "Feed",
  "nav.messages": "Nachrichten",
  "feed_comments_title": "Kommentare",
  "feed_no_comments": "Noch keine Kommentare. Sei die erste freundliche Stimme.",
  "feed_write_comment": "Schreib einen Kommentar…",
  "feed_add_comment": "Senden",
  "feed_unlocked": "Freigeschaltet",
  "feed_open_post": "Beitrag öffnen",
  "feed_credits_needed": "Dieser Beitrag kostet {n} Credits. Jetzt aufladen?",
  "msg_support": "Support",
  "msg_new_chat": "Neue Nachricht",

  "messages": "Nachrichten",
  "chats_support_btn": "Support",
  "join_by_code": "Einladungscode?",
  "chats_join_placeholder": "Code eingeben",
  "join": "Beitreten",
  "chats_invalid_code": "Ungültiger Code",
  "circles_empty_sub": "Wenn dich ein Coach in einen Kreis einlädt, erscheint er hier.",
  "new_chat_fab_a11y": "Neuen Chat starten",
  "shared_coaching_chat": "Gemeinsamer Coaching-Chat",
  "shared_chat_banner": "Alle Mitglieder sehen die Nachrichten in diesem gemeinsamen Chat.",
  "shared_chat_no_access_title": "Dieser Chat ist privat",
  "shared_chat_no_access_body": "Nur Mitglieder dieses gemeinsamen Coaching-Chats können die Nachrichten sehen.",
  "shared_chat_empty": "Noch keine Nachrichten. Beginne das Gespräch.",
  "shared_chat_placeholder": "Nachricht an alle schreiben …",
  "new_chat_title": "Neuer Chat",
  "new_chat": "Neuer Chat",
  "new_chat_pick_coach": "Coach wählen",
  "new_chat_pick_second": "Zweiten Coach wählen",
  "new_chat_shared_toggle": "Gemeinsamen Chat mit zwei Coaches starten",
  "new_chat_search_placeholder": "Coaches durchsuchen …",
  "new_chat_no_results": "Keine Coaches gefunden.",
  "new_chat_cancel": "Abbrechen",
  "new_chat_start_btn": "Chat starten",
  "new_chat_start_shared_btn": "Gemeinsamen Chat starten",
  "new_chat_error_same_coach": "Bitte wähle zwei verschiedene Coaches.",
  "post_details": "Beitrag",
  "post_not_found": "Beitrag nicht gefunden.",
  "comment_sheet_title": "Kommentare ({n})",
  "comment_empty": "Noch keine Kommentare. Sei die/der Erste.",
  "comment_input_placeholder": "Kommentar schreiben …",
  "series_progress": "{viewed}/{total} angesehen",
  "panic_attack_btn": "Panikattacke",
  "panic_attack_btn_sub": "Geführte Atemhilfe",
  "panic_picker_title": "Wo stehst Du gerade?",
  "panic_picker_sub": "Wähle die Phase, die passt — wir führen Dich durch den richtigen Atem.",
  "panic_stage_early_title": "Erste Anzeichen",
  "panic_stage_early_sub": "Innere Unruhe, Angst steigt auf",
  "panic_stage_acute_title": "Akuter Notfall",
  "panic_stage_acute_sub": "Volle Panikattacke, Atemnot",
  "panic_stage_subside_title": "Abklingende Phase",
  "panic_stage_subside_sub": "Körper zittert, Puls sinkt langsam",
  "panic_stage_prevent_title": "Zur Vorbeugung",
  "panic_stage_prevent_sub": "Im Alltag, ohne akute Angst",
  "panic_tech_2_4": "2-4-Atmung",
  "panic_tech_pursed": "Lippenbremse · Torwartstellung",
  "panic_tech_478": "4-7-8-Atmung",
  "panic_tech_diaphragm": "Bauchatmung",
  "panic_technique_label": "Technik",
  "panic_intro_early_title": "Fange die Welle ab",
  "panic_intro_early_body": "Diese Technik verhindert das Hineinrutschen in die Hyperventilation. Die verlängerte Ausatmung signalisiert Deinem Gehirn frühzeitig Sicherheit.",
  "panic_intro_acute_title": "Sofort-Entlastung für die Lunge",
  "panic_intro_acute_body": "Sofort-Effekt: Durch den Lippenwiderstand wird verbrauchte Luft aus der Lunge gepresst, was die akute Atemnot stoppt.",
  "panic_intro_subside_title": "Ein natürliches Beruhigungsmittel",
  "panic_intro_subside_body": "Wirkt wie ein natürliches Beruhigungsmittel. Das lange Luftanhalten und Ausatmen zwingt das Herz-Kreislauf-System in die tiefe Entspannung.",
  "panic_intro_prevent_title": "Trainiere Dein Zwerchfell täglich",
  "panic_intro_prevent_body": "Trainiert das Zwerchfell und senkt das allgemeine Stresslevel nachhaltig, sodass der Körper in Krisen weniger anfällig reagiert.",
  "panic_body_hint_early": "Sitze oder stehe aufrecht. Atme sanft durch die Nase.",
  "panic_body_hint_acute": "Torwartstellung: leicht vorbeugen, Hände auf die Knie, Lippen locker gespitzt wie beim Kerzen-Ausblasen.",
  "panic_body_hint_subside": "Sitze aufrecht. Zungenspitze hinter die oberen Schneidezähne. Ausatmen mit einem sanften „Whoosh\".",
  "panic_body_hint_prevent": "Lege eine Hand auf Deinen Bauch. Beim Einatmen hebt er sich, beim Ausatmen senkt er sich.",
  "panic_intensity_recap_title": "Wie intensiv war Deine Panik?",
  "panic_intensity_scale_hint": "1 = ruhig, 10 = maximal",
  "panic_intensity_continue": "Weiter",
  "panic_analytics_title": "Panikattacken-Analyse",
  "panic_analytics_sub": "Deine Panik-Reaktion im Verlauf.",
  "breathe_easy_btn": "Leichter Atmen",
  "breathe_easy_btn_sub": "Bei COPD & Atemnot",
  "copd_picker_title": "Welche Situation passt?",
  "copd_picker_sub": "Wähle eine Technik — wir führen Dich Schritt für Schritt.",
  "copd_stage_pursed_title": "Dosierte Lippenbremse",
  "copd_stage_pursed_sub": "Akute Atemnot, nach Belastung",
  "copd_stage_belly_title": "Bewusste Bauchatmung",
  "copd_stage_belly_sub": "Ruhephasen, Entspannung",
  "copd_stage_contact_title": "Kontaktatmung",
  "copd_stage_contact_sub": "Stress, gezielte Tiefenbelüftung",
  "copd_stage_huff_title": "Huffing",
  "copd_stage_huff_sub": "Festsitzender Schleim in den Atemwegen",
  "copd_stage_acbt_title": "Aktiver Atemzyklus",
  "copd_stage_acbt_sub": "Tägliche Lungenreinigung",
  "copd_intro_pursed_title": "Halte Deine Atemwege stabil",
  "copd_intro_pursed_body": "Hält Deine Atemwege stabil und verhindert deren Kollaps — sofortige Erleichterung bei Atemnot.",
  "copd_intro_belly_title": "Mehr Volumen, weniger Aufwand",
  "copd_intro_belly_body": "Nutzt das Zwerchfell statt flacher Brustatmung. Mehr Volumen, weniger Aufwand.",
  "copd_intro_contact_title": "Die Hände führen den Atem",
  "copd_intro_contact_body": "Deine Hände lenken die Aufmerksamkeit auf bestimmte Lungenbereiche und vertiefen die Atmung.",
  "copd_intro_huff_title": "Schleim lösen ohne Belastung",
  "copd_intro_huff_body": "Befördert zähen Schleim nach oben ohne die Atemwege zu belasten.",
  "copd_intro_acbt_title": "Entspannen · Belüften · Reinigen",
  "copd_intro_acbt_body": "Eine tägliche Drei-Phasen-Routine: Entspannen, Belüften, Reinigen.",
  "copd_pursed_step1": "Ruhig durch die Nase einatmen.",
  "copd_pursed_step2": "Lippen locker aufeinanderlegen, wie beim Pfeifen.",
  "copd_pursed_step3": "Langsam gegen den Lippenwiderstand ausatmen. Doppelt so lange wie das Einatmen.",
  "copd_belly_step1": "Bequem hinsetzen oder hinlegen.",
  "copd_belly_step2": "Eine Hand auf den Bauch legen.",
  "copd_belly_step3": "Einatmen — Hand hebt sich spürbar.",
  "copd_belly_step4": "Ausatmen — gerne mit Lippenbremse.",
  "copd_contact_step1": "Hände flach auf Rippen oder Unterbauch legen.",
  "copd_contact_step2": "Beim Ausatmen leicht mit den Händen nachhelfen.",
  "copd_contact_step3": "Beim Einatmen gegen die Hände drücken.",
  "copd_huff_step1": "Tief einatmen.",
  "copd_huff_step2": "Mund weit öffnen, wie beim Hauchen gegen einen Spiegel.",
  "copd_huff_step3": "Luft stoßweise kräftig ausstoßen — 'Haff'-Geräusch.",
  "copd_acbt_p1_body": "Ein paar Minuten normal und entspannt atmen.",
  "copd_acbt_p2_body": "3–4 tiefe Atemzüge, jeweils 3 Sekunden halten.",
  "copd_acbt_p3_body": "Gelösten Schleim nach oben befördern, sanft abhusten.",
  "copd_step_next": "Weiter",
  "copd_intensity_title": "Wie war Deine Atmung?",
  "copd_intensity_scale_hint": "1 = leicht, 10 = sehr schwer",
  "copd_intensity_before_short": "Vorher",
  "copd_intensity_after_short": "Jetzt",
  "copd_intensity_continue": "Weiter",
  "copd_analytics_title": "Atem-Analyse",
  "copd_analytics_sub": "Deine Atemmuster im Verlauf.",
  "posture_coach_title": "Kutschersitz",
  "posture_coach_sub": "Vorderkante Stuhl, Beine breit, Ellbogen auf Oberschenkeln, Kopf hängen lassen.",
  "posture_goalkeeper_title": "Torwartstellung",
  "posture_goalkeeper_sub": "Leicht in Knie gehen, Oberkörper vorbeugen, Hände auf Oberschenkeln.",
  "posture_wall_title": "Wandstellung",
  "posture_wall_sub": "Rücken oder Seite an Wand lehnen.",
  "posture_lay_title": "Flach liegen",
  "posture_lay_sub": "Rückenlage, Beine leicht angewinkelt, Kopf entspannt zur Seite.",
  "posture_upright_title": "Aufrecht sitzen",
  "posture_upright_sub": "Auf Stuhlkante, Füße flach, Rücken lang, Schultern locker.",
  "posture_recommended_title": "Deine Haltung",
  "posture_recommended_sub": "Wähle die Haltung, die sich am besten anfühlt.",
  "explanation_ready_btn": "Ich bin bereit",
  "analytics_sect_trend": "Wochen-Trend",
  "analytics_sect_situations": "Situationen",
  "analytics_sect_techniques": "Techniken",
  "analytics_sect_postures": "Körperhaltungen",
  "analytics_sect_timeline": "Verlauf",
  "analytics_no_sessions": "Noch keine Sitzungen.",
  "analytics_no_sessions_sub": "Schließe Deine erste geführte Atemübung ab, um hier Statistiken zu sehen.",
  "analytics_no_data": "Keine Daten",
  "analytics_kpi_sessions": "Sitzungen",
  "analytics_kpi_avg_before": "Ø vorher",
  "analytics_kpi_avg_after": "Ø nachher",
  "analytics_kpi_reduction": "Ø Reduktion",
  "analytics_before_short": "Vorher",
  "analytics_sec": "s",
  "analytics_stage_early": "Erste Anzeichen",
  "analytics_stage_acute": "Akuter Notfall",
  "analytics_stage_subside": "Abklingend",
  "analytics_stage_prevent": "Vorbeugung",
  "analytics_tech_pursed_lip": "Lippenbremse",
  "analytics_tech_4_7_8": "4-7-8-Atmung",
  "analytics_tech_diaphragmatic": "Bauchatmung",
  "analytics_tech_belly": "Bauchatmung",
  "analytics_tech_contact": "Kontaktatmung",
  "analytics_tech_huff": "Huffing",
  "analytics_tech_acbt": "Aktiver Zyklus (ACBT)",
  "analytics_posture_coach": "Kutschersitz",
  "analytics_posture_goalkeeper": "Torwart",
  "analytics_posture_wall": "An der Wand",
  "analytics_posture_lay": "Flach liegen",
  "analytics_posture_upright": "Aufrecht sitzen",
  "analytics_posture_none": "Ohne Haltung",
  "analytics_tech_2_4_breathing": "2-4-Atmung",
  "analytics_tech_pursed": "Lippenbremse",
  "settings": "Einstellungen",
  "language": "Sprache",
  "event_display_pref": "Ereignisse anzeigen als",
  "by_technique": "Technik",
  "by_emotion": "Emotion",
  "by_base_situation": "Grundsituation",
  "privacy_and_data": "Datenschutz & Daten",
  "upgrade_plan": "Plan upgraden",
  "upgrade_to_coach": "Zum Coach-Account upgraden",
  "mode": "Modus",
  "switch_to_coach_view": "Zur Coach-Ansicht wechseln",
  "sign_out": "Abmelden",
  "disclaimer": "Diese App unterstützt emotionale Selbstregulation und ersetzt keine medizinische, psychologische oder Notfallversorgung.",
  "download_my_data": "Meine Daten exportieren",
  "gdpr_art20": "Hole dir eine Kopie von allem (DSGVO Art. 20)",
  "terms_of_service": "Nutzungsbedingungen",
  "privacy_policy": "Datenschutzerklärung",
  "refund_policy": "Rückerstattungsrichtlinie",
  "blocked_users_title": "Blockierte Nutzer:innen",
  "blocked_users_empty": "Du hast noch niemanden blockiert.",
  "delete_my_account": "Konto löschen",
  "delete_my_account_sub": "Endgültig · löscht alle Daten kaskadierend",
  "delete_account_confirm_title": "Konto dauerhaft löschen?",
  "delete_account_confirm_body": "Das kann nicht rückgängig gemacht werden. Alle Tagebuch-, Chat- und Übungsdaten werden gelöscht.",
  "delete_account_confirm_cta": "Löschen",
  "need_help_now": "Brauchst du jetzt Hilfe?",
  "crisis_helplines": "Krisen-Hotlines · Notrufnummern",
  "data_sharing": "Datenfreigabe",
  "data_sharing_sub": "Bestimme selbst, was jeder Coach sieht",
  "data_sharing_ic_badge": "Inner Circle",
  "data_sharing_n_shared": "{count} geteilt",
  "data_sharing_none_shared": "Nichts geteilt",
  "data_sharing_intro": "Wähle genau, was {coachName} sehen darf. Du kannst das jederzeit ändern.",
  "data_sharing_save": "Änderungen speichern",
  "data_sharing_updated": "Aktualisiert {when}",
  "data_sharing_none_available_body": "Du bist noch mit keinem Coach verbunden. Buche eine Session oder tritt einem Inner Circle bei.",
  "profile": "Profil",
  "profile_subtitle": "Dein Konto, deine Coaches und dein Empfehlungslink.",
  "edit_name": "Name bearbeiten",
  "email": "E-Mail",
  "phone": "Telefonnummer",
  "country": "Land",
  "country_pick_hint": "Bitte Land auswählen",
  "contraindications": "Kontraindikationen",
  "contraindications_hint": "Wir überspringen Techniken, die für dich nicht sicher sein könnten.",
  "weekly_report_title": "Wöchentliche Praxis-Mail",
  "weekly_report_hint": "Jeden Sonntag Abend eine sanfte Zusammenfassung deiner Woche per E-Mail.",
  "saved": "Gespeichert ✓",
  "invite_friends_earn": "Freunde einladen · je 5 € bekommen",
  "invite_friends_sub": "Ihr beide werdet nach der ersten Sitzung belohnt",
  "create_account_cta": "Konto erstellen",
  "account": "Konto",
  "edit_profile": "Profil bearbeiten",
  "account_more": "Mehr",
  "account_manage": "Konto verwalten",
  "consent_forms_title": "Einwilligungen",
  "consent_forms_sub": "Deine unterschriebenen Einwilligungsformulare.",
  "consent_forms_empty": "Noch keine unterschriebenen Formulare.",
  "consent_signed_on": "Unterschrieben am {when}",
  "consent_version": "Version {v}",
  "unblock": "Entsperren",
  "bio_label": "Über mich",
  "export_started": "Dein Datenexport wird heruntergeladen.",
  "delete_code_prompt": "Gib den Code {code} ein, um die endgültige Löschung zu bestätigen:",
  "delete_code_mismatch": "Code stimmt nicht überein. Konto wurde NICHT gelöscht.",
  "profile_account_section": "Kontodaten",
  "profile_health_section": "Gesundheit",
  "add": "Hinzufügen",
  "safety": "Sicherheit",
  "you_re_not_alone": "Du bist nicht allein",
  "if_you_are_in_immediate_danger_call": "Wenn du in unmittelbarer Gefahr bist, rufe jetzt deine lokale Notrufnummer an.",
  "your_country": "Dein Land",
  "safety_other": "Andere…",
  "choose_country": "Land auswählen",
  "search_country": "Land suchen…",
  "no_match_try_a_different_name": "Keine Übereinstimmung. Versuche einen anderen Namen.",
  "my_within_is_not_a_medical_device_or_a": "My Within ist kein Medizinprodukt und kein Ersatz für professionelle Betreuung. Wenn du mit einer therapeutischen oder ärztlichen Fachperson zusammenarbeitest, folge bitte weiterhin deren Anleitung.",
  "help_faq": "Hilfe & FAQ",
  "search_all_help_articles": "Alle Hilfeartikel durchsuchen…",
  "new_support_request": "Neue Support-Anfrage",
  "start_a_new_support_chat": "Neuen Support-Chat starten",
  "your_email": "Deine E-Mail",
  "you_email_com": "du@email.com",
  "describe_your_issue": "Beschreibe dein Anliegen…",
  "suppor_send": "Senden",
  "suppor_reply": "Antworten…",
  "my_within_ai": "My Within AI",
  "status": "Status",
  "my_within_team": "💬 My Within Team",
  "forwarded_to_a_human_reply_arriving_by": "↳ An einen Menschen weitergeleitet – Antwort erfolgt per E-Mail.",
  "popup_email_required": "E-Mail erforderlich",
  "popup_email_for_reply": "Bitte gib deine E-Mail-Adresse an, damit wir dir antworten können.",
  "this_week": "Diese Woche",
  "sessions": "Sitzungen",
  "streak_days": "Serie",
  "avg_drop": "Ø Senkung",
  "digest_unique_days": "Praxis-Tage",
  "digest_avg_duration": "Durchschnittliche Dauer",
  "digest_biggest_drop": "Größte Verschiebung",
  "digest_top_emotion": "Am meisten gefühlt",
  "digest_top_technique": "Lieblings-Technik",
  "digest_empty_client": "Diese Woche keine Sessions – ein Atemzug zählt.",
  "digest_email_me": "Per Mail schicken",
  "digest_hint_client": "Dein Digest kommt jeden Sonntagabend per Mail.",
  "digest_sent_title": "An dein Postfach geschickt",
  "digest_sent_body": "Schau in deine E-Mails für den vollen Digest.",
  "digest_trend_4w": "Letzte 4 Wochen",
  "friendly_error_title": "Ein Moment noch",
  "coach_earnings_cashable": "Coach-Einnahmen (auszahlbar)",
  "coach_earnings_held": "Coach-Einnahmen (gesperrt)",
  "credits_2": "Credits",
  "no_transactions_yet": "Noch keine Transaktionen.",
  "purchases_refunds_and_coach_earnings": "Käufe, Rückerstattungen und Coach-Einnahmen erscheinen hier.",
  "transaction_history": "Transaktionsverlauf",
  "abbrechen_und_neu_starten": "Abbrechen und neu starten",
  "bevor_dein_vorteil_aktiviert_wird": "Bevor dein Vorteil aktiviert wird, verifizieren wir eine Zahlungsmethode über Stripe. Es wird kein Geld abgebucht – nur eine sichere Karte wird hinterlegt.",
  "case_insensitive_format_mw_gefolgt_von": "Groß-/Kleinschreibung egal · Format: MW- gefolgt von einer kurzen Kombination aus Buchstaben und Zahlen.",
  "dein_code": "Dein Code",
  "dein_vorteil_wurde_deinem_account": "Dein Vorteil wurde deinem Konto gutgeschrieben.",
  "hast_du_unsere_crowdfunding_kampagne": "Hast du unsere Crowdfunding-Kampagne unterstützt? Gib deinen Pledge-Code ein und dein Vorteil wird sofort nach einer kurzen Zahlungsverifizierung aktiviert.",
  "kein_code_erhalten": "Kein Code erhalten?",
  "mw_xxx_xxxx": "MW-XXX-XXXX",
  "pledge_code_einlo_sen": "Pledge-Code einlösen",
  "support_my_within_com": "support@my-within.com",
  "warte_auf_deine_ru_ckkehr": "Warten auf deine Rückkehr ...",
  "weiter_zur_zahlungsverifizierung": "Weiter zur Zahlungsverifizierung",
  "willkommen_bei_my_within": "Willkommen bei My Within",
  "zuru_ck_zur_startseite": "Zurück zur Startseite",
  "ai_verdict": "KI-Bewertung",
  "become_coach_complete_steps": "Erledige beide Schritte unten, um Zirkel, Feed-Posts, Produkte und bezahlte Abos freizuschalten.",
  "become_coach_full_access": "Du hast vollen Zugriff auf alle Monetarisierungs-Features.",
  "become_coach_rejected": "Bitte lade ein klareres Zertifikat hoch oder schreibe an renew@insideoutharmony.com.",
  "become_coach_title": "Coach werden",
  "dpa_accept": "Vereinbarung akzeptieren",
  "dpa_accept_button": "Joint-Controller-Vereinbarung akzeptieren",
  "dpa_body": "Als Coach seid ihr und Inside Out Harmony e.U. {joint} für die Daten eurer Klienten gemäß DSGVO Art. 26. Du verpflichtest dich, Klientendaten nur auf der Plattform zu verarbeiten, sie niemals extern zu exportieren oder zu kopieren und Vorfälle innerhalb von 24 Stunden zu melden.",
  "dpa_joint_controllers": "gemeinsam Verantwortliche",
  "dpa_read_full": "Vollständige Vereinbarung lesen →",
  "dpa_title": "Joint-Controller-Vereinbarung (DPA)",
  "guest_cta_body": "Um dich als Coach zu verifizieren, brauchen wir einen Account mit E-Mail und Passwort. Danach kannst du Dokumente hochladen und loslegen.",
  "guest_cta_title": "Erstelle zuerst dein Konto",
  "not_yet_verified": "Noch nicht verifiziert",
  "once_verified": "Nach der Verifizierung kannst du:",
  "popup_approved_check": "Genehmigt ✅",
  "popup_couldnt_read_image": "Bild konnte nicht gelesen werden",
  "popup_error_title": "Etwas ist schiefgelaufen",
  "popup_submitted": "Übermittelt",
  "qual_cert_areas": "Akzeptierte Bereiche: Atemarbeit, Meditation, Achtsamkeit, Yoga-Therapie, Coaching, Psychologie, Therapie, Somatic Experiencing und verwandte Wellness-Qualifikationen.",
  "qual_cert_before_verified": "Affiliate-Empfehlungen funktionieren auch vor der Verifizierung.",
  "qual_cert_hint": "Lade ein klares Foto/Scan deiner Coaching-, Therapie-, Atemarbeits- oder Wellness-Zertifizierung hoch. Die KI prüft es innerhalb weniger Sekunden. Wenn wir es nicht automatisch verifizieren können, prüft ein Admin innerhalb von 48 Stunden.",
  "qual_cert_reupload": "Zertifikat erneut hochladen",
  "qual_cert_title": "Qualifikations-Zertifikat",
  "qual_cert_upload": "Zertifikat hochladen",
  "qual_cert_upload_short": "Zertifikat hochladen",
  "account_help": "Hilfe",
  "account_support": "Support",
  "account_purchases": "Kaufhistorie",
  "account_redeem": "Pledge einlösen",
  "help_search_empty": "Keine Ergebnisse für „{q}“. Versuche andere Begriffe oder öffne den Support.",
  "purchases_balance": "Guthaben",
  "weekly_digest_email_toggle": "Wöchentliche Zusammenfassung per E-Mail",
  "redeem_needs_payment": "Zahlungsverifizierung erforderlich. Bitte schließe sie in der mobilen App ab.",
  "redeem_invalid": "Code ungültig oder bereits eingelöst.",
  "support_resolved": "Gelöst",
  "ok": "OK",

  // Breakout (Wave 1 · client parity)
  "breakout": "Breakout",
  "breakout_tab_sub": "Ein begleiteter Weg vom Gefühl zur Erleichterung.",
  "breakout_start_session": "Sitzung starten",
  "breakout_start_sub": "Wähle ein Gefühl, teile den Kontext, atme.",
  "breakout_how_it_works": "So funktioniert es",
  "breakout_step1": "Gefühl benennen",
  "breakout_step2": "Situation teilen",
  "breakout_step3": "Intensität 1–10 bewerten",
  "breakout_step4": "Passende Technik erhalten",
  "breakout_step5": "Mit der Anleitung atmen",
  "breakout_step6": "Intensität erneut bewerten",
  "breakout_step7": "Speichern & durchgehen",
  "what_feeling": "Was fühlst du?",
  "base_situation": "Was ist die Grundsituation?",
  "base_situation_hint": "Wo lebt dieses Gefühl?",
  "bs_work": "Arbeit",
  "bs_private": "Privat",
  "bs_public": "Öffentlich",
  "bs_togetherness": "Beziehung",
  "bs_family": "Familie",
  "bs_health": "Gesundheit",
  "bs_financial": "Finanzen",
  "bs_learning": "Lernen",
  "bs_other": "Sonstiges",
  "how_intense": "Wie intensiv ist es?",
  "intensity_scale_hint": "1 = kaum spürbar · 10 = überwältigend",
  "situation_belief_after_hint": "Situation und Überzeugung fragen wir nach dem Atmen, damit du sofort loslegen kannst.",
  "try_technique": "Probiere {name}",
  "how_it_works_row": "So funktioniert es",
  "expected": "Erwartet",
  "duration": "Dauer",
  "caution": "Vorsicht",
  "min": "Min.",
  "begin_breathing": "Atmung beginnen",
  "step_of": "Schritt {n} von {total}",

  // Share Cards (Wave 1 · client parity)
  "share_cards_title": "Share-Karten",
  "sc_tab_all": "Alle Karten",
  "sc_tab_sent": "Verschickt",
  "sc_filter_all": "Alle",
  "sc_filter_client": "Client-Karten",
  "sc_filter_coach": "Coach-Karten",
  "sc_empty_filter": "Keine Karten in diesem Filter.",
  "sc_empty_sent_head": "Noch keine Karte verschickt",
  "sc_empty_sent_body": "Sobald du eine Karte teilst, findest du sie hier.",
  "sc_browse": "Karten ansehen",
  "sc_share_moment": "Teile deinen Moment",
  "sc_share_details": "Mehr Details teilen (Emotion, Intensität)",
  "sc_your_link": "Dein persönlicher Link",
  "sc_copy": "Kopieren",
  "sc_copied": "Link kopiert",
  "sc_step1": "Klicke auf „Link kopieren“",
  "sc_step2": "Teile die Karte auf deinem Kanal",
  "sc_step3": "Füge den kopierten Link in die Beschreibung ein",
  "sc_steps_note": "Nur über deinen Link profitierst du vom Affiliate-Programm.",
  "sc_download": "Herunterladen",
  "sc_share": "Teilen",
  "sc_fine": "Klicken Menschen auf deinen Link, landen sie automatisch auf der aktiven Phase-Landing.",
  "nav.share_cards": "Share-Karten",

  // Story Wall (Wave 1 · client parity)
  "story_wall_coach_title": "Story Wall",
  "story_wall_coach_sub": "Teile Momente aus dem Weg deiner Klient:innen — nur mit beidseitigem Einverständnis.",
  "story_wall_coach_empty": "Noch keine Momente entworfen.",
  "story_wall_coach_empty_cta": "Ersten Moment festhalten",
  "story_wall_create_title": "Moment festhalten",
  "story_wall_client_lbl": "Klient:in",
  "story_wall_kind_lbl": "Art",
  "story_wall_kind_reflection": "Reflexion",
  "story_wall_kind_wellbeing_shift": "Wohlbefinden",
  "story_wall_kind_streak": "Serie",
  "story_wall_kind_quote": "Zitat",
  "story_wall_kind_milestone": "Meilenstein",
  "story_wall_title_lbl": "Titel",
  "story_wall_title_ph": "Kurze Kernaussage — z. B. Von 8 auf 3",
  "story_wall_body_lbl": "Beschreibung",
  "story_wall_body_ph": "Was ist passiert? Halte es warm, konkret und respektvoll.",
  "story_wall_metric_lbl": "Metrik (optional)",
  "story_wall_metric_ph": "z. B. 8 → 3 oder 30 Tage",
  "story_wall_color_lbl": "Farbakzent",
  "story_wall_double_consent_note": "Nach dem Speichern muss deine Klient:in den genauen Text bestätigen. Erst dann kannst du veröffentlichen.",
  "story_wall_missing_fields": "Bitte wähle eine:n Klient:in und schreibe Titel + Beschreibung.",
  "story_wall_draft_save": "Entwurf speichern",
  "story_wall_publish": "Veröffentlichen",
  "story_wall_unpublish": "Von Wall nehmen",
  "story_wall_archive": "Löschen",
  "story_wall_archive_confirm_title": "Moment endgültig löschen?",
  "story_wall_archive_confirm_body": "Das Dokument wird archiviert und ist nicht mehr auf der Story Wall sichtbar.",
  "story_wall_status_draft": "Entwurf",
  "story_wall_status_published": "Live",
  "story_wall_status_unlisted": "Nicht gelistet",
  "story_wall_review": "Bearbeiten",
  "story_wall_review_and_agree": "Einverständnis geben",
  "story_wall_coach_consent_lbl": "Dein Einverständnis",
  "story_wall_client_consent_lbl": "Einverständnis der Klient:in",
  "story_wall_consent_pending": "Ausstehend",
  "story_wall_consent_granted": "Erteilt",
  "story_wall_consent_waiting_client": "Wartet auf Klient:in",
  "story_wall_consent_grant": "Ja, veröffentlichen",
  "story_wall_consent_revoke": "Widerrufen",
  "story_wall_coach_consent_title": "Dein Einverständnis",
  "story_wall_coach_consent_body": "Bestätige, dass du diesen Text so öffentlich zeigen möchtest. Du kannst dein Einverständnis jederzeit zurückziehen.",
  "story_wall_show_name_lbl": "Meinen Namen zeigen",
  "story_wall_show_name_coach_sub": "Standard: dein Name bleibt privat.",
  "story_wall_show_name_client_sub": "Standard: nur deine Initiale wird gezeigt.",
  "story_wall_publish_needs_consents": "Bitte warte, bis beide Seiten einverstanden sind.",
  "story_wall_client_title": "Momente in Prüfung",
  "story_wall_client_sub": "Dein:e Coach möchte diese Momente teilen. Erst mit deinem Einverständnis werden sie veröffentlicht.",
  "story_wall_client_empty": "Keine Momente warten auf dich.",
  "story_wall_client_consent_title": "Bist du damit einverstanden?",
  "story_wall_client_consent_sub": "Prüfe den genauen Text unten. Nichts wird ohne dein OK öffentlich.",
  "story_wall_client_consent_thanks_title": "Danke 🌿",
  "story_wall_client_consent_thanks_body": "Dein:e Coach wird informiert und kann jetzt veröffentlichen.",
  "story_wall_privacy_note": "Wir speichern nur, was hier steht. Du kannst dein Einverständnis jederzeit widerrufen — der Moment verschwindet dann sofort.",
  "story_wall_grant": "Einverstanden",
  "story_wall_decline": "Ablehnen",
  "story_wall_by_coach": "von {name}",
  "story_wall_by_coach_anonymous": "von einem/einer Coach",
  "story_wall_browse_public": "Öffentliche Wall ansehen",
  "story_wall_public_title": "Story Wall",
  "story_wall_public_sub": "Echte Momente aus der my-within-Community — geteilt mit Einverständnis aller.",
  "story_wall_public_empty": "Noch keine öffentlichen Momente.",
  "story_wall_filter_all": "Alle",
  "story_wall_moment_title": "Story-Moment",
  "story_wall_moment_missing_title": "Moment nicht gefunden",
  "story_wall_moment_missing_body": "Dieser Moment ist nicht mehr öffentlich oder wurde widerrufen.",
  "story_wall_share_title": "Diesen Moment teilen",
  "story_wall_share_body": "Ich habe gerade diesen Moment auf my-within entdeckt: {title}",
  "story_wall_share_copied": "Link kopiert",
  "story_wall_share_copied_body": "Der Link ist jetzt in deiner Zwischenablage.",
  "story_wall_share_cta": "Teilen",
  "story_wall_share_open_card": "Fact-Card öffnen",

  // Story Mode (Wave 1 · client parity)
  "nav.story_wall": "Story-Wand",
  "nav.story_mode": "Story-Modus",
  "sm_title": "Story-Modus",
  "sm_cover_eyebrow": "Ein privates Memoir deiner Monate hier",
  "sm_cover_title": "Die Kapitel, die du bewahrt hast.",
  "sm_cover_meta": "{entries} Einträge über {days} Tage · {chapters} Kapitel",
  "sm_cover_body": "Dies ist der Raum, in dem deine Worte leben. Nichts hier wird mit deinem Coach geteilt – diese Chronik gehört nur dir. Scrolle langsam. Lies dich wie ein Buch.",
  "sm_empty_title": "Noch nichts zu erzählen.",
  "sm_empty_body": "Ein paar Journaleinträge, ein oder zwei Übungen – und das erste Kapitel schreibt sich von selbst. Komm in ein, zwei Wochen wieder.",
  "sm_chapter": "Kapitel {n}",
  "sm_kind_journal": "Journal",
  "sm_kind_practice": "Übung",
  "sm_kind_breakout": "Breakout",
  "sm_kind_booking": "Session",
  "sm_mood": "Stimmung {a} → {b}",
  "sm_intensity": "Intensität {a} → {b}",
  "sm_download_pdf": "Als PDF herunterladen",
  "sm_footer_note": "Deine Geschichte bleibt bei dir. Das PDF ist privat und wird auf dieses Gerät geladen.",

  // Welle 2 · Client-Extras (Collections · Focus-Timer · Connected-Breath · Method-Player · Unlocked)
  "collections_title": "Meine Kollektionen",
  "collections_empty_title": "Noch keine Kollektionen",
  "collections_empty_sub": "Tippe das Lesezeichen-Icon auf einem Beitrag.",
  "collections_n_posts": "{n} Beiträge",
  "collections_public": "Öffentlich",
  "collections_private": "Privat",
  "collections_not_found": "Diese Kollektion existiert nicht mehr.",
  "collections_now_private": "Wieder privat",
  "collections_now_private_body": "Der Link funktioniert nicht mehr.",
  "collections_now_public": "Kollektion ist öffentlich",
  "collections_now_public_body": "Jeder mit dem Link kann sie sehen.",
  "collections_share_msg": "Schau dir meine '{name}'-Kollektion auf My Within an: {url}",
  "collections_share_again": "Link teilen",
  "collections_edit_title": "Kollektion bearbeiten",
  "collections_field_name": "Name",
  "collections_field_description": "Beschreibung",
  "collections_field_description_ph": "Worum geht's in dieser Kollektion?",
  "collections_field_emoji": "Emoji",
  "collections_field_color": "Farbe",
  "collections_empty_folder": "Diese Kollektion ist leer — speichere Beiträge, um sie zu füllen.",
  "collections_paid_tag": "Bezahlt",
  "action_failed": "Aktion fehlgeschlagen",
  "post_untitled": "Ohne Titel",
  "focus_timer_title": "Deep-Work-Timer",
  "focus_timer_preset_classic": "Klassisch",
  "focus_timer_preset_sprint": "Sprint",
  "focus_timer_preset_extended": "Extended",
  "focus_timer_phase_focus": "Fokus",
  "focus_timer_phase_breathing": "Atmen",
  "focus_timer_phase_break": "Pause",
  "focus_timer_phase_done": "Fertig",
  "focus_timer_phase_ready": "Bereit",
  "focus_timer_hint_breathing": "Box-Atmung 4-4-4-4 · Nervensystem zurücksetzen.",
  "focus_timer_hint_break": "Aufstehen, in die Ferne schauen, Wasser trinken.",
  "focus_timer_hint_focus": "Tiefer Fokus — Benachrichtigungen stumm und los.",
  "focus_timer_hint_done": "Stark gemacht — {n} Sprint(s) fertig.",
  "focus_timer_hint_ready": "Wähle ein Preset und starte — nach jedem Sprint läuft eine Atempause.",
  "focus_timer_completed_sprints": "{n} Sprint(s) fertig",
  "focus_timer_start": "Start",
  "focus_timer_start_next": "Nächsten Sprint starten",
  "focus_timer_finish": "Beenden",
  "focus_timer_pause": "Pause",
  "focus_timer_resume": "Weiter",
  "focus_timer_reset": "Zurücksetzen",
  "focus_timer_tip": "Tipp: Handy mit dem Display nach unten legen. Der Bildschirm bleibt an, damit du während der Atempause auf den Rhythmus schauen kannst.",
  "breath_inhale": "Einatmen",
  "breath_exhale": "Ausatmen",
  "breath_hold_in": "Halten",
  "breath_hold_out": "Ruhen",
  "connected_intro_title": "Verbundenes Atmen",
  "connected_intro_body": "Eine tiefe Loslass-Praxis — lies dies vollständig, bevor Du sie ausprobierst.",
  "connected_what_it_is": "Was es ist",
  "connected_what_body": "Eine durchgehende, kreisförmige Atmung — keine Pausen zwischen Ein- und Ausatmung — über 30–60 Minuten gehalten. Oft durch den Mund, im Liegen.",
  "connected_how_works": "Wie es wirkt",
  "connected_how_body": "Das durchgehende Muster verändert die Blutchemie und senkt die Wache des denkenden Verstands. Gehaltene Emotionen, Erinnerungen und Körperzustände können an die Oberfläche kommen.",
  "connected_benefits": "Was es geben kann",
  "connected_benefits_body": "Emotionale Entladung, Einsicht, ein spürbares Gefühl von Integration, manchmal ein sehr weit gefasster Zustand. Es ist eine große Praxis — begegne ihr mit Respekt.",
  "connected_safety": "Nur mit erfahrener Begleitung",
  "connected_safety_body": "Das ist keine Solo-Praxis. Nicht alleine üben — nicht beim Autofahren, nicht im Wasser, nicht unter Medikamenten, die das Nervensystem beeinflussen, nicht während der Schwangerschaft, nicht bei schweren Herz- oder Lungenerkrankungen, nicht bei unbehandelten Trauma-Erfahrungen. Immer mit einer erfahrenen Person üben, die den Raum hält, Dysregulation erkennt und die Integration begleitet.",
  "connected_facilitator_only": "Kein In-App-Player — bewusst so.",
  "connected_close": "Verstanden",
  "mp_load_failed": "Konnte nicht laden",
  "mp_by": "von",
  "mp_auto_chain": "Automatischer Übergang",
  "mp_start": "Start",
  "mp_pause": "Pause",
  "mp_next_in": "Weiter in",
  "mp_next_step": "Weiter zum nächsten Baustein",
  "mp_finish": "Fertig · Feedback geben",
  "mp_chain_cancel": "Auto-Übergang stoppen",
  "mp_disclaimer": "Diese Übung ist ein Coaching-Angebot und ersetzt weder ärztliche Diagnose noch Psychotherapie. Bei akuten Beschwerden wende dich an eine Fachperson.",
  "mp_fb_title": "Wie war die Übung?",
  "mp_fb_sub": "Dein Coach sieht deinen kurzen Puls.",
  "mp_fb_note_ph": "Optional: was hat besonders gutgetan?",
  "mp_fb_skip": "Überspringen",
  "mp_fb_send": "Senden",
  "cm_q_required": "Pflicht",
  "unlocked_title": "Freigeschaltet",
  "unlocked_sub": "Deine gekauften und geschenkten Methoden",
  "unlocked_empty": "Noch nichts freigeschaltet. Sobald dein Coach dir eine Methode schenkt oder du eine kaufst, findest du sie hier.",
  "unlock_src_gift": "Geschenk",
  "unlock_src_paid": "Gekauft",
  "unlock_src_public": "Öffentlich",
  "unlocked_posts_title": "Meine freigeschalteten Posts",
  "unlocked_posts_sub": "Bezahlte Feed-Beiträge deiner Coaches",
  "unlocked_posts_empty_title": "Noch keine Posts freigeschaltet",
  "unlocked_posts_empty_body": "Wenn du im Feed einen bezahlten Beitrag freischaltest, findest du ihn hier wieder.",
  "unlocked_posts_go_feed": "Zum Feed",
  "nav.collections": "Kollektionen",
  "nav.focus_timer": "Fokus-Timer",
  "nav.connected_breath": "Verbundenes Atmen",
  "nav.unlocked_methods": "Freigeschaltet",
  "nav.unlocked_posts": "Gekaufte Beiträge",

  // Welle 2 · Methoden-Kind-Labels (Method-Player / Unlocked)
  "method_kind_audio": "Audio",
  "method_kind_video": "Video",
  "method_kind_breathwork": "Atemübung",
  "method_kind_questions": "Fragen",
  "method_kind_combo": "Kombi",
  "method_kind_body_scan": "Körper-Scan",
  "method_kind_gratitude": "Dankbarkeit",
  "method_kind_visualization": "Visualisierung",
  "method_kind_movement": "Bewegung",
  "method_kind_check_in": "Check-In",
  "method_kind_journal": "Journal",

  // Welle 3 · Collab-Marketplace + Snapshot-Anfragen + Blockierte Nutzer
  "client_collab_title": "Collab-Bereich",
  "client_collab_subtitle": "Alles rund um deine Coach-Kollaborationen",
  "client_collab_tile_chats_title": "Meine Collab-Chats",
  "client_collab_tile_chats_sub": "Alle laufenden Coach-Chats mit dir",
  "client_collab_tile_offerings_title": "Collab-Angebote kaufen",
  "client_collab_tile_offerings_sub": "Coach-Duos & -Gruppen entdecken und buchen",
  "client_collab_tile_projects_title": "Meine aktiven Projekte",
  "client_collab_tile_projects_sub": "Angebote & Circles an denen du teilnimmst",
  "client_collab_tile_discover_title": "Collab Coaches entdecken",
  "client_collab_tile_discover_sub": "Coach-Paare mit gemeinsamen Angeboten",
  "client_collab_tile_reviews_title": "Meine Bewertungen",
  "client_collab_tile_reviews_sub": "Abgeschlossene Projekte bewerten",
  "client_collab_discover_title": "Collab Coaches entdecken",
  "client_collab_discover_sub": "Coach-Paare & -Gruppen mit gemeinsamen Angeboten",
  "client_collab_discover_empty": "Aktuell keine Coach-Paare mit Collab-Angeboten.",
  "client_collab_discover_offerings": "Gemeinsame Angebote",
  "client_collab_discover_circles": "Collab Circles",
  "starter_card_eyebrow": "Zum Reinschnuppern",
  "starter_card_eyebrow_matched": "Passt zu deiner Haupt-Emotion · {emotion}",
  "starter_card_a11y": "Beispiel-Collab-Paket ausprobieren",
  "client_collab_offerings_title": "Collab-Angebote kaufen",
  "client_collab_offerings_sub": "Coach-Duos & -Gruppen, die du buchen kannst",
  "client_collab_offerings_empty": "Aktuell keine Collab-Angebote verfügbar.",
  "client_collab_included_unlimited": "Unbegrenzt",
  "client_collab_included_msgs": "Nachr.",
  "client_collab_included_calls": "Calls",
  "client_collab_included_live": "Live",
  "client_collab_already_bought": "Gekauft",
  "client_collab_buy_cta": "Kaufen",
  "client_collab_purchase_confirm_title": "Kauf bestätigen",
  "client_collab_purchase_confirm_body": "{title} für {price}?",
  "client_collab_pay_credits": "Mit {n} Credits bezahlen",
  "client_collab_purchase_success_title": "Gekauft!",
  "client_collab_purchase_success_body": "Du kannst jetzt mit {coaches} chatten.",
  "client_collab_purchase_fail_body": "Kauf fehlgeschlagen.",
  "client_collab_purchase_credits_short": "Du brauchst {need} Credits, hast aber nur {have}.",
  "client_collab_projects_title": "Meine aktiven Projekte",
  "client_collab_projects_sub": "Angebote & Circles an denen du teilnimmst",
  "client_collab_projects_empty": "Noch keine aktiven Collab-Projekte.",
  "client_collab_kind_circle": "Circle",
  "client_collab_kind_offering": "Angebot",
  "client_collab_kind_shared": "Multi",
  "client_collab_reviews_title": "Meine Collab-Bewertungen",
  "client_collab_reviews_sub": "Bewertung pro Coach pro Projekt",
  "client_collab_reviews_empty": "Noch keine abgeschlossenen Projekte zum Bewerten.",
  "client_collab_review_add": "Jetzt bewerten",
  "client_collab_review_saved": "Bewertung gespeichert",
  "client_collab_review_editor_title": "Bewerte {coach}",
  "client_collab_review_comment_ph": "Ein paar Worte (optional)…",
  "client_collab_review_submit": "Bewertung speichern",
  "client_collab_chats_title": "Meine Collab-Chats",
  "client_collab_chats_sub": "Alle Chats mit deinen Coaches",
  "client_collab_chats_empty": "Noch keine Collab-Chats. Kaufe ein Collab-Angebot um zu starten.",
  "client_collab_no_messages": "Noch keine Nachrichten",
  "client_collab_project_not_found": "Projekt nicht gefunden",
  "client_collab_project_coaches": "Deine Coaches",
  "client_collab_project_about": "Über dieses Projekt",
  "client_collab_project_chat": "Chat",
  "client_collab_project_open_chat": "Chat mit deinen Coaches öffnen",
  "client_collab_project_chat_soon": "Chat wird nach der ersten Aktivität verfügbar.",
  "client_collab_project_sessions": "Sessions",
  "client_collab_project_sessions_empty": "Noch keine Sessions geplant.",
  "client_collab_project_documents": "Materialien",
  "client_collab_project_documents_empty": "Noch keine Materialien geteilt.",
  "client_collab_project_tasks": "Aufgaben",
  "client_collab_project_tasks_empty": "Aktuell keine To-Dos für dich.",
  "session": "Session",
  "week": "Woche",
  "month": "Monat",
  "total": "gesamt",
  "document": "Dokument",
  "open_report": "Bericht öffnen",
  "snapshot_requests_inbox": "Snapshot-Anfragen",
  "snapshot_requests_none": "Aktuell keine Snapshot-Anfragen.",
  "snapshot_requests_from": "Von {coach}",
  "snapshot_requests_period": "Letzte {days} Tage",
  "snapshot_requests_approve": "Freigeben & teilen",
  "snapshot_requests_decline": "Ablehnen",
  "snapshot_requests_help": "Bei Freigabe wird aus deinen letzten {days} Tagen ein neuer WEVA-Bericht erzeugt — sichtbar nur für diesen Coach.",
  "snapshot_requests_status_pending": "Offen",
  "snapshot_requests_status_approved": "Geteilt",
  "snapshot_requests_status_approved_no_data": "Freigegeben (keine Daten)",
  "snapshot_requests_status_declined": "Abgelehnt",
  "snapshot_approved_toast": "Snapshot mit deinem Coach geteilt ✨",
  "snapshot_declined_toast": "Abgelehnt — nichts geteilt.",
  "snapshot_no_data_msg": "Für diesen Zeitraum gibt es noch keine Daten. Praktiziere zuerst etwas und gib danach erneut frei.",
  "popup_approve_failed": "Bestätigung fehlgeschlagen",
  "blocked_at": "Blockiert am",
  "unblock_cta": "Blockierung aufheben",
  "nav.snapshot_requests": "Snapshot-Anfragen",
  "nav.blocked_users": "Blockierte Nutzer",
  "circle_news_just_now": "gerade eben",
  "nav.collab_area": "Collab-Bereich",
  "discover_strip_title": "Entdecken",
  "discover_strip_sub": "Neue Extras für dich",
  "discover_strip_new": "Neu",

  "nav.assistant": "AI Praxis Assistent",
  "support": "Support",
  "aipa.title": "AI Praxis Assistent",
  "aipa.subtitle": "Dein proaktiver Assistent für den Praxisalltag.",
  "aipa.upsell_headline": "Mehr Zeit für deine Klient:innen",
  "aipa.upsell_sub": "Dein KI-Assistent bereitet jeden Morgen ein Briefing vor, priorisiert Aufgaben, entwirft Nachrichten und automatisiert Routinen — du behältst die Kontrolle.",
  "aipa.feature_briefing": "Tägliches Briefing",
  "aipa.feature_briefing_desc": "Jeden Morgen eine klare Übersicht zu Klient:innen, Terminen und Prioritäten.",
  "aipa.feature_tasks": "Aufgaben-Manager",
  "aipa.feature_tasks_desc": "Priorisiere, delegiere an die KI und behalte den Verlauf im Blick.",
  "aipa.feature_chat": "Assistenten-Chat",
  "aipa.feature_chat_desc": "Stelle Fragen zu deiner Praxis und erhalte konkrete Antworten.",
  "aipa.feature_workflows": "Automatische Workflows",
  "aipa.feature_workflows_desc": "Wiederkehrende Abläufe erledigt der Assistent — mit deiner Freigabe.",
  "aipa.price_line": "{price} € / Monat",
  "aipa.trial_note": "7 Tage kostenlos testen · jederzeit kündbar",
  "aipa.start_trial": "7 Tage kostenlos starten",
  "aipa.start_sub": "Jetzt abonnieren",
  "aipa.starting": "Weiterleitung zur Kasse…",
  "aipa.consent_hint": "Danach 20 €/Monat, automatische Verlängerung bis zur Kündigung.",
  "aipa.checkout_error": "Konnte gerade nicht starten. Bitte versuche es erneut.",
  "aipa.status_trial": "Testphase",
  "aipa.status_active": "Aktiv",
  "aipa.status_canceled": "Gekündigt",
  "auth.cb_success": "Erfolgreich angemeldet!",
  "auth.cb_failed": "Google-Anmeldung fehlgeschlagen. Bitte versuche es erneut.",
  "auth.cb_completing": "Anmeldung wird abgeschlossen …",
  "nf.meta": "Seite nicht gefunden",
  "nf.title": "Diese Seite gibt es nicht.",
  "nf.body": "Vielleicht findest du, was du suchst, auf unserem Marktplatz.",
  "nf.home": "Startseite",
  "aipa.card_ready": "Dein Assistent ist startklar. Öffne ihn für dein heutiges Briefing.",
  "aipa.card_open_tasks": "Offene Aufgaben",
  "aipa.card_needs_attention": "Braucht Aufmerksamkeit",
  "aipa.card_to_approve": "Zur Freigabe",
  "aipa.card_setup_step": "Nur noch ein Schritt: Richte deinen Assistenten ein, damit er morgens für dich vorbereitet.",
  "aipa.card_pitch": "Dein proaktiver Assistent: Tages-Briefing, Aufgaben, automatische Nachbereitung & Nudges — du behältst die Kontrolle.",
  "aipa.card_try_free": "7 Tage gratis testen",
  "notif.seo": "Benachrichtigungen",
  "ads.seo": "Coach · Werbung",
  "an.seo": "Coach · Analytics",
  "bk.seo": "Coach · Buchungen",
  "cd.seo": "Coach · Klient:in",
  "win.seo": "Coach · Klient:innen-Erfolge",
  "cc.seo": "Coach · Kreise",
  "cs.seo": "Coach · Einrichtung",
  "col2.seo": "Coach · Kollektive",
  "cf.seo": "Coach · Einwilligungen",
  "soc.seo": "Coach · Social",
  "help.seo": "Coach · Hilfe",
  "ici.seo": "Coach · Inner-Circle-Einladungen",
  "cm.seo": "Coach · Methoden",
  "off.seo": "Coach · Angebote",
  "pl.seo": "Coach · Pläne",
  "pon.seo": "Coach · Fachprofil",
  "prof.seo": "Coach · Profil",
  "recs.seo": "Coach · Empfehlungen",
  "ref.seo": "Coach · Empfehlen",
  "cset.seo": "Coach · Einstellungen",
  "sup.seo": "Coach · Support",
  "tour.seo": "Coach · Rundgang",
  "upg.seo": "Coach · Upgrade",
  "verify.seo": "Coach · Verifizierung",
  "aipa.seo": "Coach · AI Praxis Assistent",
  "cbr.seo": "Coach · Branding",
  "chk.seo": "Coach · Check-in-Vorlage",
  "cred.seo": "Coach · Guthaben",
  "refpol.seo": "Coach · Stornierung & Rückerstattung",
  "resch.seo": "Coach · Umbuchungen",
  "wdig.seo": "Coach · Weekly Digest",
  "common.copied": "Kopiert",
  "open": "Öffnen",
  "ads.topup_custom_ph": "z. B. 75",
  "ads.ph_themes": "Breathwork, Grenzen…",
  "ads.ph_regions": "EU, DE-Berlin…",
  "ads.ph_education_backgrounds": "Coach-Ausbildung…",
  "ads.ph_life_situations": "Selbständig, junge Eltern…",
  "ads.ph_other_traits": "Frühaufsteher, ADHS…",
  "aipa.renews_on": "Verlängert sich am {date}",
  "aipa.trial_until": "Testphase bis {date}",
  "aipa.canceled_until": "Aktiv bis {date}",
  "aipa.wizard_title": "Assistent einrichten",
  "aipa.wizard_intro": "In wenigen Schritten ist dein Assistent startklar.",
  "aipa.step_label": "Schritt {n} von {total}",
  "aipa.step_language": "Sprache",
  "aipa.step_language_desc": "In welcher Sprache soll der Assistent schreiben?",
  "aipa.lang_label": "Sprache des Assistenten",
  "aipa.step_briefing": "Tägliches Briefing",
  "aipa.step_briefing_desc": "Wann soll dein Briefing bereitstehen?",
  "aipa.briefing_time": "Briefing-Zeit",
  "aipa.show_on_login": "Briefing beim Login anzeigen",
  "aipa.step_autonomy": "Autonomie",
  "aipa.step_autonomy_desc": "Lege fest, was der Assistent selbst darf und was du bestätigst.",
  "aipa.step_workflows": "Workflows",
  "aipa.step_workflows_desc": "Aktiviere die Abläufe, die dich unterstützen sollen.",
  "aipa.step_outlook": "Outlook",
  "aipa.step_outlook_desc": "Kalender und Mails verbinden (optional).",
  "aipa.outlook_calendar": "Outlook-Kalender",
  "aipa.outlook_mail": "Outlook-Mails",
  "aipa.outlook_not_connected": "Noch nicht verbunden — der Assistent nutzt solange deine App-Daten.",
  "aipa.step_groups": "Gruppen-Filter",
  "aipa.step_groups_desc": "Auf welche Kreise soll sich der Assistent konzentrieren? Leer = alle.",
  "aipa.groups_all": "Alle Kreise",
  "aipa.groups_empty": "Noch keine Kreise vorhanden.",
  "aipa.back": "Zurück",
  "aipa.next": "Weiter",
  "aipa.finish_setup": "Einrichtung abschließen",
  "aipa.saving": "Speichern…",
  "aipa.setup_done_toast": "Assistent ist startklar!",
  "aipa.lvl_confirm": "Bestätigen",
  "aipa.lvl_auto": "Automatisch",
  "aipa.lvl_never": "Nie",
  "aipa.auto.message_clients": "Klient:innen anschreiben",
  "aipa.auto.appointment_reminders": "Terminerinnerungen",
  "aipa.auto.outlook_events": "Outlook-Termine anlegen",
  "aipa.auto.weekly_plan_reminders": "Wochenplan-Erinnerungen",
  "aipa.auto.post_drafts": "Beitrags-Entwürfe",
  "aipa.auto.mail_replies": "Mail-Antworten",
  "aipa.auto.auto_tasks": "Aufgaben automatisch anlegen",
  "aipa.wf.daily_briefing": "Tägliches Briefing",
  "aipa.wf.weekly_summary": "Wochenzusammenfassung",
  "aipa.wf.weekly_plan_reminder": "Wochenplan-Erinnerung",
  "aipa.wf.birthday_greetings": "Geburtstagsgrüße",
  "aipa.wf.session_followup": "Session-Nachbereitung",
  "aipa.wf.inactive_clients": "Inaktive Klient:innen",
  "aipa.wf.post_draft_on_theme": "Beitrags-Entwurf zu Themen",
  "aipa.wf.appointment_confirmations": "Terminbestätigungen",
  "aipa.wf.mail_reply_drafts": "Mail-Antwort-Entwürfe",
  "aipa.tab_briefing": "Briefing",
  "aipa.tab_tasks": "Aufgaben",
  "aipa.tab_agenda": "Agenda",
  "aipa.tab_chat": "Chat",
  "aipa.tab_settings": "Einstellungen",
  "aipa.briefing_title": "Dein Tages-Briefing",
  "aipa.briefing_generate": "Briefing erstellen",
  "aipa.briefing_generating": "Erstelle Briefing…",
  "aipa.briefing_regenerate": "Neu erstellen",
  "aipa.briefing_empty": "Noch kein Briefing für heute. Erstelle jetzt dein erstes.",
  "aipa.briefing_clients": "Klient:innen",
  "aipa.briefing_attention": "Braucht Aufmerksamkeit",
  "aipa.briefing_calendar": "Kalender",
  "aipa.briefing_tasks": "Aufgaben",
  "aipa.briefing_comm": "Kommunikations-Vorschläge",
  "aipa.briefing_posts": "Beitrags-Ideen",
  "aipa.briefing_add_task": "Als Aufgabe",
  "aipa.copy": "Kopieren",
  "aipa.copied": "Kopiert",
  "aipa.generated_at": "Erstellt {date}",
  "aipa.tasks_title": "Aufgaben",
  "aipa.tasks_empty": "Keine offenen Aufgaben. Gut gemacht!",
  "aipa.task_title_ph": "Neue Aufgabe…",
  "aipa.task_desc_ph": "Beschreibung (optional)",
  "aipa.task_priority": "Priorität",
  "aipa.task_add": "Hinzufügen",
  "aipa.task_adding": "Füge hinzu…",
  "aipa.prio.urgent": "Dringend",
  "aipa.prio.important": "Wichtig",
  "aipa.prio.normal": "Normal",
  "aipa.prio.later": "Später",
  "aipa.task_done": "Erledigt",
  "aipa.task_delegate": "An KI delegieren",
  "aipa.task_delegating": "Delegiere…",
  "aipa.task_delete": "Löschen",
  "aipa.task_ai_result": "KI-Ergebnis",
  "aipa.task_history": "Verlauf anzeigen",
  "aipa.task_history_hide": "Verlauf verbergen",
  "aipa.task_export": "CSV-Export",
  "aipa.agenda_title": "Agenda heute",
  "aipa.agenda_events": "Termine",
  "aipa.agenda_no_events": "Keine Termine heute.",
  "aipa.agenda_recurring": "Wiederkehrend",
  "aipa.agenda_recurring_empty": "Noch keine wiederkehrenden Einträge.",
  "aipa.agenda_outlook_on": "Outlook verbunden",
  "aipa.agenda_outlook_off": "Outlook nicht verbunden",
  "aipa.recurring_add": "Eintrag hinzufügen",
  "aipa.recurring_title_ph": "Titel (z. B. Team-Call)",
  "aipa.recurring_time": "Uhrzeit",
  "aipa.recurring_save": "Speichern",
  "aipa.wd.0": "Mo",
  "aipa.wd.1": "Di",
  "aipa.wd.2": "Mi",
  "aipa.wd.3": "Do",
  "aipa.wd.4": "Fr",
  "aipa.wd.5": "Sa",
  "aipa.wd.6": "So",
  "aipa.chat_title": "Assistenten-Chat",
  "aipa.chat_ph": "Frag deinen Assistenten…",
  "aipa.chat_send": "Senden",
  "aipa.chat_empty": "Stelle eine Frage zu deiner Praxis.",
  "aipa.chat_clear": "Verlauf löschen",
  "aipa.chat_thinking": "Denkt nach…",
  "aipa.settings_title": "Einstellungen",
  "aipa.settings_saved": "Einstellungen gespeichert.",
  "aipa.save": "Speichern",
  "aipa.cancel_package": "Paket kündigen",
  "aipa.cancel_confirm": "Paket wirklich kündigen? Du behältst Zugriff bis zum Periodenende.",
  "aipa.canceling": "Kündige…",
  "aipa.cancel_done": "Paket gekündigt.",
  "aipa.tab_automation": "Automatik",
  "aipa.automation_title": "Autonome Workflows",
  "aipa.automation_desc": "Der Assistent führt deine aktivierten Abläufe aus. Aktionen auf „Automatisch“ laufen ohne Rückfrage, „Bestätigen“ landet als Aufgabe zur Freigabe.",
  "aipa.run_now": "Jetzt ausführen",
  "aipa.running": "Führe aus…",
  "aipa.run_done": "{auto} automatisch · {pending} zur Freigabe",
  "aipa.activity_title": "Letzte Aktivität",
  "aipa.activity_empty": "Noch keine Aktivität. Aktiviere Workflows in den Einstellungen und starte sie hier.",
  "aipa.mode_auto": "Automatisch",
  "aipa.mode_pending": "Zur Freigabe",
  "guide.ui.step": "Schritt {x} von {y}",
  "guide.ui.next": "Weiter",
  "guide.ui.done": "Fertig",
  "guide.ui.later": "Später",
  "guide.ui.not_now": "Nicht jetzt",
  "guide.ui.close": "Schließen",
  "guide.bar.title": "Dein Start als Coach",
  "guide.bar.subtitle": "In ein paar warmen Schritten ist alles startklar.",
  "guide.bar.progress": "{done} von {total} erledigt",
  "guide.bar.hide": "Für jetzt ausblenden",
  "guide.bar.reopen": "Einrichtungs-Guide",
  "guide.status.done": "Erledigt",
  "guide.status.skipped": "Übersprungen",
  "guide.status.open": "Offen",
  "guide.complete.title": "Alles eingerichtet – wunderbar!",
  "guide.complete.body": "Du hast deinen Start-Pfad abgeschlossen. Dein Raum ist bereit, Menschen auf ihrem Weg zu begleiten. Schön, dass du da bist.",
  "guide.complete.cta": "Los geht's",
  "guide.theme.profile.label": "Profil",
  "guide.theme.offering.label": "Angebot",
  "guide.theme.circle.label": "Kreis",
  "guide.theme.availability.label": "Verfügbarkeit",
  "guide.theme.payments.label": "Zahlungen",
  "guide.theme.post.label": "Beitrag",
  "guide.theme.method.label": "Methode",
  "guide.theme.weekly_plan.label": "Wochenplan",
  "guide.theme.calendar.label": "Kalender",
  "guide.theme.discover.label": "Entdecken",
  "guide.theme.profile.title": "Zeig dich – dein Profil",
  "guide.theme.profile.cta": "Zum Profil",
  "guide.theme.profile.step1": "Lass uns bei dir beginnen. Hier entsteht dein persönliches Profil – der erste Eindruck für Menschen, die zu dir finden.",
  "guide.theme.profile.step2": "Lade ein warmes Foto von dir hoch. Ein echtes Gesicht schafft sofort Vertrauen.",
  "guide.theme.profile.step3": "Trag deinen Namen ein – so, wie du genannt werden möchtest.",
  "guide.theme.profile.step4": "Erzähl in ein paar Sätzen, wer du bist und wofür dein Herz schlägt. Ganz ohne Fachsprache.",
  "guide.theme.profile.step5": "Speichere dein Profil – fertig! Du kannst es jederzeit wieder anpassen.",
  "guide.theme.offering.title": "Dein erstes Angebot",
  "guide.theme.offering.cta": "Zu den Angeboten",
  "guide.theme.offering.step1": "Hier legst du fest, womit du Menschen begleitest – zum Beispiel eine Einzelsitzung oder ein kleines Paket.",
  "guide.theme.offering.step2": "Leg ein Angebot an, das zu dir passt. Sobald es gespeichert ist, haken wir diesen Schritt für dich ab.",
  "guide.theme.circle.title": "Dein eigener Kreis",
  "guide.theme.circle.cta": "Zu den Kreisen",
  "guide.theme.circle.step1": "Ein Kreis ist dein Raum für Gemeinschaft – hier kommen die Menschen zusammen, die du begleitest.",
  "guide.theme.circle.step2": "Erstell deinen ersten Kreis. Du entscheidest, wie offen oder geschützt er sein soll.",
  "guide.theme.availability.title": "Deine Zeiten",
  "guide.theme.availability.cta": "Zur Verfügbarkeit",
  "guide.theme.availability.step1": "Damit Menschen bei dir buchen können, hinterlegst du hier deine Zeiten.",
  "guide.theme.availability.step2": "Trag ein, wann du für Sitzungen da bist. Sobald du gespeichert hast, ist dieser Schritt erledigt.",
  "guide.theme.payments.title": "Bezahlung einrichten",
  "guide.theme.payments.cta": "Stripe verbinden",
  "guide.theme.payments.step1": "Damit dein Honorar sicher bei dir ankommt, verbinden wir dein Konto mit unserem Zahlungspartner.",
  "guide.theme.payments.step2": "Verbinde dich sicher mit Stripe. Das dauert nur wenige Minuten – wir führen dich Schritt für Schritt.",
  "guide.theme.post.title": "Dein erster Beitrag",
  "guide.theme.post.cta": "Zum Feed",
  "guide.theme.post.step1": "Mit einem Beitrag zeigst du, was dich bewegt – ein Gedanke, eine Einladung, ein Impuls.",
  "guide.theme.post.step2": "Teile deinen ersten Beitrag. Sobald er veröffentlicht ist, haken wir diesen Schritt ab.",
  "guide.theme.method.title": "Deine Methode",
  "guide.theme.method.cta": "Zu den Methoden",
  "guide.theme.method.step1": "Eine Methode ist eine kleine Übung oder Anleitung, die du mit Menschen teilst.",
  "guide.theme.method.step2": "Leg deine erste Methode an. Sie wird automatisch abgehakt, sobald sie gespeichert ist.",
  "guide.theme.weekly_plan.title": "Ein Wochenplan",
  "guide.theme.weekly_plan.cta": "Zu den Wochenplänen",
  "guide.theme.weekly_plan.step1": "Mit einem Wochenplan begleitest du Menschen Tag für Tag – sanft und mit Struktur.",
  "guide.theme.weekly_plan.step2": "Erstell einen Plan und weise ihn jemandem zu. Dann ist dieser Schritt erledigt.",
  "guide.theme.calendar.title": "Dein Kalender",
  "guide.theme.calendar.cta": "Kalender verbinden",
  "guide.theme.calendar.step1": "Verbinde deinen Outlook-Kalender, damit Termine automatisch zusammenpassen. Kein Muss – du kannst das auch später machen.",
  "guide.theme.discover.title": "Entdecke deinen Raum",
  "guide.theme.discover.cta": "Zum Dashboard",
  "guide.theme.discover.step1": "Zum Schluss ein kleiner Rundgang. Das hier ist dein Dashboard – dein Zuhause in der App.",
  "guide.theme.discover.step2": "Hier siehst du den Puls deiner Menschen – wie es ihnen gerade geht.",
  "guide.theme.discover.step3": "In den Nachrichten bleibst du persönlich in Kontakt.",
  "guide.theme.discover.step4": "In deinen Kreisen entsteht Gemeinschaft und Austausch.",
  "guide.theme.discover.step5": "Und hier findest du dein Konto und alle Einstellungen. Das war's – viel Freude!",
  // === iter273 i18n · wave 1 (CoachHome, CoachCircles) ===
  "ch.welcome": "Willkommen zurück",
  "ch.default_name": "Coach",
  "ch.setup_title": "Coach-Einrichtung · {done}/{total} erledigt",
  "ch.setup_sub": "Schließe die 4 Schritte ab und sichere dir das Founding-Coach-Badge.",
  "ch.stat_circles": "Kreise",
  "ch.stat_upcoming": "Kommende Buchungen",
  "ch.wq_upcoming": "Anstehende Sessions",
  "ch.wq_unread": "Ungelesene Nachrichten",
  "ch.wq_pending": "Zu erledigen",
  "ch.wq_next_sessions": "Deine nächsten Sessions",
  "ch.wq_no_sessions": "Keine anstehenden Sessions.",
  "ch.wq_view_all": "Alle ansehen",
  "ch.wq_session": "Session",
  "ch.stat_credits": "Guthaben",
  "ch.aff_title": "Dein Affiliate-Link",
  "ch.aff_hint": "Teile ihn — du verdienst an jeder Empfehlung mit.",
  "ch.aff_copied": "Affiliate-Link kopiert",
  "ch.area_title": "Dein Coach-Bereich",
  "ch.areas_count": "{n} Bereiche",
  "ch.gross_title": "Gesamtumsatz (alle Buchungen)",
  "ch.g_start": "Start",
  "ch.g_circles": "Kreise",
  "ch.g_sell": "Verkaufen",
  "ch.g_grow": "Wachstum",
  "ch.g_account": "Konto",
  "ch.g_affiliate": "Affiliate",
  "ch.i_feed": "Feed",
  "ch.i_messages": "Nachrichten",
  "ch.i_notifications": "Benachrichtigungen",
  "ch.i_circles": "Kreise",
  "ch.i_inner": "Inner Circle",
  "ch.i_mein": "Mein Kreis",
  "ch.i_pulse": "Klient:innen-Puls",
  "ch.i_assistant": "AI-Praxis-Assistent",
  "ch.i_ads": "Werbung",
  "ch.i_recommendations": "Empfehlungen",
  "ch.i_content": "Social & Inhalte",
  "ch.i_consent": "Einwilligungen",
  "ch.i_client_wins": "Klient:innen-Erfolge",
  "ch.i_collectives": "Kollektive",
  "ch.i_settings": "Einstellungen",
  "ch.i_billing": "Abrechnung & Abos",
  "ch.i_upgrade": "Coach Pro",
  "ch.i_support": "Support & Hilfe",
  "ch.i_aff_link": "Empfehlen & Affiliate-Link",
  "ch.i_aff_offerings": "Affiliate-Angebote",
  "ch.i_aff_payouts": "Auszahlungen",
  "ch.s_feed": "Globaler & regionaler Feed.",
  "ch.s_messages": "Direktnachrichten & Kreis-Chats.",
  "ch.s_notifications": "Alle Hinweise auf einen Blick.",
  "ch.s_circles": "Inner & Local Circle Übersicht.",
  "ch.s_inner": "Abo-Plan, Perks & Preise setzen.",
  "ch.s_mein": "Zusatz-Abos detailliert konfigurieren.",
  "ch.s_pulse": "Stille Klient:innen & Warnzeichen.",
  "ch.s_offerings": "Sessions, Pakete, Affiliate & Preise.",
  "ch.s_bookings": "Sitzungen, Stornos & Rückerstattungen.",
  "ch.s_earnings": "Umsatz, Auszahlungen & Steuern.",
  "ch.s_availability": "Wöchentliche Slots öffnen & schließen.",
  "ch.s_assistant": "Dein autonomer Coaching-Assistent.",
  "ch.s_analytics": "12-Kachel-Deepdive: Wachstum & Reports.",
  "ch.s_ads": "Kampagnen, Zielgruppen-KI & Guthaben.",
  "ch.s_recommendations": "Beitrags-Wirkung & warme Empfehlungen.",
  "ch.s_collab": "Netzwerk, Projekte & gemeinsame Angebote.",
  "ch.s_content": "Beiträge, Planer, Stories & WEVA.",
  "ch.s_methods": "Übungen bauen: Audio, Video, Combo.",
  "ch.s_plans": "Tagespläne & Wochen-Breathwork teilen.",
  "ch.s_profile": "Öffentliches Profil, Bio & Branding.",
  "ch.s_verify": "Qualifikation hochladen & Status.",
  "ch.s_consent": "Einverständniserklärungen & Unterschriften.",
  "ch.s_client_wins": "KI-Vorschläge für Erfolgsgeschichten.",
  "ch.s_collectives": "Coach-Allianzen mit geteilten Umsätzen.",
  "ch.s_settings": "Storno-Policy, Umbuchungen, Branding.",
  "ch.s_billing": "Guthaben, Plattform-Abo & AI-Assistent.",
  "ch.s_upgrade": "Upgrade: 10% Provision, Branding & mehr.",
  "ch.s_support": "Tickets ans Team, FAQ & Rundgang.",
  "ch.s_aff_link": "Teile deinen Link & verdiene mit.",
  "ch.s_aff_offerings": "Externe Produkte bewerben.",
  "ch.s_aff_payouts": "Provisionen & Auszahlungen.",
  "cc.title": "Kreise",
  "cc.subtitle": "Deine Begleitungsräume an einem Ort — Inner Circle, Mein Kreis, Local und der Klient:innen-Puls.",
  "cc.card_inner_sub": "Deine exklusive Begleitung",
  "cc.card_mein_sub": "Individuelle, begleitete Kreise",
  "cc.card_local_sub": "Deine kostenlose Community",
  "cc.card_pulse_sub": "Engagement im Blick behalten",
  "cc.your_circles": "Deine Kreise",
  "cc.new_circle": "Neuer Kreis",
  "cc.empty": "Noch keine Kreise. Erstelle deinen ersten Kreis.",
  "cc.archived": "Archiviert",
  "cc.actions": "Kreis-Aktionen",
  "cc.rename": "Umbenennen",
  "cc.archive": "Archivieren",
  "cc.restore": "Wiederherstellen",
  "cc.delete": "Löschen",
  "cc.health_line": "{total} Mitglieder · {msgs} Nachr./7T · {active} aktiv",
  "cc.health_active": "Aktiv",
  "cc.health_quiet": "Ruhig",
  "cc.health_silent": "Still",
  "cc.copy_code": "Einladungscode kopieren",
  "cc.code_copied": "Code kopiert",
  "cc.my_clients": "Meine Klient:innen",
  "cc.no_clients": "Aktuell keine Klient:innen ohne Kreis.",
  "cc.client": "Klient:in",
  "cc.rename_title": "Kreis umbenennen",
  "cc.rename_desc": "Gib dem Kreis einen neuen Namen. Alle Mitglieder sehen den geänderten Namen.",
  "cc.rename_ph": "Name des Kreises",
  "cc.cancel": "Abbrechen",
  "cc.save": "Speichern",
  "cc.renamed": "Kreis umbenannt",
  "cc.name_short": "Name ist zu kurz (min. 2 Zeichen)",
  "cc.archived_toast": "Kreis archiviert",
  "cc.restored_toast": "Kreis wiederhergestellt",
  "cc.delete_title": "Kreis „{name}“ löschen?",
  "cc.delete_desc": "Diese Aktion kann nicht rückgängig gemacht werden. Der Kreis und alle Nachrichten, Ankündigungen und Aktivitäten darin werden dauerhaft gelöscht.",
  "cc.delete_confirm": "Endgültig löschen",
  "cc.deleted": "Kreis gelöscht",
  "cc.kind_local": "LOCAL",
  "cc.kind_individual": "Mein Kreis",
  "cc.kind_inner": "Inner Circle",
  // === iter273 i18n · wave 2 (Billing, Membership) ===
  "tier.plus_blurb": "Für den sanften Einstieg in KI-Reflexion.",
  "tier.pro_blurb": "Mehr Reports und Starter-Pläne.",
  "tier.unlimited_blurb": "Unbegrenzte Reflexion, priorisiert.",
  "tier.coach_pro_blurb": "Alles aus Unlimited + Coaching-Tools.",
  "feat.reports_unlimited": "Unbegrenzte WEVA-Reports (Fair-Use)",
  "feat.reports_count": "{n} WEVA-Reports / Monat",
  "feat.ad_free": "Werbefrei",
  "feat.voice_journal": "Sprach-Journal",
  "feat.starter_plans": "Starter-Pläne",
  "feat.priority": "Priorisierte Verarbeitung",
  "feat.commission": "Nur {pct}% Plattform-Kommission",
  "feat.advanced_analytics": "Erweiterte Coach-Analytics",
  "bill.title": "Abrechnung & Abos",
  "bill.sub_coach": "Guthaben, Plattform-Mitgliedschaft und AI-Praxis-Assistent — alles an einem Ort. Zahlung sicher über Stripe.",
  "bill.sub_client": "Guthaben und Plattform-Mitgliedschaft — alles an einem Ort. Zahlung sicher über Stripe.",
  "bill.credits": "Guthaben",
  "bill.credit_rate": "1 Credit = €0,10 · inkl. MwSt.",
  "bill.n_credits": "{n} Credits",
  "bill.popular": "Beliebt",
  "bill.credits_word": "Credits",
  "bill.incl_vat_per": "inkl. MwSt. · {per}/Credit",
  "bill.buy": "Kaufen",
  "bill.credits_added": "Guthaben gutgeschrieben!",
  "bill.purchase_failed": "Kauf fehlgeschlagen.",
  "bill.payment_received": "Zahlung erhalten — danke!",
  "bill.cancelled": "Vorgang abgebrochen.",
  "bill.sub_activated": "Mitgliedschaft aktiviert — danke!",
  "bill.membership": "Plattform-Mitgliedschaft",
  "bill.membership_sub": "Wähle den Plan, der zu deiner inneren Arbeit passt. Jederzeit kündbar.",
  "bill.current_plan": "Aktueller Plan: {name}",
  "bill.manage_hint": "Abo verwalten, Zahlungsmittel ändern oder kündigen — sicher über das Stripe-Portal. Dein Zugang bleibt bis zum Periodenende.",
  "bill.manage": "Abo verwalten",
  "bill.monthly": "Monatlich",
  "bill.yearly": "Jährlich · spare mehr",
  "bill.recommended": "Empfohlen",
  "bill.per_year": "Jahr",
  "bill.per_month": "Monat",
  "bill.current": "Aktueller Plan",
  "bill.choose": "Wählen",
  "bill.activated": "Mitgliedschaft aktiviert!",
  "bill.finish_failed": "Konnte nicht abschließen.",
  "bill.stripe_note": "Zahlung sicher über Stripe · inkl. österreichischer USt.",
  "bill.stripe_note_vat": "Zahlung sicher über Stripe · inkl. österreichischer USt. · Preise enthalten MwSt.",
  "bill.manage_demo": "Abo-Verwaltung ist im Demo-Modus nicht verfügbar.",
  "bill.no_active_sub": "Kein aktives Abo.",
  "bill.manage_failed": "Konnte Abo-Verwaltung nicht öffnen.",
  "bill.ai_title": "AI-Praxis-Assistent",
  "bill.ai_sub": "Dein autonomer Coaching-Assistent — Tages-Briefing, Aufgaben, Chat & Workflows.",
  "bill.ai_active": "Aktiv",
  "bill.ai_runs_until": "Läuft bis {date}",
  "bill.ai_is_active": "Dein Assistent ist aktiv.",
  "bill.ai_open": "Assistent öffnen",
  "bill.ai_upsell": "Automatisiere Routineaufgaben und erhalte jeden Morgen ein klares Tages-Briefing.",
  "bill.ai_f_briefing": "Tages-Briefing",
  "bill.ai_f_tasks": "Aufgaben-Delegation",
  "bill.ai_f_chat": "KI-Chat",
  "bill.ai_f_workflows": "Autonome Workflows",
  "bill.ai_starting": "Wird gestartet…",
  "bill.ai_start_sub": "Abo starten",
  "bill.ai_trial": "7 Tage gratis testen",
  "bill.ai_price": "{price}€ / Monat",
  "bill.ai_checkout_failed": "Checkout fehlgeschlagen.",
  "mem.title": "Mitgliedschaft",
  // === iter273 i18n · wave 3 (auth + public pages) ===
  "fp.meta": "Passwort zurücksetzen",
  "fp.title": "Passwort vergessen?",
  "fp.subtitle": "Wir senden dir einen Link zum Zurücksetzen.",
  "fp.back": "Zurück zur Anmeldung",
  "fp.sent": "Falls diese E-Mail registriert ist, erhältst du gleich einen Link zum Zurücksetzen.",
  "fp.email": "E-Mail",
  "fp.email_ph": "du@beispiel.com",
  "fp.submit": "Link senden",
  "rp.meta": "Neues Passwort",
  "rp.title": "Neues Passwort",
  "rp.subtitle": "Wähle ein sicheres Passwort für dein Konto.",
  "rp.back": "Zur Anmeldung",
  "rp.no_token": "Dieser Link ist ungültig. Bitte fordere einen neuen Reset-Link an.",
  "rp.new_pw": "Neues Passwort",
  "rp.pw_ph": "Mindestens 8 Zeichen",
  "rp.submit": "Passwort speichern",
  "rp.updated": "Passwort aktualisiert.",
  "rp.failed": "Zurücksetzen fehlgeschlagen.",
  "cpg.meta": "Coaches",
  "cpg.meta_desc": "Entdecke verifizierte Coaches auf My Within — nach Thema, Expertise und Region.",
  "cpg.title": "Unsere Coaches",
  "cpg.subtitle": "Verifizierte Begleiter:innen für deine innere Arbeit — finde die Person, die zu dir passt.",
  "cpg.search_ph": "Suche nach Name, Expertise oder Beruf …",
  "cpg.empty_title": "Keine Coaches gefunden",
  "cpg.empty_desc": "Versuche einen anderen Suchbegriff.",
  "cpg.reset_search": "Suche zurücksetzen",
  "od.fallback_title": "Angebot",
  "od.notfound_title": "Angebot nicht gefunden",
  "od.notfound_desc": "Dieses Angebot ist nicht mehr verfügbar.",
  "od.to_marketplace": "Zum Marktplatz",
  "od.marketplace": "Marktplatz",
  "od.recommended": "Empfohlen",
  "od.minutes": "{n} Minuten",
  "od.included": "Das ist enthalten",
  "od.savings": "Du sparst {amount} im Bundle.",
  "od.price": "Preis",
  "od.cta": "Coach & Verfügbarkeit ansehen",
  "od.create_account": "Erstelle ein Konto",
  "od.signup_rest": ", um zu buchen und zu chatten.",
  "od.more_from": "Weitere Angebote von {name}",
  "mkt.meta": "Marktplatz",
  "mkt.meta_desc": "Entdecke Coaching-Angebote, Kurse und Pakete verifizierter Coaches auf My Within.",
  "mkt.title": "Marktplatz",
  "mkt.subtitle": "Angebote, Kurse und Pakete verifizierter Coaches — finde, was zu deinem Weg passt.",
  "mkt.search_ph": "Suche nach Thema, Titel oder Coach …",
  "mkt.art": "Art",
  "mkt.all_types": "Alle Arten",
  "mkt.region": "Region",
  "mkt.all_regions": "Alle Regionen",
  "mkt.theme": "Thema",
  "mkt.all_themes": "Alle Themen",
  "mkt.filters_active": "{n} Filter aktiv",
  "mkt.reset": "Zurücksetzen",
  "mkt.count_one": "{n} Angebot gefunden",
  "mkt.count_other": "{n} Angebote gefunden",
  "mkt.empty_title": "Keine Angebote gefunden",
  "mkt.empty_desc": "Passe deine Suche oder Filter an, um mehr Angebote zu sehen.",
  "mkt.reset_filters": "Filter zurücksetzen",
  "mkt.loading": "Lädt …",
  "mkt.load_more": "Mehr anzeigen",
  "cp.meta_fallback": "Coach",
  "cp.notfound_title": "Coach nicht gefunden",
  "cp.notfound_desc": "Dieses Profil ist nicht verfügbar.",
  "cp.all_coaches": "Alle Coaches",
  "cp.since_year": "Seit {year} im Beruf",
  "cp.about": "Über {name}",
  "cp.posts": "Beiträge",
  "cp.more_exclusive": "{n} weitere exklusive Beiträge — als Mitglied freischaltbar.",
  "cp.no_posts": "Noch keine öffentlichen Beiträge.",
  "cp.focus": "Schwerpunkte",
  "cp.topics": "Themen",
  "cp.qualifications": "Qualifikationen",
  "cp.visit_website": "Website besuchen",
  "cir.health_active": "Aktiv",
  "cir.health_quiet": "Ruhig",
  "cir.health_still": "Still",
  "cir.kind_individual": "Mein Kreis",
  "cir.load_error": "Kreise konnten nicht geladen werden.",
  "cir.created": "Kreis erstellt",
  "cir.joined": "Kreis beigetreten",
  "cir.join_failed": "Beitritt fehlgeschlagen",
  "cir.invite_sent": "Einladung gesendet",
  "cir.member_removed": "Mitglied entfernt",
  "cir.remove_failed": "Entfernen fehlgeschlagen",
  "cir.code_copied": "Code kopiert",
  "cir.link_copied": "Link kopiert",
  "cir.pin_updated": "Pin aktualisiert",
  "cir.eyebrow": "Gemeinschaft",
  "cir.title": "Kreise",
  "cir.subtitle": "Begleite deine Gruppen und bleibe mit deinen Klient:innen in Verbindung.",
  "cir.new_circle": "Neuer Kreis",
  "cir.new_circle_desc": "Wähle den Typ und gib deinem Kreis einen Namen.",
  "cir.local_circle": "Local Circle",
  "cir.local_circle_desc": "Kostenlose Gruppe für deine Community.",
  "cir.mein_kreis": "Mein Kreis",
  "cir.mein_kreis_desc": "Individueller, begleiteter Kreis.",
  "cir.name_ph": "Name des Kreises",
  "cir.desc_ph": "Beschreibung (optional)",
  "cir.cancel": "Abbrechen",
  "cir.create": "Erstellen",
  "cir.invite_code_ph": "Einladungscode",
  "cir.join": "Beitreten",
  "cir.empty": "Noch keine Kreise. Erstelle einen oder tritt mit einem Code bei.",
  "cir.health_stat": "· {total} Mitglieder · {msgs} Nachr./7T · {active} aktiv",
  "cir.copy_invite_code": "Einladungscode kopieren",
  "cir.select_circle": "Wähle links einen Kreis aus.",
  "cir.invite_code_prefix": "Einladungscode:",
  "cir.copy_code": "Code kopieren",
  "cir.members_count": "{n} Mitglieder",
  "cir.share_link": "Einladungslink teilen",
  "cir.member_health": "Mitglieder-Health",
  "cir.start_convo": "Starte das Gespräch",
  "cir.start_convo_desc": "Schreibe die erste Nachricht an deinen Kreis.",
  "cir.pin": "Anpinnen",
  "cir.msg_ph": "Nachricht schreiben …",
  "cir.invite_email_ph": "E-Mail einladen",
  "cir.invite": "Einladen",
  "cir.manage_members": "Mitglieder verwalten",
  "cir.manage_members_desc": "Mitglieder deines Kreises ansehen, einladen und entfernen.",
  "cir.no_members": "Noch keine Mitglieder.",
  "cir.member_fallback": "Mitglied",
  "cir.coach": "Coach",
  "cir.remove": "Entfernen",
  "cir.remove_member_q": "Mitglied entfernen?",
  "cir.remove_member_desc": "{who} wird aus dem Kreis entfernt. Das kann nicht rückgängig gemacht werden.",
  "cir.this_member": "Dieses Mitglied",
  "mk.seo": "Coach · Mein Kreis",
  "mk.eyebrow": "Mein Kreis",
  "mk.title": "Mein Kreis",
  "mk.subtitle": "Individuelle, begleitete Kreise mit eigenem Preis, Plätzen und Willkommensgruß.",
  "mk.new": "Neu",
  "mk.empty_title": "Noch kein eigener Kreis",
  "mk.empty_desc": "Erstelle deinen ersten individuellen Kreis mit Preis und Plätzen.",
  "mk.create_circle": "Kreis erstellen",
  "mk.bl_one_time": "einmalig",
  "mk.bl_monthly": "mtl.",
  "mk.bl_yearly": "jährl.",
  "mk.free": "kostenlos",
  "mk.seats": "{n} Plätze",
  "mk.unlimited_seats": "Unbegrenzte Plätze",
  "mk.edit": "Bearbeiten",
  "mke.seo_edit": "Coach · Kreis bearbeiten",
  "mke.seo_create": "Coach · Kreis erstellen",
  "mke.title_edit": "Kreis bearbeiten",
  "mke.title_create": "Kreis erstellen",
  "mke.subtitle": "Zusatz-Abo — genauso detailliert wie der Inner Circle, mit/ohne Zeit- und Teilnehmerlimit.",
  "mke.b_one_time": "Einmalig",
  "mke.b_monthly": "Monatlich",
  "mke.b_yearly": "Jährlich",
  "mke.period_month": "pro Monat",
  "mke.period_week": "pro Woche",
  "mke.period_total": "gesamt",
  "mke.unit_days": "Tage",
  "mke.unit_weeks": "Wochen",
  "mke.unit_months": "Monate",
  "mke.err_name": "Bitte gib einen Namen (min. 2 Zeichen) ein.",
  "mke.saved": "Kreis gespeichert",
  "mke.basics": "Grunddaten",
  "mke.name": "Name",
  "mke.description": "Beschreibung",
  "mke.desc_ph": "Worum geht es in diesem Kreis?",
  "mke.cover": "Cover-Bild",
  "mke.cover_ph": "… oder Bild-URL einfügen",
  "mke.price_billing": "Preis & Abo",
  "mke.price_eur": "Preis (€)",
  "mke.price_credits": "Preis (Credits)",
  "mke.price_hint": "Leer lassen (€ oder Credits), damit die Plattform den fehlenden Preis automatisch ableitet. 0 = kostenlos.",
  "mke.access_section": "Teilnehmer & Zeitbeschränkung",
  "mke.limit_seats": "Teilnehmerzahl begrenzen",
  "mke.limit_seats_hint": "Aus = unbegrenzt viele Mitglieder.",
  "mke.max_seats": "Maximale Teilnehmer",
  "mke.seats_ph": "z. B. 12",
  "mke.limit_time": "Zeitlich begrenzter Zugang",
  "mke.limit_time_hint": "Aus = dauerhaftes Abo ohne Zeitbeschränkung.",
  "mke.duration": "Dauer",
  "mke.duration_ph": "z. B. 3",
  "mke.perks_title": "Enthaltene Leistungen",
  "mke.perks_hint": "Bündle Angebote aller Art — genauso detailliert wie beim Inner Circle.",
  "mke.visibility": "Sichtbarkeit",
  "mke.vis_public": "Öffentlich sichtbar",
  "mke.vis_public_hint": "Erscheint in deinem Coach-Profil.",
  "mke.vis_invite": "Nur per Einladung",
  "mke.vis_invite_hint": "Beitritt nur mit Einladungscode/-Link.",
  "mke.published": "Veröffentlicht",
  "mke.published_hint": "Aus = gespeichert, aber für Klient:innen verborgen.",
  "mke.welcome_links": "Begrüßung & Links",
  "mke.welcome": "Willkommensgruß",
  "mke.welcome_ph": "Begrüße neue Mitglieder …",
  "mke.zoom": "Zoom-Link",
  "mke.onboarding_video": "Onboarding-Video",
  "mke.video_ph": "… oder Video-URL einfügen",
  "mke.sessions": "Enthaltene Sessions",
  "mke.add": "Hinzufügen",
  "mke.no_sessions": "Noch keine Sessions hinzugefügt.",
  "mke.session_title_ph": "Titel der Session",
  "mke.save": "Speichern",
  "mke.create": "Erstellen",
  "ctl.deliverables": "Lieferungen",
  "ctl.todos": "To-dos",
  "ctl.clients": "Klient:innen",
  "ctl.chats": "Chats",
  "ctl.weva": "WEVA Gruppen-Analyse",
  "ctl.members": "Mitglieder-Health",
  "ctl.load_error": "Konnte nicht geladen werden.",
  "ctl.deliverables_saved": "Lieferungen gespeichert",
  "ctl.weva_too_few": "Zu wenig Daten für eine Gruppen-Analyse (min. 3 aktive Mitglieder).",
  "ctl.analysis_created": "Analyse erstellt",
  "ctl.analysis_pro": "Analyse nicht möglich (nur Coach Pro).",
  "ctl.seo": "Coach · {title}",
  "ctl.back": "Dashboard",
  "ctl.inner_readonly": "Inner-Circle-Lieferungen werden im Inner-Circle-Plan verwaltet (schreibgeschützt hier).",
  "ctl.no_deliverables": "Keine Lieferungen verfügbar.",
  "ctl.save": "Speichern",
  "ctl.todo_behind": "Im Rückstand",
  "ctl.todo_behind_empty": "Alles im Plan.",
  "ctl.todo_dms": "Offene DMs",
  "ctl.todo_dms_empty": "Keine offenen DMs.",
  "ctl.msg": "Nachricht",
  "ctl.todo_snapshots": "Neue Snapshots",
  "ctl.todo_snapshots_empty": "Keine neuen Snapshots.",
  "ctl.snapshot": "Snapshot",
  "ctl.no_clients": "Noch keine Klient:innen in diesem Bereich.",
  "ctl.client": "Klient:in",
  "ctl.dm_limit": "DM-Limit aktiv: {n}/Monat.",
  "ctl.no_chats": "Keine Chats.",
  "ctl.no_members": "Noch keine Mitglieder in diesem Bereich.",
  "ctl.entries_30d": "{n} Einträge (30T)",
  "ctl.last_emotion": " · zuletzt: {emotion}",
  "ctl.start_analysis": "Analyse starten",
  "ctl.privacy_min": "Für den Datenschutz werden Gruppen-Einblicke erst ab 3 aktiven Mitgliedern mit Daten angezeigt.",
  "ctl.themes": "Themen",
  "ctl.emotions": "Emotionen",
  "ctl.beliefs": "Beliefs",
  "ctl.latest_analysis": "Letzte Analyse",
  "ctl.history": "Verlauf",
  "ctl.analysis": "Analyse",
  "ctl.privacy_note": "WEVA-Einblicke sind aggregiert und anonymisiert. Einzelne Einträge werden nie im Klartext geteilt.",
  "ctl.no_data": "Keine Daten.",
  "cdb.weva": "WEVA Analyse",
  "cdb.load_error": "Übersicht konnte nicht geladen werden.",
  "cdb.seo": "Coach · {title}",
  "cdb.subtitle": "Überblick über Aktivität, Einnahmen und Lieferungen.",
  "cdb.all_circles": "Alle Kreise",
  "cdb.active_members": "Aktive Mitglieder",
  "cdb.earnings_month": "Einnahmen (Monat)",
  "cdb.snapshots_confirmed": "Bestätigte Snapshots",
  "cdb.entries_received": "Einträge erhalten",
  "cdb.bookings": "Buchungen",
  "cdb.active_offerings": "Aktive Angebote",
  "cdb.included_deliverables": "Enthaltene Lieferungen",
  "cdb.no_deliverables_defined": "Noch keine Lieferungen definiert.",
  "cdb.per_month": "{n}× / Monat",
  "cdb.earnings_this_month": "Einnahmen diesen Monat",
  "cdb.bookings_received": "Buchungen erhalten",
  "cdb.areas": "Bereiche",
  "perk.weva_snapshot_analysis": "WEVA Snapshot-Analysen",
  "perk.user_entries_analysis": "Eintrags-Analysen",
  "perk.weekly_plan": "Wochenplan vom Coach",
  "perk.dm_monthly": "Direktnachrichten pro Monat",
  "perk.paid_content": "Zugang zu allen bezahlten Inhalten",
  "perk.group_chat": "Privater Gruppenchat mit anderen Mitgliedern",
  "perk.video_call": "1:1 Videocall-Minuten pro Monat",
  "perk.belief_text_beliefs": "Glaubenssatz-Arbeit per Text · Glaubenssätze pro Monat",
  "perk.belief_text_dms": "Glaubenssatz-Arbeit per Text · DMs pro Monat",
  "perk.belief_phone": "Glaubenssatz-Arbeit per Telefon · Minuten pro Monat",
  "perk.belief_video": "Glaubenssatz-Arbeit per Videocall · Minuten pro Monat",
  "perk.emergency_support": "Emotionale Notfall-Unterstützung",
  "perk.unit_month": "/Monat",
  "perk.unit_dms_month": "DMs/Monat",
  "perk.unit_min_month": "Min./Monat",
  "perk.recommended": "· empfohlen",
  "perk.custom_hint": "Eigene Leistungen / Angebote hinzufügen (z. B. „5 Sprachnachrichten / Monat“).",
  "perk.min_short": "Min.",
  "perk.offer_name_ph": "Angebotsname",
  "perk.count_ph": "Anzahl",
  "perk.add": "Hinzufügen",
  "cext.err_title": "Titel benötigt (min. 2 Zeichen).",
  "cext.published": "Ankündigung veröffentlicht",
  "cext.pinned": "Angepinnt",
  "cext.unpin": "Lösen",
  "cext.announcements": "Ankündigungen",
  "cext.new": "Neu",
  "cext.post_title": "Ankündigung posten",
  "cext.post_desc": "Teile eine Neuigkeit mit deinem Kreis.",
  "cext.title": "Titel",
  "cext.text": "Text",
  "cext.body_ph": "Deine Nachricht …",
  "cext.require_confirm": "Lesebestätigung verlangen",
  "cext.schedule": "Planen (optional)",
  "cext.attachment": "Anhang (optional)",
  "cext.post": "Posten",
  "cext.empty": "Noch keine Ankündigungen.",
  "cext.scheduled": "geplant",
  "cext.confirmed": "Bestätigt",
  "cext.read": "Gelesen",
  "earn.p_month": "Monat",
  "earn.p_quarter": "Quartal",
  "earn.p_year": "Jahr",
  "earn.p_all": "Gesamt",
  "earn.src_inner": "Inner Circle",
  "earn.src_local": "Local Circle",
  "earn.src_sessions": "Sitzungen",
  "earn.src_affiliate": "Affiliate",
  "earn.src_paid": "Bezahlte Inhalte",
  "earn.src_other": "Sonstiges",
  "earn.paid_status": "Ausgezahlt",
  "earn.pending_status": "Ausstehend",
  "earn.failed_status": "Fehlgeschlagen",
  "earn.seo": "Coach · Einnahmen",
  "earn.back": "Coach-Dashboard",
  "earn.eyebrow": "Einnahmen",
  "earn.title": "Einnahmen & Auszahlungen",
  "earn.subtitle": "Umsatz nach Quelle, Auszahlungen und Stripe-Status.",
  "earn.stripe_err": "Stripe-Onboarding konnte nicht gestartet werden.",
  "earn.gross": "Brutto-Umsatz",
  "earn.paid_out": "Ausgezahlt",
  "earn.pending": "Ausstehend",
  "earn.next_payout": "Nächste Auszahlung",
  "earn.by_source": "Umsatz nach Quelle",
  "earn.no_revenue": "Kein Umsatz in diesem Zeitraum.",
  "earn.stripe_payouts": "Stripe-Auszahlungen",
  "earn.active": "Aktiv",
  "earn.setup_needed": "Einrichtung nötig",
  "earn.opening_stripe": "Öffne Stripe…",
  "earn.continue_onboarding": "Onboarding fortsetzen",
  "earn.connect_stripe": "Stripe verbinden",
  "earn.payouts": "Auszahlungen",
  "earn.no_payouts": "Noch keine Auszahlungen.",
  "earn.paid_on": "Ausgezahlt {date}",
  "earn.created_on": "Erstellt {date}",
  "earn.step_connect": "Stripe-Konto verbinden",
  "earn.step_identity": "Identität verifizieren",
  "earn.step_bank": "Bankkonto für Auszahlungen hinzufügen",
  "earn.step_documents": "Angeforderte Dokumente hochladen (falls nötig)",
  "cpul.seg_all": "Alle",
  "cpul.seg_rising": "Wachsend",
  "cpul.seg_stable": "Stabil",
  "cpul.seg_dropping": "Gefährdet",
  "cpul.seg_no_data": "Keine Daten",
  "cpul.load_err": "Puls konnte nicht geladen werden.",
  "cpul.seo": "Coach · Klient:innen-Puls",
  "cpul.eyebrow": "Klient:innen-Puls",
  "cpul.title": "Klient:innen-Puls",
  "cpul.subtitle": "Behalte das Engagement deiner Klient:innen im Blick.",
  "cpul.refresh": "Aktualisieren",
  "cpul.alert_one": "{n} Klient:in mit sinkendem Engagement.",
  "cpul.alert_other": "{n} Klient:innen mit sinkendem Engagement.",
  "cpul.all_good_title": "Alles im grünen Bereich",
  "cpul.all_good_desc": "Alle Klient:innen stabil oder wachsend.",
  "cpul.h7": "7T:",
  "cpul.h30": "30T:",
  "cpul.sessions": "Sessions:",
  "mh.bucket_healthy": "Aktiv",
  "mh.bucket_silent": "Still",
  "mh.bucket_inactive": "Inaktiv",
  "mh.bucket_churned": "Abgewandert",
  "mh.load_err": "Mitglieder-Health konnte nicht geladen werden.",
  "mh.nudge_sent": "Nudge gesendet",
  "mh.bulk_nudged": "{n} Mitglieder genudged",
  "mh.seo": "Coach · Mitglieder-Health",
  "mh.eyebrow": "Mitglieder",
  "mh.title": "Mitglieder-Health",
  "mh.subtitle": "Aktivität deiner Mitglieder und gezielte Nudges.",
  "mh.all_silent": "Alle Stillen ({n})",
  "mh.empty_title": "Noch keine Mitglieder",
  "mh.empty_desc": "Sobald Mitglieder beitreten, siehst du hier ihre Aktivität.",
  "mh.not_active": "Noch nicht aktiv",
  "mh.last_active": "Zuletzt aktiv vor {n} Tag(en)",
  "mh.expiring": " · Abo läuft bald aus",
  "mh.nudge": "Nudge",
  "mh.nudge_title": "{name} anstupsen",
  "mh.nudge_desc": "Eine warme Nachricht + Benachrichtigung.",
  "mh.nudge_ph": "Optionale Nachricht …",
  "mh.send": "Senden",
  "mh.bulk_title": "Alle stillen Mitglieder anstupsen",
  "mh.bulk_desc": "Nur Mitglieder, die zuletzt inaktiv waren (max. 1× pro 24h).",
  "av.wd_mon": "Montag",
  "av.wd_tue": "Dienstag",
  "av.wd_wed": "Mittwoch",
  "av.wd_thu": "Donnerstag",
  "av.wd_fri": "Freitag",
  "av.wd_sat": "Samstag",
  "av.wd_sun": "Sonntag",
  "av.wds_mon": "Mo",
  "av.wds_tue": "Di",
  "av.wds_wed": "Mi",
  "av.wds_thu": "Do",
  "av.wds_fri": "Fr",
  "av.wds_sat": "Sa",
  "av.wds_sun": "So",
  "av.load_err": "Verfügbarkeit konnte nicht geladen werden.",
  "av.outlook_connected": "Outlook-Kalender verbunden.",
  "av.outlook_failed": "Outlook-Verbindung fehlgeschlagen.",
  "av.outlook_not_setup": "Outlook ist noch nicht eingerichtet.",
  "av.outlook_disconnected": "Outlook getrennt.",
  "av.saved": "Verfügbarkeit gespeichert.",
  "av.save_failed": "Speichern fehlgeschlagen.",
  "av.day_updated": "{day} aktualisiert.",
  "av.day_reset": "{day} zurückgesetzt.",
  "av.day_save_failed": "Tag konnte nicht gespeichert werden.",
  "av.seo": "Coach · Verfügbarkeit",
  "av.eyebrow": "Verfügbarkeit",
  "av.title": "Verfügbarkeit & Kalender",
  "av.subtitle": "Öffne wöchentliche Slots oder passe einzelne Tage über die nächsten Wochen an.",
  "av.outlook_cal": "Outlook-Kalender",
  "av.outlook_soon": "Wird vom Team eingerichtet — bald verfügbar.",
  "av.connected": "Verbunden",
  "av.reconnect_needed": " · erneut verbinden nötig",
  "av.outlook_hint": "Verbinde deinen Outlook-Kalender für Frei/Belegt-Abgleich.",
  "av.disconnect": "Trennen",
  "av.reconnect": "Erneut verbinden",
  "av.outlook_connect": "Outlook verbinden",
  "av.mode_uniform": "Einheitlich",
  "av.mode_individual": "Individuell",
  "av.timezone": "Zeitzone",
  "av.uniform_hint": "Wochenvorlage gilt für alle {weeks} Wochen — einzelne Tage unten überschreibbar.",
  "av.individual_hint": "Jeder Tag wird einzeln bearbeitet.",
  "av.week_template": "Wochenvorlage",
  "av.saving": "Speichern…",
  "av.save_template": "Vorlage speichern",
  "av.next_weeks": "Nächste {weeks} Wochen",
  "av.tap_hint": "· Tag antippen zum Anpassen",
  "av.view": "Ansicht",
  "av.month": "Monat",
  "av.weeks_short": "{w} Wo.",
  "av.custom": "Custom",
  "av.adjust_day": "{day} anpassen",
  "av.available": "Verfügbar",
  "av.reset": "Zurücksetzen",
  "av.save": "Speichern",
  "av.slot": "Slot",
  "ic.seo": "Coach · Inner Circle",
  "ic.subtitle": "Dein exklusives Monats-Abo — bündle Angebote aller Art zu einer festen Begleitung.",
  "ic.tab_settings": "Einstellungen",
  "ic.tab_overview": "Übersicht",
  "ic.tab_clients": "Klient:innen",
  "ic.tab_weva": "WEVA",
  "ic.tab_invites": "Einladungen",
  "ic.err_price": "Bitte einen Preis in € oder Credits festlegen.",
  "ic.err_min_eur": "Mindestpreis ist €4,99 / Monat.",
  "ic.err_min_credits": "Mindestpreis ist 50 Credits / Monat.",
  "ic.saved_published": "Inner Circle gespeichert & veröffentlicht.",
  "ic.saved_hidden": "Inner Circle gespeichert (verborgen).",
  "ic.setup_intro": "Lege einen Monatspreis fest und wähle, was deine Mitglieder jeden Monat bekommen.",
  "ic.enable_card": "Kartenzahlungen aktivieren",
  "ic.enable_card_desc": "Schließe beide Schritte ab, damit Klient:innen per Karte abonnieren können.",
  "ic.step1": "1 · Stripe-Auszahlungen verbinden",
  "ic.stripe_not_started": "Noch nicht gestartet — Stripe prüft Identität & Bankdaten für deine Auszahlungen.",
  "ic.stripe_submitted": "Eingereicht — Stripe prüft noch (meist <24h).",
  "ic.stripe_connected": "Verbunden — du kannst Auszahlungen erhalten.",
  "ic.stripe_incomplete": "Gestartet, aber unvollständig — KYC-Formular abschließen.",
  "ic.stripe_start": "Stripe-Onboarding starten",
  "ic.step2": "2 · €-Preis festlegen",
  "ic.price_set": "{price}/Monat gesetzt. Speichern zum Aktivieren.",
  "ic.price_enter": "Monatspreis unten eingeben (mind. €4,99/Monat).",
  "ic.card_active": "Kartenzahlungen aktiv",
  "ic.card_active_desc": "Klient:innen können per Karte (Stripe) oder Credits abonnieren. {price}/Monat · {share}% gehen an dich.",
  "ic.price_eur": "Monatspreis (€)",
  "ic.only_credits_hint": "Leer lassen, wenn du nur Credits akzeptieren möchtest.",
  "ic.price_credits": "Monatspreis (Credits)",
  "ic.price_credits_ph": "z. B. 50",
  "ic.credits_month": "Credits/Monat",
  "ic.credits_auto_hint": "Leer lassen, damit die Plattform den Credit-Preis automatisch ableitet.",
  "ic.revenue_split": "Plattform behält {platform}% · Du erhältst {coach}%",
  "ic.coach_pro_hint": " · Upgrade auf Coach Pro senkt auf 15%",
  "ic.description_label": "Beschreibung — was Abonnent:innen bekommen",
  "ic.description_ph": "Eine monatliche Verpflichtung zu deiner inneren Arbeit …",
  "ic.whats_included": "Was ist enthalten",
  "ic.core_hint": "Die ersten vier sind Kern-Leistungen (WEVA-Coaching) und werden empfohlen.",
  "ic.visibility": "Sichtbarkeit",
  "ic.visibility_hint": "Erscheint dein Inner Circle öffentlich in deinem Profil oder nur per Einladung?",
  "ic.vis_public": "Öffentlich sichtbar",
  "ic.vis_public_hint": "Erscheint in deinem Coach-Profil, jede:r kann abonnieren.",
  "ic.vis_invite": "Nur per Einladung",
  "ic.vis_invite_hint": "Nur eingeladene Klient:innen können beitreten.",
  "ic.waitlist": "{n} warten auf deinen Inner Circle",
  "ic.waitlist_hint": "Sie bekommen eine Benachrichtigung, sobald du „Veröffentlicht“ aktivierst.",
  "ic.dm_limit": "Hartes DM-Limit",
  "ic.dm_limit_hint": "An = Mitglieder können das monatliche DM-Kontingent nicht überschreiten.",
  "ic.save": "Inner Circle speichern",
  "ic.no_members": "Noch keine Inner-Circle-Mitglieder",
  "ic.no_members_hint": "Sobald jemand abonniert, erscheint er hier.",
  "ic.planned": "{n} geplant",
  "ic.past": "{n} vergangen",
  "ic.weva_err": "WEVA-Report konnte nicht geladen werden.",
  "ic.snapshot7": "Snapshot (7T)",
  "ic.days30": "30 Tage",
  "ic.history90": "Verlauf (90T)",
  "ic.members_one": "{n} Mitglied",
  "ic.members_other": "{n} Mitglieder",
  "ic.period": "Zeitraum: letzte {n} Tage",
  "ic.top_beliefs": "Häufigste Glaubenssätze",
  "ic.upper_limits": "Upper-Limit-Hotspots",
  "ic.not_enough": "Nicht genug Aktivität in diesem Zeitraum für einen Report.",
  "ic.min": "Min.",
  "ic.days": "Tage",
  "ic.err_email": "Bitte mindestens eine gültige E-Mail eingeben.",
  "ic.invites_created": "{n} Einladung(en) erstellt.",
  "ic.invites_err": "Einladungen konnten nicht gesendet werden.",
  "ic.invite_revoked": "Einladung zurückgezogen",
  "ic.emails_label": "E-Mail-Adressen",
  "ic.emails_hint": "Trenne mehrere Adressen mit Komma, Semikolon oder Zeilenumbruch.",
  "ic.note_label": "Persönliche Notiz (optional)",
  "ic.note_ph": "Willkommen im Inner Circle …",
  "ic.sending": "Senden…",
  "ic.kpi_sent": "Gesendet",
  "ic.kpi_accept_rate": "Annahme-Rate",
  "ic.kpi_accepted": "Angenommen",
  "ic.kpi_pending": "Ausstehend",
  "ic.kpi_revoked": "Zurückgezogen",
  "ic.kpi_avg_time": "Ø Beitrittszeit",
  "ic.kpi_active": "Aktive Mitglieder",
  "ic.kpi_retention": "30T-Retention",
  "ic.sec_pending": "Ausstehend",
  "ic.sec_pending_empty": "Noch keine ausstehenden Einladungen.",
  "ic.sec_accepted": "Angenommen",
  "ic.sec_accepted_empty": "Noch keine Annahmen.",
  "ic.sec_revoked": "Zurückgezogen",
  "ic.back": "Kreise",
  "ic.tile_deliverables": "Lieferungen",
  "ic.tile_todos": "To-dos",
  "ic.tile_clients": "Klient:innen",
  "ic.tile_chats": "Chats",
  "ic.tile_weva": "WEVA Analyse",
  "ic.tile_members": "Mitglieder-Health",
  "ic.save_err": "Speichern fehlgeschlagen.",
  "ic.stripe_onboard_err": "Stripe-Onboarding konnte nicht gestartet werden.",
  "ic.opening_stripe": "Öffne Stripe…",
  "ic.continue_onboarding": "Onboarding fortsetzen",
  "ic.ov_active_members": "Aktive Mitglieder",
  "ic.ov_earnings": "Einnahmen (Monat)",
  "ic.ov_snapshots": "Bestätigte Snapshots",
  "ic.ov_entries": "Einträge erhalten",
  "ic.ov_bookings": "Buchungen",
  "ic.ov_offerings": "Aktive Angebote",
  "ic.deliverables_title": "Enthaltene Lieferungen",
  "ic.no_deliverables": "Noch keine Lieferungen definiert.",
  "ic.per_month": "{n}× / Monat",
  "ic.areas": "Bereiche",
  "ic.published": "Veröffentlicht",
  "ic.published_hint": "Aus = gespeichert, aber für Klient:innen verborgen.",
  "ic.saving": "Speichern…",
  "ic.invite": "Einladen",
  "ic.month_suffix": "/Monat",
  "ic.overview_err": "Übersicht konnte nicht geladen werden.",

  // Coach · Kollaboration (Collab.jsx)
  "col.seo": "Coach · Kollaboration",
  "col.back": "Coach-Dashboard",
  "col.eyebrow": "Kollaboration",
  "col.title": "Kollaboration",
  "col.subtitle": "Vernetze dich mit anderen Coaches, chattet gemeinsam und gestaltet geteilte Angebote.",
  "col.open_title": "Offen für Kollaboration",
  "col.open_desc": "Andere Coaches sehen dich im Collab-Netzwerk und können dich anfragen.",
  "col.stat_connected": "Verbundene Coaches",
  "col.stat_in": "Eingehende Anfragen",
  "col.stat_out": "Ausgehende Anfragen",
  "col.stat_offerings": "Gemeinsame Angebote",
  "col.tab_connected": "Verbunden",
  "col.tab_requests": "Anfragen",
  "col.tab_find": "Finden",
  "col.tab_offerings": "Gemeinsame Angebote",
  "col.tab_circles": "Gemeinsame Kreise",
  "col.tab_chats": "Chats",
  "col.st_draft": "Entwurf",
  "col.st_pending": "Wartet auf Zusage",
  "col.st_published": "Veröffentlicht",
  "col.st_archived": "Archiviert",
  "col.kind_one_on_one": "1:1-Session",
  "col.kind_training": "Training",
  "col.kind_product": "Produkt",
  "col.bill_one_time": "Einmalig",
  "col.bill_monthly": "Monatlich",
  "col.bill_yearly": "Jährlich",
  "col.no_shared_clients_title": "Keine gemeinsamen Klient:innen",
  "col.no_shared_clients_desc": "Beide Coaches brauchen dieselbe Klient:in mit Collab-Freigabe.",
  "col.conn_empty_title": "Noch keine Verbindungen",
  "col.conn_empty_text": "Finde Coaches im Tab „Finden“ und sende eine Anfrage.",
  "col.circles_n": "{n} Kreise",
  "col.offers_n": "{n} Angebote",
  "col.message": "Nachricht",
  "col.shared_chat": "Geteilter Chat",
  "col.pick_client_title": "Welche:n Klient:in verbinden?",
  "col.pick_client_desc": "Nur Klient:innen, die beiden Coaches eine Collab-Freigabe erteilt haben.",
  "col.search_client_ph": "Klient:in suchen…",
  "col.req_accepted": "Anfrage angenommen.",
  "col.req_declined": "Anfrage abgelehnt.",
  "col.req_empty_title": "Keine offenen Anfragen",
  "col.req_empty_text": "Eingehende und gesendete Anfragen erscheinen hier.",
  "col.incoming_n": "Eingehend ({n})",
  "col.no_incoming": "Keine eingehenden Anfragen.",
  "col.outgoing_n": "Gesendet ({n})",
  "col.no_outgoing": "Keine gesendeten Anfragen.",
  "col.accept": "Annehmen",
  "col.decline": "Ablehnen",
  "col.pending": "Ausstehend",
  "col.request_sent": "Anfrage an {name} gesendet.",
  "col.request_failed": "Anfrage fehlgeschlagen.",
  "col.search_coach_ph": "Coach nach Name oder Fachgebiet suchen…",
  "col.no_coaches_title": "Keine Coaches gefunden",
  "col.no_coaches_text": "Versuche einen anderen Suchbegriff.",
  "col.request": "Anfragen",
  "col.request_to": "Anfrage an {name}",
  "col.topic_label": "Thema (optional)",
  "col.topic_ph": "z. B. Gemeinsames Retreat",
  "col.message_label": "Nachricht (optional)",
  "col.message_ph": "Stell dich kurz vor und beschreibe deine Idee…",
  "col.sending": "Senden…",
  "col.send_request": "Anfrage senden",
  "col.off_accepted": "Angebot angenommen.",
  "col.off_declined": "Angebot abgelehnt.",
  "col.off_published": "Angebot veröffentlicht.",
  "col.off_archived": "Angebot archiviert.",
  "col.new_offering": "Neues gemeinsames Angebot",
  "col.off_empty_title": "Noch keine gemeinsamen Angebote",
  "col.off_empty_text": "Erstelle mit verbundenen Coaches ein Paket — Einnahmen werden automatisch aufgeteilt.",
  "col.confirmed_of": "{confirmed}/{total} bestätigt",
  "col.bookings_suffix": " · {n} Buchungen",
  "col.needs_confirm": "Deine Zusage fehlt",
  "col.fully_booked": "Ausgebucht",
  "col.publish": "Veröffentlichen",
  "col.archive": "Archivieren",
  "col.block_title_ph": "Baustein-Titel",
  "col.pick_product_ph": "Produkt/Methode/Plan wählen…",
  "col.duration_min": "Dauer (Min.)",
  "col.price_eur": "Preis (EUR)",
  "col.days": "Tage",
  "col.day": "Tag",
  "col.max_participants": "Max. Teilnehmer (0 = unbegrenzt)",
  "col.executing_coaches": "Ausführende Coaches",
  "col.split_pct": "Aufteilung (%)",
  "col.split_executing": "Ausführende",
  "col.split_all": "Alle",
  "col.err_title_min": "Titel (min. 3 Zeichen).",
  "col.err_pick_coach": "Mindestens eine:n Coach auswählen.",
  "col.err_add_block": "Mindestens einen Baustein hinzufügen.",
  "col.err_block_title": "Baustein {n}: Titel fehlt.",
  "col.err_block_split": "Baustein {n}: Aufteilung muss 100 % ergeben (aktuell {sum} %).",
  "col.err_block_day": "Baustein {n}: mindestens ein Tag mit Datum/Zeit.",
  "col.err_block_product": "Baustein {n}: Produkt wählen.",
  "col.err_total_zero": "Gesamtpreis muss größer als 0 sein.",
  "col.err_override_high": "Paketpreis darf nicht höher als die Summe sein.",
  "col.offering_created": "Gemeinsames Angebot erstellt.",
  "col.create_failed": "Konnte nicht erstellt werden.",
  "col.you": "Du",
  "col.coach_fallback": "Coach",
  "col.dialog_new_offering_desc": "Ein Paket aus Bausteinen (Training, 1:1, Produkt). Einnahmen je Baustein werden nach eurer Aufteilung verbucht.",
  "col.f_title": "Titel",
  "col.offering_title_ph": "z. B. Breath & Body Retreat-Paket",
  "col.f_description": "Beschreibung",
  "col.coaches_connected": "Coaches (verbunden)",
  "col.no_connected_coaches": "Noch keine verbundenen Coaches. Verbinde dich zuerst im Tab „Finden“.",
  "col.blocks": "Bausteine",
  "col.add_block_hint": "Füge mindestens einen Baustein hinzu.",
  "col.sum_blocks": "Summe Bausteine",
  "col.override_price": "Paketpreis überschreiben (Rabatt)",
  "col.package_price_ph": "Paketpreis (EUR)",
  "col.create": "Erstellen",
  "col.offering_fallback": "Gemeinsames Angebot",
  "col.coaches": "Coaches",
  "col.circ_confirmed": "Kreis bestätigt.",
  "col.new_circle": "Neuer gemeinsamer Kreis",
  "col.circ_empty_title": "Noch keine gemeinsamen Kreise",
  "col.circ_empty_text": "Gründe mit verbundenen Coaches einen Co-Coaching-Kreis — Einnahmen werden geteilt.",
  "col.circ_pending": "Wartet auf Zusagen",
  "col.confirm": "Bestätigen",
  "col.err_name_min": "Name (min. 3 Zeichen).",
  "col.err_split_100": "Aufteilung muss 100 % ergeben (aktuell {sum} %).",
  "col.circle_created": "Gemeinsamer Kreis erstellt.",
  "col.dialog_new_circle_desc": "Ein Co-Coaching-Kreis mit geteilter Mitgliedschaft. Alle Coaches müssen zusagen, bevor er live geht.",
  "col.f_name": "Name",
  "col.circle_name_ph": "z. B. Breath & Mind Collective",
  "col.billing": "Abrechnung",
  "col.seats": "Plätze (optional)",
  "col.co_coaches_connected": "Co-Coaches (verbunden)",
  "col.rev_split": "Einnahmen-Aufteilung (%)",
  "col.sum_100": "Summe muss 100 % ergeben.",
  "col.filter_all": "Alle",
  "col.filter_coaches": "Coaches",
  "col.filter_with_client": "Mit Klient:in",
  "col.chat_offer": "Chat-Angebot",
  "col.chats_empty_title": "Noch keine Chats",
  "col.chats_empty_text": "Starte einen Chat über den Tab „Verbunden“.",
  "col.chat_fallback": "Chat",
  "col.badge_coach": "Coach",
  "col.badge_client": "Klient:in",
  "col.chatoffer_saved": "Chat-Angebot gespeichert.",
  "col.chatoffer_title": "Bezahltes Chat-Angebot",
  "col.chatoffer_desc": "Biete Klient:innen einen bezahlten Chat-Zugang zu dir an.",
  "col.chatoffer_active": "Chat-Angebot aktiv",
  "col.unlimited_msgs": "Unbegrenzte Nachrichten",
  "col.included_msgs": "Inkludierte Nachrichten",
  "col.phone_included": "Telefonat inklusive",
  "col.phone_minutes": "Telefon-Minuten",
  "col.extras": "Extras (Komma-getrennt)",
  "col.extras_ph": "z. B. Voice-Memos, PDF-Zusammenfassung",
  "col.save": "Speichern",
  "col.no_messages": "Noch keine Nachrichten. Schreib die erste 👋",
  "col.msg_deleted": "Nachricht gelöscht",
  "col.msg_input_ph": "Nachricht schreiben…",

  // UX Rework 3.0
  "rw3.dw_areas": "Bereiche",
  "rw3.dw_quick": "Schnellzugriff",
  "rw3.mem_on_free": "Du nutzt aktuell den kostenlosen Plan.",
  "rw3.mem_free_access": "Enthalten: Atmen, Journal & Deep Within sowie begrenzte WEVA-Reports.",
  "rw3.mem_credits_title": "Guthaben & Abrechnung",
  "rw3.mem_credits_note": "Einzelne Sessions und Reports zahlst du mit Guthaben — getrennt vom Abo.",
  "rw3.mem_credits_cta": "Zur Abrechnung",
  "rw3.mem_lifetime": "Du hast lebenslangen Zugang — kein Abo nötig.",
  "rw3.mem_coach_note": "Coach-Pläne enthalten alle persönlichen Vorteile plus Praxis-Tools.",
  "rw3.pl_confirm_multi": "Plan „{name}“ an {n} Klient:innen senden?",
  "rw3.pl_confirm_circle": "Plan „{name}“ an alle Mitglieder dieses Kreises senden?",
  "rw3.off_online": "Online",
  "rw3.off_inperson": "Vor Ort",
  "rw3.ic_this_month": "Diesen Monat",
  "rw3.ic_recurring_est": "geschätzt wiederkehrend / Monat",
  "ch.earn_title": "Einnahmen (Monat)",
  "ch.earn_view": "Details",
  "ch.earn_gross": "Brutto",
  "ch.earn_pending": "Ausstehend",
  "ch.earn_paid": "Ausgezahlt",
  "ch.earn_next": "Nächste Auszahlung",
  "ch.earn_period_note": "Aktueller Monat · Zeiträume & Details unter „Einnahmen“.",
  "ch.earn_vs_prev": "vs. Vormonat",
  "dw.progress_label": "{done} von {total} transformiert",
};

export default de;
